/* ============================================================
   EFX × DPO Customizations
   Hosted as theme asset to bypass DPO's Extra JavaScript size limit.
   Loaded from theme.liquid via <script src="//efx.co/cdn/shop/t/68/assets/efx-dpo-customizations.js?v=182601372870257181601784922915" defer></script>
   ============================================================ */

try { console.log('[EFX DPO] build 2026-07-24 · AA (font picker writes to the LIVE select — fixes duplicated-jersey font)'); } catch (e) { /* noop */ }

/* ============================================================
   EFX × DPO — PHASE 2.1: FABRIC SWATCH PICKER
   ============================================================
   Where to paste: DPO Admin → Templates → Extra JavaScript
                   (append below the existing jQuery code)
   What it does:   Replaces the Fabric Options dropdown with
                   a visual swatch grid. Writes the choice back
                   to the hidden <select> so DPO + cart + your
                   JSX automation all work identically.
   Safe:           Hides the original <select>, doesn't remove
                   it. If JS fails to load, customer still sees
                   a usable dropdown (graceful degradation).
   ============================================================ */

// ── EFX_LOGO_IMAGES — name → image URL ─────────────────────────
// Auto-generated from Randy's mapping. Asset-folder files use
// Liquid's asset_url filter; Shopify Files use raw cdn URLs.
// Note: file is .js.liquid, NOT .js, so Liquid filters resolve.
var EFX_LOGO_IMAGES = {
  "900G"                 : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_53888_master-branding-900g.jpg?v=164008398370374945881784915120",
  "900G - G"             : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_45819_900g-g.jpg?v=1765147754",
  "Brunswick"            : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_41779_master-branding-brunswick.jpg?v=171028895919897270941784915120",
  "Brunswick - Vintage B": "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_49901_master-brandingb.jpg?v=1735331389",
  "C300"                 : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_19133_master-branding-c300.jpg?v=103143140379723354431784915120",
  "DV8"                  : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_67570_master-branding-dv8.jpg?v=93705574577632377101784915120",
  "Ebonite"              : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_41144_master-branding-ebonite.jpg?v=160649963464773408761784915120",
  "Ebonite - Vintage"    : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_81623_master-brandingebonitevintage.jpg?v=1705000052",
  "EFX"                  : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_26003_master-branding-efx.jpg?v=122143988236470896351784915120",
  "Hammer"               : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_13244_master-branding-hammer.jpg?v=59403445709334426981784915120",
  "Hammer - Full"        : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_13449_master-brandinghammer-full.png?v=1704784228",
  "Motiv"                : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_43093_motiv.jpg?v=1779573787",
  "Motiv M"              : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_52600_master-branding-mmotiv.jpg?v=1702498109",
  "Radical"              : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_31447_master-branding-radical.jpg?v=144307049213239202791784915120",
  "Radical - R"          : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_35214_radical-r.png?v=1713805428",
  "Roto Grip - Original" : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_50492_master-branding-rgog.jpg?v=95453470488970870401784915120",
  "Roto Grip - Star Only": "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_52257_master-branding-rgstar.jpg?v=119011730597862541641784915120",
  "Storm - Original"     : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_46838_master-branding-stormog.jpg?v=131957371254489190851784915120",
  "Storm - Bolt"         : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_22124_master-branding-stormoval.jpg?v=136036453386202980201784915120",
  "Swag"                 : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_63046_swag.jpg?v=1779572014",
  "Track"                : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_58762_master-branding-track.jpg?v=18658130009051445841784915120",
  "Track - Flaming T"    : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_90998_master-brandingt.jpg?v=1735331414",
  "TVBS - Black"         : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_42117_tvbs-black.png?v=1773852711",
  "TVBS - Colored"       : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_13410_tvbs-colored.jpg?v=1773852509",
  "Turbo Tech"           : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_56085_turbo-tech.png?v=1773853225",
  "Turbo Tech - Neon"    : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_24710_turbo-tech-neon.png?v=1773852872",
  "Major Bowling"        : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_46590_major-bowling.png?v=1774635779",
  "TBBC - Original"      : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_93174_tbbc-original.jpg?v=1775769034",
  "TBBC - Peach"         : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_73433_tbbc-peach.jpg?v=1775769044",
  "3G"                   : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_85737_master-branding-3g.jpg?v=59293000680665520231784915120",
  "Bowler X"             : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_37128_bowler-x.png?v=1732050948",
  "CTD"                  : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_34048_ctd.jpg?v=1707929147",
  "Dexter"               : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_94470_dexter.png?v=1732051586",
  "EFX - Badge"          : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/EFX---Badge.png?v=1729260581",
  "Genesis"              : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_23414_master-branding-genesis.jpg?v=170339298011126349061784915120",
  "Jopo"                 : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_66058_jopo.jpg?v=1732051608",
  "Turbo"                : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_72942_turbo.jpg?v=1732051687",
  "Turbo - Neon"         : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_72942_turbo.jpg?v=1732051687",
  "Vise"                 : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_70109_master-branding-vise.jpg?v=59611554721427847841784915120",
  "PBA BowlTV"           : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_30886_master-branding-pba.jpg?v=107039818110802850581784915120",
  "PBA BowlTV - 50"      : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_77796_master-branding-pba50.png?v=1727804790",
  "PBA BowlTV - Jr"      : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_86054_master-branding-pba-jr.png?v=1727804755",
  "PWBA BowlTV"          : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_81959_master-brandingpwba.jpg?v=1704915353",
  "PBA BowlTV - Neon"    : "//efx.co/cdn/shop/t/68/assets/dpo_custom_option_30886_master-branding-pba.jpg?v=107039818110802850581784915120",
  "PBA BowlTV - 50 Neon" : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_77796_master-branding-pba50.png?v=1727804790",
  "PBA BowlTV - Jr Neon" : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_86054_master-branding-pba-jr.png?v=1727804755",
  "PWBA BowlTV - Neon"   : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_81959_master-brandingpwba.jpg?v=1704915353",
  "MJMA"                 : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_96539_mjma.jpg?v=1781813752",
  "Otter - Badge"        : "https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_13495_otter.jpg?v=1781813809",
};

/* ============================================================
   EFX × DPO — TEMPLATE TAG HELPER
   ============================================================
   theme.liquid exposes window.EFX_DPO_TAGS (an array of all
   Shopify tags on the current product). Use this helper to
   branch behavior on specific DPO template tags.
   Examples:
     if (efxHasTag('dpo-bowling-neon')) { ... }
     if (efxHasTag('dpo-bowling-main') || efxHasTag('dpo-pants')) { ... }
   ============================================================ */
window.efxHasTag = function (tag) {
  return Array.isArray(window.EFX_DPO_TAGS) &&
         window.EFX_DPO_TAGS.indexOf(tag) !== -1;
};

// ── DUPLICATE URLs (potential typos worth checking) ──
//   ['Bowler X', 'CTD'] → https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_37128_b...
//   ['Turbo', 'Turbo - Neon'] → https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_72942_t...
//   ['PBA BowlTV', 'PBA BowlTV - Neon'] → dpo_custom_option_30886_master-branding-pba.jpg
//   ['PBA BowlTV - 50', 'PBA BowlTV - 50 Neon'] → https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_77796_m...
//   ['PBA BowlTV - Jr', 'PBA BowlTV - Jr Neon'] → https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_86054_m...
//   ['PWBA BowlTV', 'PWBA BowlTV - Neon'] → https://cdn.shopify.com/s/files/1/0359/2319/8092/files/dpo_custom_option_81959_m...

(function () {
  'use strict';

  // The DPO option ID for Fabric Options.
  // Confirmed from the inspected HTML: <select name="options[1002]">
  var FABRIC_OPTION_ID = 1002;

  // ── Visual styling per fabric SKU code ────────────────────
  // DPO's option text contains a code in parens like (IN130).
  // Match against that to pick the swatch visual + spec line.
  // Edit / extend this map as you add new fabrics in DPO admin.
  var FABRIC_SWATCHES = {
  'IN130': { type: 'perf',  spec: 'Smooth Knit · 130 gsm' },
  'IN160': { type: 'perf',  spec: 'Smooth Knit · 160 gsm' },
  'ME135': { type: 'mesh',  spec: 'Breathable · 135 gsm' },
  'ME160': { type: 'mesh',  spec: 'Breathable · 160 gsm' },
  'AL130': { type: 'perf',  spec: '4-Way Stretch · 130 gsm' },
};

  // ── Find the fabric field ─────────────────────────────────
  function findFabricControl() {
    // Skip on pants/shorts/skorts — field 1002 is Pants Size there, not Fabric.
    if (window.efxHasTag &&
        (window.efxHasTag('dpo-general-pants') ||
         window.efxHasTag('dpo-general-shorts') ||
         window.efxHasTag('dpo-general-skorts'))) {
      return null;
    }
    var select = document.getElementById('select_' + FABRIC_OPTION_ID) ||
                 document.querySelector('select[name="options[' + FABRIC_OPTION_ID + ']"]');
    return select ? select.closest('.control') : null;
  }

  // ── Parse option text into clean parts ────────────────────
  function parseOption(opt) {
    var raw = (opt.text || '').trim();
    // Find the SKU code (e.g. IN130, ME160) inside parentheses
    var codeMatch = raw.match(/\(([A-Z]{2}\d{3})\)/);
    var code = codeMatch ? codeMatch[1] : null;
    var swatch = (code && FABRIC_SWATCHES[code]) || { type: 'std', spec: '' };

    // Clean display name: strip "+$5.00" suffix and the (CODE) suffix
    var name = raw
      .replace(/\s*\+\$[\d.]+\s*$/, '')
      .replace(/\s*\([A-Z]{2}\d{3}\)\s*$/, '')
      .trim();

    var price = parseFloat(opt.getAttribute('price') || '0') || 0;

    return {
      value: opt.value,
      name: name,
      raw: raw,
      code: code || '',
      type: swatch.type,
      spec: swatch.spec,
      price: price,
    };
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ── Build and inject the swatch grid ──────────────────────
  function buildPicker(control) {
    var select = control.querySelector('select');
    if (!select || control.dataset.efxFabric) return false;
    control.dataset.efxFabric = '1';

    var options = [].slice.call(select.options)
      .filter(function (o) { return o.value && !/please\s*select/i.test(o.text); })
      .map(parseOption);

    if (!options.length) return false;

    // Hide the original select (keep in DOM for form submission)
    select.style.display = 'none';

    // Build the grid HTML
    var grid = document.createElement('div');
    grid.className = 'efx-swatch-grid';
    grid.innerHTML = options.map(function (o) {
      return '' +
        '<div class="efx-swatch" data-value="' + escapeHtml(o.value) + '">' +
          '<div class="efx-swatch-tex efx-swatch-tex-' + o.type + '">' +
            (o.code ? '<span class="efx-swatch-tag">' + escapeHtml(o.code) + '</span>' : '') +
          '</div>' +
          '<div class="efx-swatch-meta">' +
            '<div class="efx-swatch-name">' + escapeHtml(o.name) + '</div>' +
            (o.spec ? '<div class="efx-swatch-spec">' + escapeHtml(o.spec) + '</div>' : '') +
            (o.price ? '<div class="efx-swatch-price">+$' + (o.price % 1 === 0 ? o.price.toFixed(0) : o.price.toFixed(2)) + '</div>' : '') +
          '</div>' +
        '</div>';
    }).join('');

    control.insertBefore(grid, select);

    // Wire up clicks → set select value + fire change
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-swatch');
      if (!card) return;
      grid.querySelectorAll('.efx-swatch').forEach(function (c) {
        c.classList.remove('selected');
      });
      card.classList.add('selected');
      select.value = card.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      // Some apps also listen for 'input'
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Mirror the LIVE <select> onto the swatches, not just once at build time.
    // The Team Order builder replays snapshots into this same control and blanks
    // it for a freshly added jersey; reflecting only at build left a stale
    // "selected" swatch, so the shopper saw a fabric chosen while the select was
    // actually empty — it never saved and they had to click it anyway.
    function syncFromSelect() {
      var live = control.querySelector('select') || select;
      var v = live.value;
      grid.querySelectorAll('.efx-swatch').forEach(function (c) {
        c.classList.toggle('selected', !!v && c.dataset.value === v);
      });
    }
    // Delegated: survives DPO swapping the <select> element out on a cascade.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT' && control.contains(e.target)) syncFromSelect();
    }, true);
    syncFromSelect();

    return true;
  }

  // ── Wait for DPO to render, then hook ─────────────────────
  function tryInit() {
    var control = findFabricControl();
    if (!control) return false;
    return buildPicker(control);
  }

  function start() {
    if (tryInit()) return;
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Safety: stop watching after 20s
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 2.2: PRODUCTION TIME FRAME CARDS
   ============================================================
   Where to paste: DPO Admin → Templates → Extra JavaScript
                   (append below the fabric picker)
   What it does:   Replaces the Production Time Frame radio
                   group with three full-width selectable cards.
                   Each card shows a clear name, the timeframe,
                   and the price impact.
   Safe:           Hides the radios + their labels, doesn't
                   remove them. Selection writes back via
                   input.checked = true + change event.
   ============================================================ */

(function () {
  'use strict';

  // Match patterns → friendly display labels.
  // Tested against the radio's label text (e.g.
  // "Expedite - 5 business days +$70.00").
  // Order matters: most specific match wins. "5 business days"
  // must come before "expedite" so Rush doesn't get caught by
  // the generic Express pattern.
  var TIME_MAPPING = [
    { match: /\b5\s*business\s*days/i,  label: 'Rush'     },
    { match: /expedite|express/i,     label: 'Express'  },
    { match: /standard/i,             label: 'Standard' },
  ];

  // ── Find the Production Time Frame field ──────────────────
  function findProductionControl() {
    // Match by label text — survives whatever DPO option ID
    // is used and works across product templates
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('label');
      if (label && /production\s*time/i.test(label.textContent || '')) {
        return fields[i].querySelector('.control') || fields[i];
      }
    }
    return null;
  }

  // ── Parse a radio + its label into structured data ────────
  function parseRadio(input) {
    // The label can be either a separate <label for="..."> or
    // a parent <label> containing the input. Try both.
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (!label) {
      label = input.closest('label');
    }
    var raw = '';
    if (label) {
      // Clone to strip out any input nodes inside before reading text
      var clone = label.cloneNode(true);
      clone.querySelectorAll('input').forEach(function (n) { n.remove(); });
      raw = (clone.textContent || '').trim();
    }

    // Days descriptor (e.g. "25 business days" or "10-17 business days")
    var daysMatch = raw.match(/(\d+(?:-\d+)?)\s*business\s*days/i);
    var days = daysMatch ? daysMatch[0] : '';

    // Override displayed days per preset to show the full range,
    // not just the max (Phase 12 ship-by estimator uses the same
    // ranges from CONFIG: standard 22–28, express 10–17, rush 5).
    // Order matters: check Rush (5 days) before Express, because
    // DPO labels both as "Expedite" — only the day count differs.
    if (/standard/i.test(raw))                   days = '22-28 business days';
    else if (/\b5\s*business\s*days/i.test(raw)) days = '5 business days';
    else if (/expedite|express/i.test(raw))      days = '10-17 business days';

    // Price modifier
    var priceMatch = raw.match(/\+\$([\d.]+)/);
    var price = priceMatch ? parseFloat(priceMatch[1]) : 0;

    // Friendly label
    var preset = TIME_MAPPING[TIME_MAPPING.length - 1]; // fallback Standard
    for (var i = 0; i < TIME_MAPPING.length; i++) {
      if (TIME_MAPPING[i].match.test(raw)) {
        preset = TIME_MAPPING[i];
        break;
      }
    }

    return {
      value: input.value,
      inputId: input.id,
      label: preset.label,
      days: days,
      price: price,
    };
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ── Build the visual card stack ───────────────────────────
  function buildPicker(control) {
    if (!control || control.dataset.efxTime) return false;

    var radios = control.querySelectorAll('input[type="radio"]');
    if (!radios.length) return false;
    control.dataset.efxTime = '1';

    var options = [].slice.call(radios).map(parseRadio);

    // Hide the original radios + their labels
    radios.forEach(function (r) {
      r.style.display = 'none';
      var lbl = document.querySelector('label[for="' + r.id + '"]');
      if (lbl) lbl.style.display = 'none';
      // Some DPO templates also wrap each radio in a <div> row
      var row = r.closest('.control > div');
      if (row && row !== control) row.style.display = 'none';
    });

    // Build the new card stack
    var stack = document.createElement('div');
    stack.className = 'efx-time-stack';
    stack.innerHTML = options.map(function (o) {
      var priceLabel = o.price ? '+$' + o.price.toFixed(0) : 'Included';
      var priceClass = o.price ? 'efx-time-price' : 'efx-time-price efx-time-price-included';
      return '' +
        '<div class="efx-time-card" data-input-id="' + escapeHtml(o.inputId) + '" role="button" tabindex="0">' +
          '<div class="efx-time-radio"><span class="efx-time-radio-dot"></span></div>' +
          '<div class="efx-time-info">' +
            '<div class="efx-time-label">' + escapeHtml(o.label) + '</div>' +
            (o.days ? '<div class="efx-time-days">' + escapeHtml(o.days) + '</div>' : '') +
          '</div>' +
          '<div class="' + priceClass + '">' + escapeHtml(priceLabel) + '</div>' +
        '</div>';
    }).join('');

    control.insertBefore(stack, control.firstChild);

    // ── Wire up clicks + keyboard ────────────────────────────
    function selectCard(card) {
      stack.querySelectorAll('.efx-time-card').forEach(function (c) {
        c.classList.remove('selected');
      });
      card.classList.add('selected');
      var input = document.getElementById(card.dataset.inputId);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('click',  { bubbles: true }));
      }
    }

    stack.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-time-card');
      if (card) selectCard(card);
    });

    stack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-time-card');
        if (card) {
          e.preventDefault();
          selectCard(card);
        }
      }
    });

    // Mirror the live inputs onto the cards (see the fabric picker for why a
    // build-time-only reflection left a blank jersey looking pre-filled).
    function syncFromInputs() {
      var checked = control.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      stack.querySelectorAll('.efx-time-card').forEach(function (c) {
        c.classList.toggle('selected', !!checked && c.dataset.inputId === checked.id);
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && control.contains(e.target)) syncFromInputs();
    }, true);
    syncFromInputs();

    return true;
  }

  // ── Wait for DPO to render, then hook ─────────────────────
  function tryInit() {
    var control = findProductionControl();
    if (!control) return false;
    return buildPicker(control);
  }

  function start() {
    if (tryInit()) return;
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 2.3: COLLAR STYLE PICKER (v3 — bugfix)
   ============================================================
   Where to paste: REPLACE the previous Phase 2.3 JS block
   What changed:   Removed broken inline onerror attribute that
                   was leaking text next to images. Error
                   fallback now attached via proper JS event
                   listener after the grid renders.
   ============================================================ */

(function () {
  'use strict';

  var COLLAR_OPTION_ID = 1003;
  var COLLAR_IMAGE_BASE = 'https://efx.co/cdn/shop/files/';

  var COLLAR_STYLES = {
    '1/4 zipper': {
      label: '1/4 Zipper',
      tag: 'Modern Sport',
      features: '5″ Zipper Front',
      image: 'Collars---Quarter-Zipper.jpg',
    },
    'button polo': {
      label: 'Button Polo',
      tag: 'Traditional',
      features: '3-Button Placket · Foldover',
      image: 'Collars---Button-Polo.jpg',
    },
    'crew neck': {
      label: 'Crew Neck',
      tag: 'Traditional Tee',
      features: 'Shirt Style · Soft Feel',
      image: 'Collars---Crew-Neck.jpg',
    },
    'half crew': {
      label: 'Half Crew',
      tag: 'Modern Tee',
      features: 'Tapered · Soft Feel',
      image: 'Collars---Half-Crew.jpg',
    },
    'polo zipper': {
      label: 'Polo Zipper',
      tag: 'Modern Polo',
      features: 'Zipper Placket · Foldover',
      image: 'Collars---Polo-Zipper.jpg',
    },
    'pro button': {
      label: 'Pro Button',
      tag: 'Henley',
      features: '3-Button · Tapered',
      image: 'Collars---Pro-Button.jpg',
    },
    'v neck': {
      label: 'V Neck',
      tag: 'Open',
      features: 'Non-Restrictive · Soft Feel',
      image: 'Collars---V-Neck.jpg',
    },
    // NEW: alias for Fairways/Bowling Polo products — same visual + spec as Button Polo
    'bowling polo': {
     label: 'Bowling Polo',
      tag: 'Traditional',
      features: '3-Button Placket · Foldover',
      image: 'Collars---Button-Polo.jpg',
    },
    'athletic crew': {
      label: 'Athletic Crew',
      tag: 'Modern Tee',
      features: 'Tapered · Soft Feel',
      image: 'Collars---Crew-Neck.jpg',
},
  };

  var FALLBACK_SVG =
    '<svg viewBox="0 0 60 60" fill="none" stroke="#111" stroke-width="2">' +
      '<path d="M5 20 Q12 15 20 22 Q30 30 40 22 Q48 15 55 20"/>' +
      '<path d="M5 20 L5 55"/><path d="M55 20 L55 55"/>' +
    '</svg>';

  function findCollarControl() {
    // Skip on pants/shorts/skorts — field 1003 is Pants Length there, not Collar.
    if (window.efxHasTag &&
        (window.efxHasTag('dpo-general-pants') ||
         window.efxHasTag('dpo-general-shorts') ||
         window.efxHasTag('dpo-general-skorts'))) {
      return null;
    }
    var select = document.getElementById('select_' + COLLAR_OPTION_ID) ||
                 document.querySelector('select[name="options[' + COLLAR_OPTION_ID + ']"]');
    return select ? select.closest('.control') : null;
  }

  function lookupStyle(name) {
    var key = (name || '').toLowerCase().trim();
    if (COLLAR_STYLES[key]) return COLLAR_STYLES[key];
    for (var k in COLLAR_STYLES) {
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) {
        return COLLAR_STYLES[k];
      }
    }
    return { label: name, tag: '', features: '', image: null };
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // Build clean image markup — NO inline onerror.
  function buildVisual(meta) {
    if (meta.image) {
      return '<img src="' + COLLAR_IMAGE_BASE + escapeHtml(meta.image) +
             '" alt="' + escapeHtml(meta.label) +
             '" loading="lazy">';
    }
    return FALLBACK_SVG;
  }

  function buildPicker(control) {
    var select = control.querySelector('select');
    if (!select || control.dataset.efxCollar) return false;
    control.dataset.efxCollar = '1';

    var options = [].slice.call(select.options)
      .filter(function (o) { return o.value && !/please\s*select/i.test(o.text); })
      .map(function (o) {
        var name = (o.text || '').trim();
        var meta = lookupStyle(name);
        var price = parseFloat(o.getAttribute('price') || '0') || 0;
        return {
          value: o.value,
          label: meta.label,
          tag: meta.tag,
          features: meta.features,
          image: meta.image,
          visual: buildVisual(meta),
          price: price,
        };
      });

    if (!options.length) return false;

    select.style.display = 'none';

    var grid = document.createElement('div');
    grid.className = 'efx-collar-grid';
    grid.innerHTML = options.map(function (o) {
      return '' +
        '<div class="efx-collar-card" data-value="' + escapeHtml(o.value) + '" role="button" tabindex="0">' +
          '<div class="efx-collar-svg">' + o.visual + '</div>' +
          '<div class="efx-collar-meta">' +
            '<div class="efx-collar-label">' + escapeHtml(o.label) + '</div>' +
            (o.tag ? '<div class="efx-collar-tag">' + escapeHtml(o.tag) + '</div>' : '') +
            (o.features ? '<div class="efx-collar-features">' + escapeHtml(o.features) + '</div>' : '') +
            (o.price ? '<div class="efx-collar-price">+$' + (o.price % 1 === 0 ? o.price.toFixed(0) : o.price.toFixed(2)) + '</div>' : '') +
          '</div>' +
        '</div>';
    }).join('');

    control.insertBefore(grid, select);

    // ─── Attach fallback error handlers via JS (clean) ──────
    grid.querySelectorAll('.efx-collar-svg img').forEach(function (img) {
      img.addEventListener('error', function () {
        var holder = img.parentNode;
        if (holder) holder.innerHTML = FALLBACK_SVG;
      });
    });

    function selectCard(card) {
      grid.querySelectorAll('.efx-collar-card').forEach(function (c) {
        c.classList.remove('selected');
      });
      card.classList.add('selected');
      select.value = card.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input',  { bubbles: true }));
    }

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-collar-card');
      if (card) selectCard(card);
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-collar-card');
        if (card) { e.preventDefault(); selectCard(card); }
      }
    });

    // Mirror the live <select> onto the cards (see the fabric picker for why a
    // build-time-only reflection left a blank jersey looking pre-filled).
    function syncFromSelect() {
      var live = control.querySelector('select') || select;
      var v = live.value;
      grid.querySelectorAll('.efx-collar-card').forEach(function (c) {
        c.classList.toggle('selected', !!v && c.dataset.value === v);
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT' && control.contains(e.target)) syncFromSelect();
    }, true);
    syncFromSelect();

    return true;
  }

  function tryInit() {
    var control = findCollarControl();
    if (!control) return false;
    return buildPicker(control);
  }

  function start() {
    if (tryInit()) return;
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 3.1: SIZING CHART TOOLTIP (v4)
   ============================================================
   Where to paste: REPLACE the v3 Phase 3.1 sizing tooltip JS
   What changed:   v3 required DPO's jQuery to inject the
                   sizing pill. Since that injection was
                   removed, this version creates the pill
                   itself if no existing one is found.
                   Pill inherits Phase 1 v2 styling and the
                   Phase 3.3 text override automatically.
   ============================================================ */

(function () {
  'use strict';

  var SIZE_TYPE_OPTION_ID = 1004;

  var SIZE_CHARTS = {
    men: {
      title: "Men's Shirt",
      columns: ['Size', 'Chest', 'Height'],
      rows: [
        ['XS',  '38',   '26.5'],
        ['S',   '41',   '27'],
        ['M',   '44',   '27.5'],
        ['L',   '47',   '28.5'],
        ['XL',  '50.5', '30'],
        ['2XL', '54',   '31.5'],
        ['3XL', '57.5', '33'],
        ['4XL', '61',   '34.5'],
        ['5XL', '64.5', '35.5'],
        ['6XL', '68',   '37'],
        ['7XL', '71.5', '38'],
        ['8XL', '75',   '40'],
      ],
    },
    women: {
      title: "Women's Shirt",
      columns: ['Size', 'Chest', 'Height', 'Waist', 'Hips'],
      rows: [
        ['WXS',  '36', '25',   '34.5', '36'],
        ['WS',   '38', '25.5', '36.5', '38'],
        ['WM',   '40', '26.5', '38.5', '40'],
        ['WL',   '42', '27',   '40.5', '42'],
        ['WXL',  '44', '28',   '42.5', '44'],
        ['W2XL', '46', '28',   '44.5', '46'],
        ['W3XL', '48', '29.5', '47',   '48'],
      ],
    },
    youth: {
      title: 'Youth Shirt',
      columns: ['Size', 'Chest', 'Height'],
      rows: [
        ['2T',  '24.5', '15'],
        ['3T',  '26.5', '16'],
        ['4T',  '28.5', '18'],
        ['YXS', '30.5', '19.5'],
        ['YS',  '33.5', '20.5'],
        ['YM',  '36.5', '21.5'],
        ['YL',  '39.5', '22.5'],
        ['YXL', '42.5', '23.5'],
      ],
    },
    // NEW — Men's Bottoms chart (pants/shorts/skorts). Numbers from the
    // public Sizing page; matches the main template's bottoms chain.
    bottoms: {
     title: "Men's Bottoms",
      columns: ['Size', 'Waist', 'Hips', 'Inseam'],
      rows: [
       ['XS',  '28-32', '34-38', ''],
       ['S',   '30-34', '36-40', ''],
       ['M',   '32-36', '38-42', ''],
       ['L',   '34-38', '40-44', ''],
       ['XL',  '36-40', '42-46', ''],
       ['2XL', '38-42', '44-48', ''],
       ['3XL', '40-44', '46-50', ''],
      ],
    },
    // Skorts use a different scale than men's pants/shorts.
    // Numbers from the public Sizing page (Height + Waist only).
    skorts: {
      title: 'Skort',
      columns: ['Size', 'Height', 'Waist'],
      rows: [
        ['XXS', '15.5', '14.5'],
        ['XS',  '16',   '15'],
        ['S',   '16.5', '15.5'],
        ['M',   '17',   '16'],
        ['L',   '17.5', '16.5'],
        ['XL',  '18',   '17'],
        ['2XL', '18.5', '17.5'],
        ['3XL', '19',   '18'],
      ],
    },
  };

  var TAB_ORDER = ['men', 'women', 'youth', 'bottoms', 'skorts'];
  var TAB_LABELS = {
    men: 'Men',
    women: 'Women',
    youth: 'Youth',
    bottoms: "Men's Bottoms",
    skorts: 'Skort',
  };

  var tooltipEl = null;
  var triggerEl = null;
  var isOpen = false;
  var activeTab = 'men';
  var hoverOpenTimer = null;
  var hoverCloseTimer = null;

  function hasHover() {
    return window.matchMedia('(hover: hover)').matches;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function getCheckedSizeTypes() {
  // Inventory products (Phase 17) set their own chart keys.
  if (window.__efxInventorySizeKeys) return window.__efxInventorySizeKeys;
  // Skorts: separate Height/Waist chart.
  if (window.efxHasTag && window.efxHasTag('dpo-general-skorts')) {
    return ['skorts'];
  }
  // Pants/Shorts: men's bottoms chart.
  if (window.efxHasTag &&
      (window.efxHasTag('dpo-general-pants') ||
       window.efxHasTag('dpo-general-shorts'))) {
    return ['bottoms'];
  }
  // Fairways / Athletic Tee: men only.
  if (window.efxHasTag &&
      (window.efxHasTag('dpo-bowling-fairways') ||
       window.efxHasTag('dpo-bowling-athletic-tee'))) {
    return ['men'];
  }
  // Match BOTH the multi-select checkbox name (options[1004][]) and the
  // single-select radio name (options[1004]) so this keeps working if DPO's
  // Size Type is switched from checkboxes to radios.
  var checkboxes = document.querySelectorAll(
    'input[name="options[' + SIZE_TYPE_OPTION_ID + '][]"]:checked, ' +
    'input[name="options[' + SIZE_TYPE_OPTION_ID + ']"]:checked'
  );
  var keys = [];
  checkboxes.forEach(function (cb) {
    var labelEl = document.querySelector('label[for="' + cb.id + '"]') ||
                  cb.closest('label') || cb.parentElement;
    var label = (labelEl ? labelEl.textContent : '').toLowerCase().trim();
    if (label.indexOf('youth') !== -1)      keys.push('youth');
    else if (label.indexOf('women') !== -1) keys.push('women');
    else if (label.indexOf('men') !== -1)   keys.push('men');
  });
  return keys;
}

  // ── Build the static structure ONCE ───────────────────────
  function buildTooltipContent() {
    var tabsHtml = TAB_ORDER.map(function (key) {
      return '<button class="efx-tooltip-tab" data-tab="' + key + '" type="button">' +
             escapeHtml(TAB_LABELS[key]) + '</button>';
    }).join('');

    var panelsHtml = TAB_ORDER.map(function (key) {
      var chart = SIZE_CHARTS[key];
      var headerCells = chart.columns.map(function (c) {
        return '<th>' + escapeHtml(c) + '</th>';
      }).join('');
      var bodyRows = chart.rows.map(function (row) {
        return '<tr>' + row.map(function (v) {
          return '<td>' + escapeHtml(v) + '</td>';
        }).join('') + '</tr>';
      }).join('');
      return '<div class="efx-tab-panel" data-panel="' + key + '">' +
        '<table class="efx-tooltip-table">' +
          '<thead><tr>' + headerCells + '</tr></thead>' +
          '<tbody>' + bodyRows + '</tbody>' +
        '</table>' +
      '</div>';
    }).join('');

    tooltipEl.innerHTML =
      '<div class="efx-tooltip-header">' +
        '<div class="efx-tooltip-title">Sizing Chart</div>' +
        '<button class="efx-tooltip-close" aria-label="Close" type="button">&times;</button>' +
      '</div>' +
      '<div class="efx-tooltip-tabs">' + tabsHtml + '</div>' +
      '<div class="efx-tooltip-body">' +
        '<div class="efx-tooltip-meta">All measurements in inches &middot; &plusmn;0.5&Prime; variance &mdash; made to order</div>' +
        panelsHtml +
      '</div>';
  }

  // ── Toggle visibility (no DOM destruction) ────────────────
  function updateVisibility() {
    var checked = getCheckedSizeTypes();
    var visibleTabs = checked.length > 0 ? checked : TAB_ORDER.slice();

    if (visibleTabs.indexOf(activeTab) === -1) {
      activeTab = visibleTabs[0];
    }

    // Tabs row — hide entire row if only one tab visible
    var tabsRow = tooltipEl.querySelector('.efx-tooltip-tabs');
    if (tabsRow) {
      tabsRow.style.display = visibleTabs.length > 1 ? '' : 'none';
    }

    // Individual tabs — show/hide + active class
    tooltipEl.querySelectorAll('.efx-tooltip-tab').forEach(function (t) {
      var key = t.dataset.tab;
      t.style.display = visibleTabs.indexOf(key) === -1 ? 'none' : '';
      t.classList.toggle('active', key === activeTab);
    });

    // Panels — show only active
    tooltipEl.querySelectorAll('.efx-tab-panel').forEach(function (p) {
      p.style.display = p.dataset.panel === activeTab ? '' : 'none';
    });

    // Title text reflects active tab
    var titleEl = tooltipEl.querySelector('.efx-tooltip-title');
    if (titleEl && SIZE_CHARTS[activeTab]) {
      titleEl.textContent = SIZE_CHARTS[activeTab].title + ' Sizing';
    }
  }

  function selectTab(key) {
    if (!key || key === activeTab) return;
    activeTab = key;
    updateVisibility();
    requestAnimationFrame(positionTooltip);
  }

  function buildTooltip() {
    if (tooltipEl) return tooltipEl;

    tooltipEl = document.createElement('div');
    tooltipEl.className = 'efx-tooltip efx-sizing-tooltip';
    tooltipEl.setAttribute('role', 'dialog');
    tooltipEl.setAttribute('aria-label', 'Sizing chart');
    document.body.appendChild(tooltipEl);

    tooltipEl.addEventListener('click', function (e) {
      e.stopPropagation();
      var closeBtn = e.target.closest('.efx-tooltip-close');
      if (closeBtn) { closeTooltip(); return; }
      var tabBtn = e.target.closest('.efx-tooltip-tab');
      if (tabBtn && tabBtn.dataset.tab) selectTab(tabBtn.dataset.tab);
    });

    // Mouse events only active on hover-capable devices
    tooltipEl.addEventListener('mouseenter', function () {
      if (!hasHover()) return;
      if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
    });
    tooltipEl.addEventListener('mouseleave', function () {
      if (!hasHover()) return;
      scheduleClose();
    });

    return tooltipEl;
  }

  function positionTooltip() {
    if (!tooltipEl || !triggerEl) return;

    var ttW = tooltipEl.offsetWidth;
    var ttH = tooltipEl.offsetHeight;
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var margin = 12;

    // Touch devices: center the tooltip in the viewport as a modal.
    // Desktop: anchor below/above the trigger like before.
    var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

    if (isTouch) {
      // Fixed positioning on mobile — no scroll offset needed since
      // position: fixed anchors to the viewport.
      var top  = Math.max(margin, (winH - ttH) / 2);
      var left = Math.max(margin, (winW - ttW) / 2);
      tooltipEl.style.top  = top + 'px';
      tooltipEl.style.left = left + 'px';
      return;
    }

    var rect = triggerEl.getBoundingClientRect();
    var dtop = rect.bottom + 8;
    var dleft = rect.left;

    if (dleft + ttW + margin > winW) dleft = winW - ttW - margin;
    if (dleft < margin) dleft = margin;

    if (dtop + ttH + margin > winH) {
      var aboveTop = rect.top - ttH - 8;
      dtop = aboveTop >= margin ? aboveTop : margin;
    }

    tooltipEl.style.top  = (dtop + window.scrollY) + 'px';
    tooltipEl.style.left = (dleft + window.scrollX) + 'px';
  }

  function openTooltip() {
    if (isOpen) return;
    buildTooltip();
    if (!tooltipEl.dataset.efxBuilt) {
      buildTooltipContent();
      tooltipEl.dataset.efxBuilt = '1';
    }
    updateVisibility();
    isOpen = true;
    tooltipEl.classList.add('open');
    document.body.classList.add('efx-tooltip-open');
    requestAnimationFrame(positionTooltip);
  }

  function closeTooltip() {
    if (!isOpen) return;
    isOpen = false;
    if (tooltipEl) tooltipEl.classList.remove('open');
    document.body.classList.remove('efx-tooltip-open');
  }

  function toggleTooltip() {
    if (isOpen) closeTooltip(); else openTooltip();
  }

  function scheduleClose() {
    if (hoverCloseTimer) clearTimeout(hoverCloseTimer);
    hoverCloseTimer = setTimeout(closeTooltip, 350);
  }

  function bindTrigger() {
  // Pick the field that hosts the sizing-chart link based on template.
  var fieldId = SIZE_TYPE_OPTION_ID;  // 1004 default
  if (window.efxHasTag &&
      (window.efxHasTag('dpo-general-pants') ||
       window.efxHasTag('dpo-general-shorts') ||
       window.efxHasTag('dpo-general-skorts'))) {
    fieldId = 1002;  // Pants Size on bottoms templates
  }
  var sizeTypeField = document.getElementById('dynamic_option_id_' + fieldId);
  if (!sizeTypeField) return false;

  var link = sizeTypeField.querySelector('label a');

    // No existing link — inject our own
    if (!link) {
      var label = sizeTypeField.querySelector('label');
      if (!label) return false;

      link = document.createElement('a');
      link.href = '#';
      link.setAttribute('role', 'button');
      link.textContent = 'Hover for sizing chart'; // CSS overrides this text
      label.appendChild(link);
    }

    if (link.dataset.efxSizingBound) return false;

    triggerEl = link;
    triggerEl.dataset.efxSizingBound = '1';

    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleTooltip();
    });

    link.addEventListener('mouseenter', function () {
      if (!hasHover()) return;
      if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
      if (!isOpen) hoverOpenTimer = setTimeout(openTooltip, 250);
    });

    link.addEventListener('mouseleave', function () {
      if (!hasHover()) return;
      if (hoverOpenTimer) { clearTimeout(hoverOpenTimer); hoverOpenTimer = null; }
      scheduleClose();
    });

    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (tooltipEl && tooltipEl.contains(e.target)) return;
      if (triggerEl && triggerEl.contains(e.target)) return;
      closeTooltip();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeTooltip();
    });

    window.addEventListener('scroll', function () {
      if (isOpen) positionTooltip();
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (isOpen) positionTooltip();
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches &&
          e.target.matches('input[name^="options[' + SIZE_TYPE_OPTION_ID + ']"]')) {
        if (isOpen) {
          updateVisibility();
          requestAnimationFrame(positionTooltip);
        }
      }
    });

    return true;
  }

  function start() {
    if (bindTrigger()) return;
    var observer = new MutationObserver(function () {
      if (bindTrigger()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  // Expose for Phase 17 (inventory products) — lets non-DPO triggers
  // open the same singleton tooltip without binding to a DPO label <a>.
  window.__efxOpenInventoryTooltip = function (anchor) {
    if (!anchor) return;
    triggerEl = anchor;
    openTooltip();
  };
  window.__efxCloseInventoryTooltip = closeTooltip;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 3.4: FABRIC HOVER INFO (v3)
   ============================================================
   Where to paste: REPLACE the v2 fabric-hover JS block
   What changed:   v2 assumed DPO's jQuery would inject the
                   fabric pill. Since that injection was
                   removed, this version creates the pill
                   itself if no existing one is found.
                   Pill inherits Phase 1 v2 styling
                   automatically.
   Requires:       Phase 3.4 CSS v2 block (unchanged)
   ============================================================ */

(function () {
  'use strict';

  var FABRIC_INFO = {
    'dri-efx': {
      name: 'DRI-EFX',
      tagline: 'Moisture-Wicking Lightweight Polyester',
      description: "Dri-EFX is an innovative light-weight polyester fabric designed to keep you dry longer, so you can comfortably work harder. Dri-EFX's unique microfiber structure wicks away sweat, dispersing it evenly across the surface of the garment, enabling it to dry quicker.",
      features: ['Moisture-Wicking', 'Microfiber Weave', 'Quick-Dry', 'Lightweight'],
    },
    'cool-efx': {
      name: 'COOL-EFX',
      tagline: 'Breathable Performance Polyester',
      description: "Cool-EFX is an innovative light-weight polyester fabric designed with tiny spaced holes creating a high-performance breathable garment. Like our Dri-EFX fabric, Cool-EFX wicks away sweat quickly, as it disperses evenly across the surface of the garment using these tiny spaced holes.",
      features: ['High Breathability', 'Perforated Weave', 'Moisture-Wicking', 'Quick-Dry'],
    },
  };

  var FAMILIES = ['dri-efx', 'cool-efx'];
  var FAMILY_LABELS = { 'dri-efx': 'Dri-EFX', 'cool-efx': 'Cool-EFX' };

  // State
  var tooltipEl = null;
  var pillEl = null;
  var currentAnchor = null;
  var activeFamily = 'dri-efx';
  var isOpen = false;
  var hoverOpenTimer = null;
  var hoverCloseTimer = null;

  function hasHover() {
    return window.matchMedia('(hover: hover)').matches;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function getFamilyFromCard(card) {
    var tag = card.querySelector('.efx-swatch-tag');
    var code = tag ? tag.textContent.trim().toUpperCase() : '';
    if (!code) {
      var nameEl = card.querySelector('.efx-swatch-name');
      code = nameEl ? nameEl.textContent.toUpperCase() : '';
    }
    if (code.indexOf('IN') === 0 || code.indexOf('DRI') !== -1) return 'dri-efx';
    if (code.indexOf('ME') === 0 || code.indexOf('COOL') !== -1) return 'cool-efx';
    return null;
  }

  // ── Build static structure ONCE ──────────────────────────
  function buildTooltipContent() {
    var tabsHtml = FAMILIES.map(function (key) {
      return '<button class="efx-fabric-tab" data-family="' + key + '" type="button">' +
             escapeHtml(FAMILY_LABELS[key]) + '</button>';
    }).join('');

    var panelsHtml = FAMILIES.map(function (key) {
      var info = FABRIC_INFO[key];
      return '<div class="efx-fabric-panel" data-panel="' + key + '">' +
        '<div class="efx-fabric-info-header">' +
          '<div class="efx-fabric-info-name">' + escapeHtml(info.name) + '</div>' +
          '<div class="efx-fabric-info-tagline">' + escapeHtml(info.tagline) + '</div>' +
        '</div>' +
        '<div class="efx-fabric-info-body">' +
          '<div class="efx-fabric-info-desc">' + escapeHtml(info.description) + '</div>' +
          '<div class="efx-fabric-info-features">' +
            info.features.map(function (f) {
              return '<div class="efx-fabric-info-feature">' + escapeHtml(f) + '</div>';
            }).join('') +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    tooltipEl.innerHTML =
      '<div class="efx-fabric-tabs">' + tabsHtml + '</div>' +
      '<div class="efx-fabric-body">' + panelsHtml + '</div>';
  }

  function updateVisibility() {
    tooltipEl.querySelectorAll('.efx-fabric-tab').forEach(function (t) {
      t.classList.toggle('active', t.dataset.family === activeFamily);
    });
    tooltipEl.querySelectorAll('.efx-fabric-panel').forEach(function (p) {
      p.style.display = p.dataset.panel === activeFamily ? '' : 'none';
    });
  }

  function selectFamily(key) {
    if (!key || key === activeFamily) return;
    activeFamily = key;
    updateVisibility();
    if (currentAnchor) {
      requestAnimationFrame(function () { positionTooltip(currentAnchor); });
    }
  }

  function buildTooltip() {
    if (tooltipEl) return tooltipEl;

    tooltipEl = document.createElement('div');
    tooltipEl.className = 'efx-tooltip efx-fabric-info-tooltip';
    tooltipEl.setAttribute('role', 'dialog');
    tooltipEl.setAttribute('aria-label', 'Fabric info');
    document.body.appendChild(tooltipEl);

    tooltipEl.addEventListener('click', function (e) {
      e.stopPropagation();
      var tab = e.target.closest('.efx-fabric-tab');
      if (tab && tab.dataset.family) {
        selectFamily(tab.dataset.family);
      }
    });

    tooltipEl.addEventListener('mouseenter', function () {
      if (!hasHover()) return;
      if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
    });
    tooltipEl.addEventListener('mouseleave', function () {
      if (!hasHover()) return;
      scheduleClose();
    });

    return tooltipEl;
  }

  function openAt(anchor) {
    if (!anchor) return;
    buildTooltip();
    if (!tooltipEl.dataset.efxBuilt) {
      buildTooltipContent();
      tooltipEl.dataset.efxBuilt = '1';
    }
    updateVisibility();
    currentAnchor = anchor;
    isOpen = true;
    tooltipEl.classList.add('open');
    requestAnimationFrame(function () { positionTooltip(anchor); });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    if (tooltipEl) tooltipEl.classList.remove('open');
  }

  function scheduleClose() {
    if (hoverCloseTimer) clearTimeout(hoverCloseTimer);
    hoverCloseTimer = setTimeout(close, 300);
  }

  function showForCard(card) {
    var family = getFamilyFromCard(card);
    if (!family) return;
    activeFamily = family;
    openAt(card);
  }

  function showForPill() {
    if (!pillEl) return;
    openAt(pillEl);
  }

  function positionTooltip(anchor) {
    if (!tooltipEl || !anchor) return;

    var rect = anchor.getBoundingClientRect();
    var ttW = tooltipEl.offsetWidth;
    var ttH = tooltipEl.offsetHeight;
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var margin = 12;

    // Default: below the anchor, centered horizontally
    var top = rect.bottom + 8;
    var left = rect.left + (rect.width - ttW) / 2;

    if (left + ttW + margin > winW) left = winW - ttW - margin;
    if (left < margin) left = margin;

    if (top + ttH + margin > winH) {
      var aboveTop = rect.top - ttH - 8;
      top = aboveTop >= margin ? aboveTop : margin;
    }

    tooltipEl.style.top = (top + window.scrollY) + 'px';
    tooltipEl.style.left = (left + window.scrollX) + 'px';
  }

  // ── Bind hover handlers to each fabric card ──────────────
  function bindCards() {
    // Card hover DISABLED (2026-07-15): opening the fabric info while hovering a
    // swatch card was too aggressive. The info now opens ONLY from the
    // "Hover for info" pill (see bindPill). Returning true stops the init retry.
    return true;
  }

  // ── Bind hover+click to the "Hover for Info" pill ────────
  //    If no pill exists in the Fabric label yet, create one.
  function bindPill() {
    // Skip on pants/shorts/skorts — field 1002 is Pants Size there, not Fabric.
    if (window.efxHasTag &&
        (window.efxHasTag('dpo-general-pants') ||
         window.efxHasTag('dpo-general-shorts') ||
         window.efxHasTag('dpo-general-skorts'))) {
      return false;
    }
    var pill = document.querySelector('.fabric > .field > label > a') ||
               document.querySelector('[id^="dynamic_option_id_1002"] > label > a');
    // No existing pill — inject one
    if (!pill) {
      var label = document.querySelector('.fabric > .field > label') ||
                  document.querySelector('[id^="dynamic_option_id_1002"] > label');
      if (!label) return false;

      pill = document.createElement('a');
      pill.href = '#';
      pill.setAttribute('role', 'button');
      pill.textContent = 'Hover for info'; // CSS overrides this text
      label.appendChild(pill);
    }

    if (pill.dataset.efxFabricPillBound) return true;
    pill.dataset.efxFabricPillBound = '1';
    pillEl = pill;

    pill.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen && currentAnchor === pillEl) {
        close();
      } else {
        showForPill();
      }
    });

    pill.addEventListener('mouseenter', function () {
      if (!hasHover()) return;
      if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
      if (hoverOpenTimer) clearTimeout(hoverOpenTimer);
      if (!isOpen) {
        hoverOpenTimer = setTimeout(showForPill, 250);
      }
    });

    pill.addEventListener('mouseleave', function () {
      if (!hasHover()) return;
      if (hoverOpenTimer) { clearTimeout(hoverOpenTimer); hoverOpenTimer = null; }
      scheduleClose();
    });

    return true;
  }

  // ── Outside-click + Escape close ─────────────────────────
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (tooltipEl && tooltipEl.contains(e.target)) return;
    if (currentAnchor && currentAnchor.contains && currentAnchor.contains(e.target)) return;
    close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  window.addEventListener('scroll', function () {
    if (isOpen && currentAnchor) positionTooltip(currentAnchor);
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (isOpen && currentAnchor) positionTooltip(currentAnchor);
  });

  function start() {
    bindCards();
    bindPill();
    var observer = new MutationObserver(function () {
      bindCards();
      bindPill();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 3.5: SIZE PILL PICKERS (v3)
   ============================================================
   Where to paste: REPLACE the v2 Phase 3.5 size-pills JS
   What changed:   1. Now also pillifies any dropdown whose
                      options match the "Extend N\"" pattern
                      (e.g. the conditional "Additional Shirt
                      Length" dropdown that appears after
                      selecting Yes).
                   2. Abbreviates "Extend 1\"" → "1\"" so the
                      pills stay uniformly short.
                   3. Tags pillified fields with class
                      .efx-conditional-child so the size-group
                      CSS can kill the underline on those labels
                      without us knowing their option IDs.
   Requires:       Phase 3.5 CSS v2 (no CSS changes)
                   Phase 3.2 size-group CSS v4
   ============================================================ */

(function () {
  'use strict';

// Main template: 1005 (Men), 1006 (Women), 1007 (Youth)
// Fairways template: 1004 (Men, implicit), 1006 (Additional Shirt Length)
// Adding 1004 picks up Fairways Men Sizes. 1007 is now Right Chest on
// Fairways (not a size), but Phase 3.5's parseOption strips brand names
// like "900G" cleanly anyway — and Phase 16 will hide/replace 1007's UI
// before Phase 3.5 can hijack it. Safer to scope explicitly.
// Known size dropdowns by ID, scoped per template tag.
var KNOWN_SIZE_IDS = (function () {
  if (window.efxHasTag) {
    if (window.efxHasTag('dpo-bowling-fairways'))     return [1004];
    if (window.efxHasTag('dpo-bowling-athletic-tee')) return [1004];
  }
  return [1005, 1006, 1007]; // Main / Neon default
})();

  // Verbose names → short codes
  var ABBREVIATIONS = {
    'extra small': 'XS',
    'small': 'S',
    'medium': 'M',
    'large': 'L',
    'extra large': 'XL',
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // True if every non-placeholder option matches "Extend N" or "Extend N inches"
  function isExtendDropdown(select) {
    var options = [].slice.call(select.options).filter(function (o) {
      return o.value && !/please\s*select/i.test(o.text);
    });
    if (options.length === 0) return false;
    return options.every(function (o) {
      return /^extend\s+\d+\s*("|inch|inches?)?\s*(\+\$[\d.]+)?$/i.test((o.text || '').trim());
    });
  }

  function shouldPillify(field) {
    if (!field) return false;
    // On pants/shorts/skorts, the Pants Size + Pants Length fields belong
    // to Phase 6 (custom dropdowns), not Phase 3.5 pills.
    if (window.efxHasTag &&
        (window.efxHasTag('dpo-general-pants') ||
         window.efxHasTag('dpo-general-shorts') ||
         window.efxHasTag('dpo-general-skorts'))) {
      return false;
    }
    var idMatch = field.id.match(/(\d+)$/);
    if (idMatch && KNOWN_SIZE_IDS.indexOf(parseInt(idMatch[1], 10)) !== -1) {
      return true;
    }
    // Label-based detection: DPO's field IDs are not stable (the 2026-07 Size
    // Type restructure changed them), so also pillify any "Men/Women/Youth
    // Sizes" dropdown by its label. Keeps the abbreviations (S/M/L…) working
    // regardless of ID. Anchored so "men" can't match inside "women".
    var lbl = field.querySelector('label');
    var labelText = lbl ? (lbl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (/^(?:men|women|youth)\s+sizes?\b/i.test(labelText) &&
        field.querySelector('.control select')) {
      return true;
    }
    var select = field.querySelector('.control select');
    return !!(select && isExtendDropdown(select));
  }

  function parseOption(opt) {
    var raw = (opt.text || '').trim();
    var code = raw
      .replace(/^(?:Men's?|Women's?|Youth)\s+/i, '')
      .replace(/\s*\+\$[\d.]+\s*$/, '')
      .trim();

    // Verbose names → short codes
    var lower = code.toLowerCase();
    if (ABBREVIATIONS[lower]) {
      code = ABBREVIATIONS[lower];
    }

    // "Extend 1\"" → "1\""
    var extendMatch = code.match(/^extend\s+(\d+)\s*("|inch|inches?)?$/i);
    if (extendMatch) {
      code = extendMatch[1] + '"';
    }

    var price = parseFloat(opt.getAttribute('price') || '0') || 0;
    return { value: opt.value, code: code, price: price };
  }

  function buildPicker(control) {
    var select = control.querySelector('select');
    if (!select || control.dataset.efxSizePills) return false;
    control.dataset.efxSizePills = '1';

    var options = [].slice.call(select.options)
      .filter(function (o) { return o.value && !/please\s*select/i.test(o.text); })
      .map(parseOption);

    if (!options.length) return false;

    select.style.display = 'none';

    var grid = document.createElement('div');
    grid.className = 'efx-size-pills';
    grid.setAttribute('role', 'radiogroup');

    grid.innerHTML = options.map(function (o) {
      return '<button class="efx-size-pill" type="button" role="radio" aria-checked="false" data-value="' +
             escapeHtml(o.value) + '">' +
        '<span class="efx-size-pill-code">' + escapeHtml(o.code) + '</span>' +
        (o.price ? '<span class="efx-size-pill-price">+$' + o.price.toFixed(0) + '</span>' : '') +
      '</button>';
    }).join('');

    control.insertBefore(grid, select);

    // Tag the parent field so CSS can kill its label underline
    var field = control.closest('[id^="dynamic_option_id_"]');
    if (field) field.classList.add('efx-conditional-child');

    // Re-resolve the LIVE <select> from its field on every use. DPO REPLACES a
    // size field's <select> element when a restored row (Team Order jersey 2+)
    // cascades; the captured closure select then becomes a detached, stale node,
    // so clicks wrote to nothing and the pick "didn't register" / didn't
    // highlight. Keying off the persistent field id survives the swap.
    var fieldId = field ? field.id : null;
    function liveSelect() {
      var f = fieldId ? document.getElementById(fieldId) : null;
      var s = f ? f.querySelector('select') : null;
      return s || select;
    }

    // The size the shopper intends. Updated whenever a real value lands (a pill
    // click OR a restore). If DPO later BLANKS the select on a cascade — e.g.
    // changing Collar on jersey 2+, which was wiping the size from the header
    // and causing a size error at add — we put the pick back. Guards keep it
    // from bleeding one jersey's size into another:
    //   • suppressed while the Team Order builder is mid-restore
    //     (window.__efxTORestoring): during a replay DPO/the builder set the
    //     size, and re-asserting a stale value there is exactly cross-row bleed;
    //   • `reasserting` prevents recursion from our own change dispatch.
    var committed = liveSelect().value || null;
    var reasserting = false;

    function optionExists(sel, v) {
      for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === v) return true;
      return false;
    }

    function selectPill(pill) {
      var sel = liveSelect();
      grid.querySelectorAll('.efx-size-pill').forEach(function (p) {
        p.classList.remove('selected');
        p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('selected');
      pill.setAttribute('aria-checked', 'true');
      committed = pill.dataset.value;
      stampSize(committed);
      sel.value = committed;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input',  { bubbles: true }));
    }

    grid.addEventListener('click', function (e) {
      var pill = e.target.closest('.efx-size-pill');
      if (pill) selectPill(pill);
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var pill = e.target.closest('.efx-size-pill');
        if (pill) { e.preventDefault(); selectPill(pill); }
      }
    });

    function syncFromSelect() {
      var sel = liveSelect();
      grid.querySelectorAll('.efx-size-pill').forEach(function (p) {
        var on = p.dataset.value === sel.value;
        p.classList.toggle('selected', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    // Stamp the committed size on the FIELD so the Team Order builder can read
    // it right before it snapshots a row — DPO can silently blank the <select>
    // at save/park time, which lost the size from the header and errored at add.
    // Only the ACTIVE (non-.ihidden) size type keeps a stamp, so an inactive
    // type's leftover pick can never leak into another jersey's snapshot.
    function fieldNode() { return fieldId ? document.getElementById(fieldId) : null; }
    function isActive() { var f = fieldNode(); return !!(f && !f.classList.contains('ihidden')); }
    function stampSize(v) {
      var f = fieldNode();
      if (!f) return;
      if (v) f.setAttribute('data-efx-size', v);
      else f.removeAttribute('data-efx-size');
    }

    // React to any change on this size field (delegated on the persistent id, so
    // it survives DPO swapping the <select>): keep `committed` current, and if
    // DPO blanked the select while we hold a committed pick, restore it.
    function onFieldChange() {
      if (reasserting) return;
      var sel = liveSelect();
      if (!isActive()) {
        // No longer the active size type — forget the pick so it can't leak.
        committed = null;
        stampSize(null);
        syncFromSelect();
        return;
      }
      if (sel.value) {
        committed = sel.value; // a real value landed (pick or restore) — remember it
        stampSize(committed);
      } else if (committed && !window.__efxTORestoring && optionExists(sel, committed)) {
        reasserting = true;
        sel.value = committed;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sel.dispatchEvent(new Event('input',  { bubbles: true }));
        reasserting = false;
      }
      syncFromSelect();
    }

    if (fieldId) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('#' + fieldId)) onFieldChange();
      }, true);
      document.addEventListener('input', function (e) {
        if (e.target && e.target.closest && e.target.closest('#' + fieldId)) onFieldChange();
      }, true);
    } else {
      select.addEventListener('change', onFieldChange);
      select.addEventListener('input', onFieldChange);
    }

    syncFromSelect(); // initial highlight

    return true;
  }

  function tryInit() {
    var any = false;
    document.querySelectorAll('[id^="dynamic_option_id_"]').forEach(function (field) {
      if (!shouldPillify(field)) return;
      var control = field.querySelector('.control');
      if (control && buildPicker(control)) any = true;
    });
    return any;
  }

  function start() {
    tryInit();
    var observer = new MutationObserver(function () {
      tryInit();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 3.6: LOGO POSITION SLIDERS (v4)
   Fixes vs v3:
   - drag handler only scrolls past a 6px threshold (the
     "clicks don't register" root cause)
   - mousedown-card fallback in the click handler
   - rule sync: mirrors DPO option removals into cards
   - checkmark is a real <span>, not ::after
   ============================================================ */
(function () {
  'use strict';
  try { runEfxLogoSlider(); }
  catch (err) { console.error('[EFX Logo Slider] Init failed:', err); }

  function runEfxLogoSlider() {
    var LOGO_LABEL_PATTERNS = [
      /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
      /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i,
    ];

    function isLogoField(field) {
      var label = field.querySelector('label');
      if (!label) return false;
      return LOGO_LABEL_PATTERNS.some(function (p) {
        return p.test((label.textContent || '').trim());
      });
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    function stripDisplayName(raw) {
      return String(raw || '')
        .replace(/\s*\+\$[\d.]+\s*$/, '').trim()
        .replace(/\s*[\[\{][^\]\}]*[\]\}]\s*$/, '').trim()   // hide internal [TAG]/{TAG}s like {HEM}
        .replace(/\s*\([^)]*\)\s*$/, '').trim();
    }

    function extractImagesFromField(field) {
      var images = {};
      if (typeof EFX_LOGO_IMAGES !== 'object' || !EFX_LOGO_IMAGES) return images;
      function norm(s) { return String(s||'').toLowerCase().replace(/[\s\-_]+/g, ''); }
      var byNorm = {};
      for (var key in EFX_LOGO_IMAGES) {
        if (Object.prototype.hasOwnProperty.call(EFX_LOGO_IMAGES, key)) {
          byNorm[norm(key)] = EFX_LOGO_IMAGES[key];
        }
      }
      var select = field.querySelector('select');
      if (!select) return images;
      for (var i = 0; i < select.options.length; i++) {
        var raw = (select.options[i].text || '').trim();
        var url = byNorm[norm(stripDisplayName(raw))];
        if (url) images[raw.toLowerCase()] = url;
      }
      return images;
    }

    function optimizeShopifyImage(url, size) {
      if (!url) return url;
      if (!/(?:cdn\.shopify\.com|\/cdn\/shop\/)/.test(url)) return url;
      var m = url.match(/^(.+?)(\.[a-z]+)(\?.*)?$/i);
      return m ? m[1] + '_' + size + 'x' + size + m[2] + (m[3] || '') : url;
    }

    function parseOption(opt, imagesByLabel) {
      var raw = (opt.text || '').trim();
      var image = imagesByLabel[raw.toLowerCase()] || null;
      if (image) image = optimizeShopifyImage(image, 120);
      var name = stripDisplayName(raw);
      return {
        value: opt.value, name: name, image: image,
        price: parseFloat(opt.getAttribute('price') || '0') || 0,
        isNone: !opt.value || /^--/.test(raw) || /^none$/i.test(name)
      };
    }

    var NONE_SVG    = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="5" y1="19" x2="19" y2="5"/></svg>';
    var ARROW_LEFT  = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    var ARROW_RIGHT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    function buildCardHtml(o) {
      var classes = ['efx-logo-card'];
      if (o.isNone) classes.push('is-none');
      if (!o.image && !o.isNone) classes.push('no-image');

      var imageBlock = '';
      if (o.image) {
        imageBlock = '<div class="efx-logo-card-image-wrap"><img class="efx-logo-card-image" src="' +
                     escapeHtml(o.image) + '" alt="' + escapeHtml(o.name) + '" loading="lazy"/></div>';
      } else if (o.isNone) {
        imageBlock = '<div class="efx-logo-card-image-wrap"><div class="efx-logo-card-image-none">' +
                     NONE_SVG + '</div></div>';
      }

      return '<button class="' + classes.join(' ') +
             '" type="button" role="radio" aria-checked="false" data-value="' +
             escapeHtml(o.value) + '">' +
        '<span class="efx-logo-card-check" aria-hidden="true">\u2713</span>' +
        imageBlock +
        '<div class="efx-logo-card-name">' + escapeHtml(o.name) + '</div>' +
      '</button>';
    }

    function hideDpoUI(control) {
  control.classList.add('efx-has-logo-slider');   // ← add this line
  // rest of function unchanged
  var kids = control.children;
  for (var i = 0; i < kids.length; i++) {
    var el = kids[i];
    if (el.tagName === 'SELECT') continue;
    if (el.classList && el.classList.contains('efx-logo-slider')) continue;
    el.style.display = 'none';
  }
  // Also kill anything DPO/search/product-custom-option-classed nested deeper
  var nested = control.querySelectorAll(
    '[class*="dpo_"], [class*="dpo-"], [class*="search"], [class*="product-custom-option"]'
  );
  for (var j = 0; j < nested.length; j++) {
    if (nested[j].closest('.efx-logo-slider')) continue;
    nested[j].style.display = 'none';
  }
}

    function buildSlider(control, field) {
      var select = control.querySelector('select');
      if (!select || control.dataset.efxLogoSlider) return false;
      control.dataset.efxLogoSlider = '1';

      var imagesByLabel = extractImagesFromField(field);
      var options = [].slice.call(select.options).map(function (o) {
        return parseOption(o, imagesByLabel);
      });
      if (!options.length) return false;

      select.style.display = 'none';
      hideDpoUI(control);

      var slider = document.createElement('div');
      slider.className = 'efx-logo-slider';

      var track = document.createElement('div');
      track.className = 'efx-logo-track';
      track.innerHTML = options.map(buildCardHtml).join('');

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'efx-logo-nav efx-logo-nav-prev';
      prevBtn.setAttribute('aria-label', 'Scroll left');
      prevBtn.innerHTML = ARROW_LEFT;

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'efx-logo-nav efx-logo-nav-next';
      nextBtn.setAttribute('aria-label', 'Scroll right');
      nextBtn.innerHTML = ARROW_RIGHT;

      var progress = document.createElement('div');
      progress.className = 'efx-logo-progress';
      var thumb = document.createElement('div');
      thumb.className = 'efx-logo-progress-thumb';
      progress.appendChild(thumb);

      slider.appendChild(track);
      slider.appendChild(prevBtn);
      slider.appendChild(nextBtn);
      slider.appendChild(progress);

      control.insertBefore(slider, select);

      function selectCard(card) {
        if (!card || card.classList.contains('efx-rule-hidden')) return;
        if (card.classList.contains('efx-option-removed')) return;
        track.querySelectorAll('.efx-logo-card').forEach(function (c) {
          c.classList.remove('selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('selected');
        card.setAttribute('aria-checked', 'true');
        select.value = card.dataset.value;
        // Mark the parent field as user-touched. Only reached via real
        // user card clicks (programmatic .trigger('change') skips this).
        field.dataset.efxUserTouched = '1';
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.dispatchEvent(new Event('input',  { bubbles: true }));
        if (window.jQuery) {
          window.jQuery(select).trigger('change');
        }
      }

      // ── Instant activation + wheel scrolling (v5) ─────────────
function activateCard(card) {
  if (!card || card.classList.contains('efx-rule-hidden')) return;
  // Toggle: tapping the currently-selected logo deselects to None
  if (card.classList.contains('selected') && !card.classList.contains('is-none')) {
    var noneCard = track.querySelector('.efx-logo-card.is-none');
    if (noneCard) selectCard(noneCard);
    return;
  }
  selectCard(card);
}

var lastActivation = 0;

// Mouse: activate on mousedown for instant feedback (no click-twice issue)
track.addEventListener('mousedown', function (e) {
  if (e.button !== 0) return;
  if (Date.now() - lastActivation < 500) return; // ignore emulated mouse from touch
  var card = e.target.closest('.efx-logo-card');
  if (card) {
    lastActivation = Date.now();
    activateCard(card);
  }
});

// Touch: activate on tap, not on swipe-to-scroll
var touchCard = null, touchStartX = 0;
track.addEventListener('touchstart', function (e) {
  touchCard = e.target.closest('.efx-logo-card');
  if (touchCard) touchStartX = e.touches[0].clientX;
}, { passive: true });
track.addEventListener('touchmove', function (e) {
  if (touchCard && Math.abs(e.touches[0].clientX - touchStartX) > 10) {
    touchCard = null; // user is swiping, not tapping
  }
}, { passive: true });
track.addEventListener('touchend', function () {
  if (touchCard) {
    lastActivation = Date.now();
    activateCard(touchCard);
    touchCard = null;
  }
});

// Keyboard fallback (Enter on focused button fires click but no mousedown/touchend)
track.addEventListener('click', function (e) {
  if (Date.now() - lastActivation < 500) return; // already handled
  var card = e.target.closest('.efx-logo-card');
  if (card) activateCard(card);
});

// Mouse wheel: vertical wheel → horizontal scroll (fixes desktop stiffness)
slider.addEventListener('wheel', function (e) {
  if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
  var max = track.scrollWidth - track.clientWidth;
  if (max <= 0) return;
  var next = track.scrollLeft + e.deltaY;
  if ((next <= 0 && e.deltaY < 0) || (next >= max && e.deltaY > 0)) return;
  e.preventDefault();
  track.scrollLeft = next;
}, { passive: false });

      // ── Nav arrows ────────────────────────────────────────
      function scrollPage(dir) {
        var amount = Math.max(280, track.clientWidth * 0.75);
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      prevBtn.addEventListener('click', function () { scrollPage(-1); });
      nextBtn.addEventListener('click', function () { scrollPage(1);  });

      // ── Arrow + progress thumb update ─────────────────────
      function update() {
        var atStart = track.scrollLeft <= 4;
        var atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
        prevBtn.classList.toggle('disabled', atStart);
        nextBtn.classList.toggle('disabled', atEnd);
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
        var sw = track.scrollWidth, cw = track.clientWidth;
        if (sw <= cw + 4) { progress.classList.add('hidden'); return; }
        progress.classList.remove('hidden');
        var pw = progress.offsetWidth;
        if (pw <= 0) return;
        var thumbWidth = Math.max(32, pw * (cw / sw));
        thumb.style.width = thumbWidth + 'px';
        var maxScroll = sw - cw;
        var maxThumbLeft = pw - thumbWidth;
        var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        thumb.style.left = (ratio * maxThumbLeft) + 'px';
      }
      track.addEventListener('scroll', update);
      setTimeout(update, 100);
      setTimeout(update, 600);

      // ── Progress-thumb drag (unchanged) ───────────────────
      thumb.addEventListener('mousedown', startThumbDrag);
      thumb.addEventListener('touchstart', startThumbDrag, { passive: false });
      function startThumbDrag(e) {
        thumb.classList.add('dragging');
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var startLeft = thumb.offsetLeft, startX = clientX;
        function onTMove(ev) {
          var x = ev.touches ? ev.touches[0].clientX : ev.clientX;
          var delta = x - startX;
          var rect = progress.getBoundingClientRect();
          var tw = thumb.offsetWidth;
          var newLeft = Math.max(0, Math.min(rect.width - tw, startLeft + delta));
          var r = (rect.width - tw) > 0 ? newLeft / (rect.width - tw) : 0;
          var maxScroll = track.scrollWidth - track.clientWidth;
          track.scrollLeft = r * maxScroll;
          if (ev.touches) ev.preventDefault();
        }
        function onTEnd() {
          thumb.classList.remove('dragging');
          document.removeEventListener('mousemove', onTMove);
          document.removeEventListener('touchmove', onTMove);
          document.removeEventListener('mouseup',   onTEnd);
          document.removeEventListener('touchend',  onTEnd);
          document.removeEventListener('touchcancel', onTEnd);
        }
        document.addEventListener('mousemove', onTMove);
        document.addEventListener('touchmove', onTMove, { passive: false });
        document.addEventListener('mouseup',   onTEnd);
        document.addEventListener('touchend',  onTEnd);
        document.addEventListener('touchcancel', onTEnd);
        e.preventDefault();
      }
      progress.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = progress.getBoundingClientRect();
        var tw = thumb.offsetWidth;
        var newLeft = Math.max(0, Math.min(rect.width - tw, e.clientX - rect.left - tw / 2));
        var r = (rect.width - tw) > 0 ? newLeft / (rect.width - tw) : 0;
        var maxScroll = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: r * maxScroll, behavior: 'smooth' });
      });

      // ── Rule evaluation: read visibility_condition from DPO state ──────
function efxGetSelectedTitle(fieldIdx) {
  var f = window.dpoOptions && window.dpoOptions.options && window.dpoOptions.options[fieldIdx];
  if (!f || !f.items) return null;
  // Try DPO's own is_selected flag first
  for (var k in f.items) {
    var it = f.items[k];
    if (it.is_selected === 1 || it.is_selected === '1') return it.title;
  }
  // Fallback: read the underlying <select> for that field
  var lookFor = String(f.label || f.title || '').trim().replace(/:$/, '').toLowerCase();
  var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
  for (var i = 0; i < fields.length; i++) {
    var fl = fields[i];
    var lbl = (fl.querySelector('label') && fl.querySelector('label').textContent || '').trim().replace(/:$/, '').toLowerCase();
    if (lbl !== lookFor) continue;
    var s = fl.querySelector('select');
    if (!s || !s.value) return null;
    for (var k2 in f.items) {
      if (String(f.items[k2].option_type_id) === String(s.value)) return f.items[k2].title;
    }
  }
  return null;
}

function efxNormTitle(s) {
  if (s == null) return '';
  return String(s)
    .replace(/\(.*?\)/g, '')   // strip "(3.3x4.09)" etc.
    .replace(/[\/\\]/g, ' ')   // slash → space
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}


function efxEvalCondition(cond) {
  if (typeof cond === 'string') {
    try { cond = JSON.parse(cond); } catch (_) { return false; }
  }
  if (!cond || !cond.conditions || !cond.conditions.length) return false;
  var results = cond.conditions.map(function (c) {
    if (c.type !== 'field') return false;
    var sel = efxNormTitle(efxGetSelectedTitle(c.field));
    var val = efxNormTitle(c.value);
    if (c.condition === 'is')     return sel === val;
    if (c.condition === 'is_not') return sel !== val;
    return false;
  });
  return cond.type === 'all'
    ? results.every(function (x) { return x; })
    : results.some(function (x)  { return x; });
}

function efxGetInverseExclusions(targetFieldIdx) {
  // Returns a set of option_type_ids in targetFieldIdx that should be hidden
  // because some currently-selected item in ANOTHER field is incompatible with them.
  var exclusions = {};
  if (!window.dpoOptions || !window.dpoOptions.options) return exclusions;

  for (var fIdx in window.dpoOptions.options) {
    var fld = window.dpoOptions.options[fIdx];
    if (!fld || !fld.items) continue;

    // Is anything currently selected in this field?
    var selTitle = efxGetSelectedTitle(fIdx);
    if (!selTitle) continue;
    var normSel = efxNormTitle(selTitle);

    // Find the currently-selected item to read its visibility_condition
    for (var iKey in fld.items) {
      var item = fld.items[iKey];
      if (efxNormTitle(item.title) !== normSel) continue;
      if (!item.visibility_condition || item.visibility_action !== 'hidden') break;

      var cond = item.visibility_condition;
      if (typeof cond === 'string') {
        try { cond = JSON.parse(cond); } catch (_) { break; }
      }
      if (!cond || !cond.conditions) break;

      // Each condition that references our target field tells us
      // which item in the target field is incompatible with the current selection.
      cond.conditions.forEach(function (c) {
        if (c.type !== 'field') return;
        if (String(c.field) !== String(targetFieldIdx)) return;
        if (c.condition !== 'is') return; // skip is_not / other forms for now
        var targetFld = window.dpoOptions.options[targetFieldIdx];
        if (!targetFld || !targetFld.items) return;
        var normVal = efxNormTitle(c.value);
        for (var k in targetFld.items) {
          if (efxNormTitle(targetFld.items[k].title) === normVal) {
            exclusions[targetFld.items[k].option_type_id] = true;
          }
        }
      });
      break;
    }
  }
  return exclusions;
}

function efxFindMyFieldIdx() {
  if (!window.dpoOptions || !window.dpoOptions.options) return null;
  var myLabel = (field.querySelector('label') && field.querySelector('label').textContent || '').trim().replace(/:$/, '').toLowerCase();
  for (var idx in window.dpoOptions.options) {
    var lbl = String(window.dpoOptions.options[idx].label || window.dpoOptions.options[idx].title || '').trim().replace(/:$/, '').toLowerCase();
    if (lbl === myLabel) return idx;
  }
  return null;
}

function syncCardsToRules() {
  var idx = efxFindMyFieldIdx();
  if (idx === null) return;
  var dpoField = window.dpoOptions.options[idx];
  if (!dpoField || !dpoField.items) return;
  for (var k in dpoField.items) {
    var item = dpoField.items[k];
    var hide = false;
    if (item.visibility_condition) {
      hide = efxEvalCondition(item.visibility_condition) && item.visibility_action === 'hidden';
    }
    // NEW: inverse rule — other selected items declare us incompatible
    if (!hide) {
      var inv = efxGetInverseExclusions(idx);
      if (inv[item.option_type_id]) hide = true;
    }
    var card = track.querySelector('.efx-logo-card[data-value="' + item.option_type_id + '"]');
    if (!card) continue;
    if (hide) {
      card.style.display = 'none';
      card.classList.add('efx-rule-hidden');
      if (card.classList.contains('selected')) {
        card.classList.remove('selected');
        card.setAttribute('aria-checked', 'false');
      }
    } else {
      card.style.display = '';
      card.classList.remove('efx-rule-hidden');
    }
  }
  setTimeout(update, 50);
}

// Re-evaluate this slider's rules whenever ANY select changes
// (rules can reference any other field)
var _ruleSyncTimer;
function _scheduleRuleSync() {
  clearTimeout(_ruleSyncTimer);
  _ruleSyncTimer = setTimeout(syncCardsToRules, 30);
}
document.addEventListener('change', function (e) {
  if (e.target && e.target.tagName === 'SELECT') _scheduleRuleSync();
}, true);

// First-pass evaluation (after DPO has finished initializing)
setTimeout(syncCardsToRules, 200);

// ── Sync cards to <option> presence (NEW) ────────────────
// DPO dynamically adds/removes <option> elements from the
// underlying <select> when its rule engine fires. Mirror
// that onto the cards so they can't desync from reality.
function syncCardsToSelectOptions() {
  var existing = new Set();
  Array.from(select.options).forEach(function (o) {
    existing.add(String(o.value));
  });
  var currentVal = String(select.value || '');

  // Case A: select still has a value, but that option no longer exists
  // (DPO didn't clear it cleanly). Force to None.
  if (currentVal && !existing.has(currentVal)) {
    var noneOpt = Array.from(select.options).find(function (o) {
      return !o.value || /^[-—\s]*none[-—\s]*$/i.test((o.textContent || '').trim());
    });
    if (noneOpt) {
      select.value = noneOpt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jQuery) window.jQuery(select).trigger('change');
    } else {
      select.value = '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    currentVal = String(select.value || '');
  }

  // Case B: select is empty but Phase 9 label still shows a stale summary.
  // Happens when DPO silently cleared the select without firing change.
  var lbl = field.querySelector('label');
  if (!currentVal && lbl) {
    var staleSummary = lbl.getAttribute('data-efx-summary');
    if (staleSummary && staleSummary !== 'Click to select' && staleSummary !== 'None') {
      lbl.setAttribute('data-efx-summary', 'Click to select');
      field.classList.remove('efx-acc-has-value');
      delete field.dataset.efxUserTouched;
      var clearBtn = lbl.querySelector('.efx-acc-clear');
      if (clearBtn) clearBtn.remove();
      // Un-select all cards, select None
      track.querySelectorAll('.efx-logo-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      var noneCard = track.querySelector('.efx-logo-card.is-none');
      if (noneCard) {
        noneCard.classList.add('selected');
        noneCard.setAttribute('aria-checked', 'true');
      }
    }
  }

  // Standard sync: hide cards whose options no longer exist
  track.querySelectorAll('.efx-logo-card').forEach(function (card) {
    var value = String(card.dataset.value || '');
    if (!value) return;
    if (!existing.has(value)) {
      card.style.display = 'none';
      card.classList.add('efx-option-removed');
      if (card.classList.contains('selected')) {
        card.classList.remove('selected');
        card.setAttribute('aria-checked', 'false');
      }
    } else {
      card.style.display = '';
      card.classList.remove('efx-option-removed');
    }
  });
}

var optionObs = new MutationObserver(syncCardsToSelectOptions);
optionObs.observe(select, { childList: true });

document.addEventListener('change', function (e) {
  if (e.target && (e.target.tagName === 'SELECT' || e.target.tagName === 'INPUT')) {
    setTimeout(syncCardsToSelectOptions, 50);
  }
}, true);

setTimeout(syncCardsToSelectOptions, 200);
setTimeout(syncCardsToSelectOptions, 800);

      // ── Preselect existing value ──────────────────────────
      if (select.value) {
        var pre = track.querySelector('.efx-logo-card[data-value="' + select.value + '"]');
        if (pre) {
          pre.classList.add('selected');
          pre.setAttribute('aria-checked', 'true');
        }
      }

      return true;
    }

    function tryInit() {
      var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        if (!isLogoField(field)) continue;
        var control = field.querySelector('.control');
        if (!control) continue;
        try { buildSlider(control, field); }
        catch (err) { console.error('[EFX Logo Slider] buildSlider failed for ' + field.id + ':', err); }
      }
    }

    function start() {
      tryInit();
      var inObserve = false;
      var observer = new MutationObserver(function () {
        if (inObserve) return;
        inObserve = true;
        try { tryInit(); } finally { inObserve = false; }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 15000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();

/* ============================================================
   PHASE 3.7 — Size Type pills (Men / Women / Youth)
   Hijacks the option 1004 input group (checkbox OR radio), renders 3
   styled pills. Adapts to the field type: checkboxes toggle independently
   (legacy multi-select); radios are single-select (a pick unchecks siblings).
   ============================================================ */
(function () {
  'use strict';

  function findSizeTypeField() {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      if (/size\s*type/i.test(fields[i].textContent || '')) return fields[i];
    }
    return null;
  }

  function buildPills() {
    var field = findSizeTypeField();
    if (!field || field.dataset.efxSizeTypePills) return false;
    // Accept radios too, so this still builds if DPO's Size Type is switched
    // from multi-select checkboxes to single-select radios.
    var checks = field.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    if (checks.length < 2) return false;
    field.dataset.efxSizeTypePills = '1';

    // Build pill row
    var row = document.createElement('div');
    row.className = 'efx-stype-pills';
    var pills = [];
    checks.forEach(function (cb) {
      var lbl = cb.closest('label') ||
                document.querySelector('label[for="' + cb.id + '"]');
      var labelText = (lbl ? lbl.textContent : cb.value || 'Option').trim();
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'efx-stype-pill';
      pill.textContent = labelText;
      if (cb.checked) pill.classList.add('selected');
      pill.addEventListener('click', function () {
        // Radios can't be un-picked by clicking; checkboxes toggle. A radio
        // pick also unchecks its siblings, so re-sync every pill afterwards.
        if (cb.type === 'radio') cb.checked = true;
        else cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
        cb.dispatchEvent(new Event('click',  { bubbles: true }));
        pills.forEach(function (p) { p.pill.classList.toggle('selected', p.cb.checked); });
      });
      pills.push({ pill: pill, cb: cb });
      row.appendChild(pill);

      // Hide the original checkbox + its label visually but keep accessible
      if (lbl) lbl.style.display = 'none';
      cb.style.display = 'none';
    });

    var control = field.querySelector('.control') || field;
    control.insertBefore(row, control.firstChild);

    // Reflect any later programmatic changes (e.g. preselection)
    checks.forEach(function (cb, i) {
      cb.addEventListener('change', function () {
        if (pills[i]) pills[i].pill.classList.toggle('selected', cb.checked);
      });
    });
    return true;
  }

  function start() {
    if (buildPills()) return;
    var obs = new MutationObserver(function () {
      if (buildPills()) obs.disconnect();
    });
    obs.observe(document.body, { subtree: true, childList: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ──────────────────────────────────────────────────────────────
 * Phase 8: Size Type → reuse production-time pill rendering
 * ────────────────────────────────────────────────────────────── */
(function () {
  function build() {
    var existing = document.querySelector('.efx-stype-pills');
    if (!existing) return false;

    var control = existing.closest('.control');
    if (!control || control.dataset.efxSizeBuilt) return !!control;

    var optionsList = control.querySelector('.options-list');
    if (!optionsList) return false;

    var radios = optionsList.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    if (!radios.length) return false;

    var SIZE_RANGES = { 'men': 'XS–8XL', 'women': 'XS–3XL', 'youth': '2T–XL' };

    var stack = document.createElement('div');
    stack.className = 'efx-time-stack';

    var cards = [];
    radios.forEach(function (radio) {
      var lblSpan = optionsList.querySelector('label[for="' + radio.id + '"] span');
      var lblText = lblSpan ? lblSpan.textContent.trim() : radio.value;

      var card = document.createElement('div');
      card.className = 'efx-time-card';
      card.setAttribute('data-input-id', radio.id);
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      var range = SIZE_RANGES[lblText.trim().toLowerCase()] || '';
      card.innerHTML =
        '<div class="efx-time-radio"><span class="efx-time-radio-dot"></span></div>' +
        '<div class="efx-time-info"><div class="efx-time-label">' + lblText + '</div></div>' +
        (range ? '<div class="efx-time-price efx-time-price-included">' + range + '</div>' : '');

      function activate() {
        radios.forEach(function (r) { r.checked = false; });
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.jQuery) window.jQuery(radio).trigger('change');
        cards.forEach(function (c) { c.classList.remove('selected'); });
        card.classList.add('selected');
      }

      card.addEventListener('click', activate);
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); activate(); }
      });

      if (radio.checked) card.classList.add('selected');

      stack.appendChild(card);
      cards.push(card);
    });

    existing.style.display = 'none';
    control.insertBefore(stack, existing);
    control.dataset.efxSizeBuilt = '1';
    return true;
  }

  if (!build()) {
    var mo = new MutationObserver(function () { if (build()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

})();

/* ──────────────────────────────────────────────────────────────
 * Phase 8b (v2, SAFE): put each size dropdown under its Size Type card.
 * Moves ONCE, only after DPO has been stable ~1s, with NO ongoing observer
 * and no per-change listener (v1 moved on every mutation, i.e. mid-render,
 * which corrupted the customizer). Wrapped in try/catch so it can never break
 * the customizer. The size fields live in DPO's <table>; their emptied <tr>
 * is hidden after the move.
 * ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // DISABLED 2026-07-15: relocating DPO's size fields under their Size Type
  // card is a dead end. DPO re-homes its own conditional fields back to their
  // native <table> slot on every cascade (ANY option change — e.g. Collar —
  // triggers it), so the move only survives until the next change and the size
  // dropdown "disappears" from under the card until re-clicked. Making it stick
  // would require re-moving on every cascade, which is the per-mutation
  // approach that corrupted the customizer. Left inert for reference; only
  // revisit via a PROXY UI that writes to the hidden DPO <select> and never
  // moves DPO's own node. The .efx-size-under-type / .efx-emptied-row CSS is
  // now dormant and harmless.
  return;

  var TYPE_SIZE = { men: /^men\s*sizes/i, women: /^women\s*sizes/i, youth: /^youth\s*sizes/i };

  function cleanLabel(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return '';
    var clone = lbl.cloneNode(true);
    clone.querySelectorAll('a, em, span').forEach(function (n) { n.remove(); });
    return (clone.textContent || '').trim();
  }

  function fieldBy(re) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      if (re.test(cleanLabel(fields[i]))) return fields[i];
    }
    return null;
  }

  function sizeTypeStack() {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      if (/size\s*type/i.test(fields[i].textContent || '')) {
        return fields[i].querySelector('.efx-time-stack');
      }
    }
    return null;
  }

  function cardType(card) {
    var lblEl = card.querySelector('.efx-time-label');
    var t = lblEl ? (lblEl.textContent || '').trim().toLowerCase() : '';
    if (/^men\b/.test(t)) return 'men';
    if (/^women\b/.test(t)) return 'women';
    if (/^youth\b/.test(t)) return 'youth';
    return null;
  }

  function doMove(stack) {
    var cards = [].slice.call(stack.querySelectorAll('.efx-time-card'));
    cards.forEach(function (card) {
      var type = cardType(card);
      if (!type || !TYPE_SIZE[type]) return;
      var sizeField = fieldBy(TYPE_SIZE[type]);
      if (!sizeField) return;
      if (sizeField.closest('.efx-time-stack') === stack) return; // already there
      var origRow = sizeField.closest('tr');
      sizeField.classList.add('efx-size-under-type');
      stack.insertBefore(sizeField, card.nextElementSibling);
      if (origRow && !origRow.querySelector('[id^="dynamic_option_id_"]')) {
        origRow.classList.add('efx-emptied-row');
      }
    });
  }

  var moved = false, stable = 0, tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (moved || tries > 40) { clearInterval(timer); return; } // give up after ~20s
    var stack = sizeTypeStack();
    var anySize = fieldBy(TYPE_SIZE.men) || fieldBy(TYPE_SIZE.women) || fieldBy(TYPE_SIZE.youth);
    var readyNow = stack && stack.querySelector('.efx-time-card') && anySize;
    if (!readyNow) { stable = 0; return; }
    if (++stable < 2) return; // ~1s stable before touching DPO's DOM
    try { doMove(stack); } catch (e) { /* never break the customizer */ }
    moved = true;
    clearInterval(timer);
  }, 500);
})();


/* ──────────────────────────────────────────────────────────────
 * Phase 8c: Size pills UNDER their Size Type card (proxy — DPO-safe)
 * ──────────────────────────────────────────────────────────────
 * Replaces the failed field-move approach (disabled Phase 8b above).
 * Instead of moving DPO's own size field — which DPO re-homes on every
 * cascade — we move OUR OWN .efx-size-pills grid (built by Phase 3.5)
 * under the matching Size Type card. DPO's <select> stays hidden in
 * place in the table, so DPO has nothing to reclaim and the layout
 * survives every cascade (Collar change, restore, etc.).
 *
 * The original DPO size field is kept in the DOM (so DPO's own
 * validation/required logic is untouched) but visually hidden via the
 * .efx-size-hoisted class — its UI now lives under the card.
 *
 * Visibility follows the card's Size Type radio (the ground truth), so
 * it is correct after a Team Order restore too (where the radio is set
 * programmatically and the card's click handler never runs); we also
 * mirror the radio onto the card's .selected highlight as a bonus.
 *
 * No-ops safely on templates without Men/Women/Youth cards (Fairways,
 * pants, etc.) — it commits only once all three cards + grids + fields
 * are present, and otherwise leaves everything alone.
 * ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var SIZE_IDS = { men: 1005, women: 1006, youth: 1007 };

  function findStack() {
    var stacks = document.querySelectorAll('.efx-time-stack');
    for (var i = 0; i < stacks.length; i++) {
      var labels = [].map.call(stacks[i].querySelectorAll('.efx-time-label'), function (l) {
        return (l.textContent || '').trim().toLowerCase();
      });
      if (labels.indexOf('men') > -1 || labels.indexOf('youth') > -1) return stacks[i];
    }
    return null;
  }

  function cardFor(stack, type) {
    var cards = [].slice.call(stack.querySelectorAll('.efx-time-card'));
    for (var i = 0; i < cards.length; i++) {
      var l = cards[i].querySelector('.efx-time-label');
      if (l && (l.textContent || '').trim().toLowerCase() === type) return cards[i];
    }
    return null;
  }

  function build(stack) {
    if (stack.dataset.efxSizeUnderCard) return true;

    // Gather every piece first — commit only when ALL are present, so a
    // half-built stack just waits for the next pass instead of half-moving.
    var groups = [];
    var keys = Object.keys(SIZE_IDS);
    for (var i = 0; i < keys.length; i++) {
      var type = keys[i];
      var field = document.getElementById('dynamic_option_id_' + SIZE_IDS[type]);
      var grid = field && field.querySelector('.efx-size-pills');
      var card = cardFor(stack, type);
      if (!field || !grid || !card) return false;
      groups.push({ type: type, field: field, grid: grid, card: card });
    }

    groups.forEach(function (g) {
      var wrap = document.createElement('div');
      wrap.className = 'efx-size-under-card';
      g.card.parentNode.insertBefore(wrap, g.card.nextSibling);
      wrap.appendChild(g.grid);            // OUR element — DPO doesn't own it
      g.wrap = wrap;
      g.field.classList.add('efx-size-hoisted'); // hide the now-empty field in the table
      var rid = g.card.getAttribute('data-input-id');
      g.radio = rid ? document.getElementById(rid) : null;
    });

    var refreshing = false;
    function refresh() {
      if (refreshing) return;             // guard against any re-entrancy
      refreshing = true;
      groups.forEach(function (g) {
        var on = g.radio ? !!g.radio.checked : g.card.classList.contains('selected');
        g.wrap.style.display = on ? 'block' : 'none';
        if (g.card.classList.contains('selected') !== on) {
          g.card.classList.toggle('selected', on); // keep card highlight in sync (esp. after restore)
        }
      });
      refreshing = false;
    }

    // The size-type radios drive everything: a user card click (Phase 8's
    // activate) and a Team Order restore both end in a radio 'change'.
    groups.forEach(function (g) {
      if (g.radio) g.radio.addEventListener('change', refresh);
    });
    // Catch-all for any path that toggles a card without a radio 'change'.
    stack.addEventListener('click', function () { setTimeout(refresh, 0); });

    refresh();
    stack.dataset.efxSizeUnderCard = '1';
    return true;
  }

  function start() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var done = false;
      try {
        var stack = findStack();
        done = !!(stack && build(stack));
      } catch (e) { /* never break the customizer */ }
      if (done || tries > 60) clearInterval(timer); // give up after ~30s
    }, 500);
  }

  start();
  // Theme editor re-renders the section: a fresh stack needs re-wiring.
  document.addEventListener('shopify:section:load', start);
})();


/* ──────────────────────────────────────────────────────────────
 * Phase 8d: Unified Size Type cards from SEPARATE one-checkbox fields
 * ──────────────────────────────────────────────────────────────
 * The 2026-07 DPO restructure split Size Type into THREE separate
 * one-checkbox fields (Size Type→Men, →Women, →Youth), each followed by
 * its size dropdown. Phase 3.7/8 assumed ONE field holding all three
 * checkboxes, so they can no longer build the card group.
 *
 * This gathers the separate Size Type fields, renders the unified card
 * stack (reusing the .efx-time-stack card markup + CSS) and coordinates
 * single-select ACROSS the fields (picking a card unchecks the others'
 * checkboxes — DPO no longer enforces that). Each type's size pills (built
 * by Phase 3.5, now label-detected so abbreviations still apply) are moved
 * under its card. DPO's own fields stay in the DOM (hidden) so its rules
 * and validation are untouched.
 *
 * Runs ONLY when there are ≥2 SEPARATE size-type fields (the new
 * structure). If all the checkboxes live in one field (legacy), it bails
 * and lets Phase 3.7/8 handle it, so the two never both build. No-ops on
 * templates without Men/Women/Youth size types.
 * ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var TYPES = ['men', 'women', 'youth'];
  var RANGES = { men: 'XS–8XL', women: 'XS–3XL', youth: '2T–XL' };

  function cleanLabel(field) {
    var l = field.querySelector('label');
    if (!l) return '';
    var c = l.cloneNode(true);
    c.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
    return (c.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Word-boundary match so "men" can't match inside "women".
  function typeOfText(text) {
    text = (text || '').toLowerCase();
    for (var i = 0; i < TYPES.length; i++) {
      if (new RegExp('\\b' + TYPES[i] + '\\b').test(text)) return TYPES[i];
    }
    return null;
  }

  function inputType(inp, field) {
    var l = field.querySelector('label[for="' + inp.id + '"]') || inp.closest('label');
    return typeOfText(l ? l.textContent : inp.value);
  }

  function gather() {
    var fields = [].slice.call(document.querySelectorAll('[id^="dynamic_option_id_"]'));
    var found = [];
    fields.forEach(function (f) {
      if (!/size\s*type/i.test(f.textContent || '')) return;
      [].forEach.call(f.querySelectorAll('input[type="checkbox"], input[type="radio"]'), function (inp) {
        var t = inputType(inp, f);
        if (t && !found.some(function (x) { return x.type === t; })) {
          found.push({ type: t, input: inp, field: f });
        }
      });
    });
    found.sort(function (a, b) { return TYPES.indexOf(a.type) - TYPES.indexOf(b.type); });
    return found;
  }

  function sizeFieldFor(type) {
    var re = new RegExp('^\\s*' + type + '\\s+sizes?', 'i');
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      if (re.test(cleanLabel(fields[i]))) return fields[i];
    }
    return null;
  }

  var built = false;

  function build() {
    if (built) return true;
    // Never build a second stack over an existing one (e.g. a stray re-run).
    if (document.querySelector('.efx-stype-stack')) { built = true; return true; }
    var types = gather();
    if (types.length < 2) return false;
    // Confirm the NEW multi-field structure: the types must span ≥2 distinct
    // fields. If they're all in one field, leave it to Phase 3.7/8.
    var distinct = [];
    types.forEach(function (t) { if (distinct.indexOf(t.field) === -1) distinct.push(t.field); });
    if (distinct.length < 2) return false;

    var stack = document.createElement('div');
    stack.className = 'efx-time-stack efx-stype-stack';

    var cards = [];
    types.forEach(function (t) {
      var card = document.createElement('div');
      card.className = 'efx-time-card';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('data-efx-type', t.type);
      var name = t.type.charAt(0).toUpperCase() + t.type.slice(1);
      card.innerHTML =
        '<div class="efx-time-radio"><span class="efx-time-radio-dot"></span></div>' +
        '<div class="efx-time-info"><div class="efx-time-label">' + name + '</div></div>' +
        (RANGES[t.type] ? '<div class="efx-time-price efx-time-price-included">' + RANGES[t.type] + '</div>' : '');

      function activate() {
        // Single-select across the separate fields: check this type, uncheck
        // the rest, and fire each so DPO updates its conditional size fields.
        types.forEach(function (o) {
          var want = (o === t);
          if (o.input.checked !== want) {
            o.input.checked = want;
            o.input.dispatchEvent(new Event('change', { bubbles: true }));
            o.input.dispatchEvent(new Event('click', { bubbles: true }));
            if (window.jQuery) window.jQuery(o.input).trigger('change');
          }
        });
        refresh();
      }
      card.addEventListener('click', activate);
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); activate(); }
      });

      stack.appendChild(card);
      cards.push({ card: card, t: t, wrap: null, grid: null, sizeField: null });
    });

    // Host the cards INSIDE the first size-type field's control so its
    // "SIZE TYPE:" label + sizing-chart link stay put and the alignment matches
    // the original single-field layout. Hide only that field's checkbox UI, and
    // hide the other (duplicate "SIZE TYPE:") fields entirely.
    var host = types[0].field;
    var hostControl = host.querySelector('.control') || host;
    hostControl.insertBefore(stack, hostControl.firstChild);
    var hostList = host.querySelector('.options-list');
    if (hostList) {
      hostList.style.display = 'none';
    } else {
      [].forEach.call(host.querySelectorAll('input[type="checkbox"], input[type="radio"]'), function (inp) {
        inp.style.display = 'none';
        var l = host.querySelector('label[for="' + inp.id + '"]') || inp.closest('label');
        if (l) l.style.display = 'none';
      });
    }
    types.slice(1).forEach(function (t) { t.field.classList.add('efx-stype-hoisted'); });

    cards.forEach(function (c) {
      var wrap = document.createElement('div');
      wrap.className = 'efx-size-under-card';
      c.card.insertAdjacentElement('afterend', wrap);
      c.wrap = wrap;
      c.sizeField = sizeFieldFor(c.t.type);
      if (c.sizeField) c.sizeField.classList.add('efx-size-hoisted');
    });

    // Phase 3.5 builds the .efx-size-pills asynchronously; adopt each grid
    // under its card as soon as it appears (moving OUR element, never DPO's).
    function adoptPills() {
      cards.forEach(function (c) {
        if (c.grid || !c.sizeField || !c.wrap) return;
        var g = c.sizeField.querySelector('.efx-size-pills');
        if (g) { c.grid = g; c.wrap.appendChild(g); }
      });
    }

    function refresh() {
      adoptPills();
      cards.forEach(function (c) {
        var on = !!c.t.input.checked;
        c.card.classList.toggle('selected', on);
        if (c.wrap) c.wrap.style.display = on ? 'block' : 'none';
      });
    }

    types.forEach(function (t) { t.input.addEventListener('change', refresh); });

    refresh();
    var n = 0;
    var iv = setInterval(function () {
      adoptPills(); refresh();
      if (++n > 25) clearInterval(iv); // ~10s to catch late pills
    }, 400);

    built = true;
    return true;
  }

  function start() {
    if (build()) return;
    var obs = new MutationObserver(function () { if (build()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function () { built = false; start(); });
})();


/* ──────────────────────────────────────────────────────────────
 * Phase 9: Logo position accordion (clean version — no label mutation)
 * ────────────────────────────────────────────────────────────── */
(function () {
  var ORDER = ['front logo', 'left chest', 'right chest', 'left sleeve', 'right sleeve', 'lower back logo'];
  var fields = [];

  function labelText(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return '';
    // Read only direct text nodes — ignore any child elements
    var t = '';
    for (var i = 0; i < lbl.childNodes.length; i++) {
      if (lbl.childNodes[i].nodeType === 3) t += lbl.childNodes[i].textContent;
    }
    return t.trim().replace(/:$/, '').trim().toLowerCase();
  }
  function isLogoField(field) { return ORDER.indexOf(labelText(field)) !== -1; }
  function orderIdx(field) { return ORDER.indexOf(labelText(field)); }

  function getSummary(field) {
    var sel = field.querySelector('.control select');
    if (!sel) return '';
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return '';
    var txt = (opt.textContent || '').trim();
    // "-- None --" only shows in the pill if user has clicked a card
    // on this slider. Default page-load state stays as "Click to select".
    if (/^[-—\s]*none[-—\s]*$/i.test(txt)) {
      return field.dataset.efxUserTouched === '1' ? 'None' : '';
    }
    // Real value selected — show it (this path covers both user clicks
    // AND programmatic auto-select like product-title rules)
    if (!sel.value) return '';
    return txt.replace(/\s*\(.*?\)\s*/g, '').replace(/\s*[\[\{].*?[\]\}]\s*/g, '').replace(/\s*\+\$.*$/, '').trim();
  }

  function updateSummary(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return;
    var s = getSummary(field);
    lbl.setAttribute('data-efx-summary', s || 'Click to select');
    field.classList.toggle('efx-acc-has-value', !!s);

    // Sibling-X: lives outside the label so it doesn't interfere
    // with the pill's ::after rendering. Inserted as a sibling
    // right after the label.
    // X button lives INSIDE the label (which is display: flex).
    // This lets it sit next to the ::after pill within the same row.
    var existing = lbl.querySelector('.efx-acc-clear');
    if (s) {
      if (!existing) {
        var clearBtn = document.createElement('button');
        clearBtn.type = 'button';
        clearBtn.className = 'efx-acc-clear';
        clearBtn.setAttribute('aria-label', 'Clear selection');
        clearBtn.innerHTML = '&times;';
        clearBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          var sel = field.querySelector('.control select');
          if (!sel) return;
          var noneOpt = Array.prototype.find.call(sel.options, function (o) {
            return !o.value || /^[-—\s]*none[-—\s]*$/i.test(o.textContent.trim());
          });
          if (noneOpt) {
        sel.value = noneOpt.value;
        delete field.dataset.efxUserTouched;

        // Sync the visual slider cards — find the matching slider
        // in this field and update which card has 'selected' class.
        var track = field.querySelector('.efx-logo-track');
        if (track) {
          track.querySelectorAll('.efx-logo-card').forEach(function (c) {
            c.classList.remove('selected');
            c.setAttribute('aria-checked', 'false');
          });
          var noneCard = track.querySelector('.efx-logo-card.is-none');
          if (noneCard) {
            noneCard.classList.add('selected');
            noneCard.setAttribute('aria-checked', 'true');
          }
        }

        sel.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.jQuery) window.jQuery(sel).trigger('change');
      }
        });
        lbl.appendChild(clearBtn);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function collapse(f) { f.classList.add('efx-acc-collapsed'); }
  function expand(f) {
    fields.forEach(collapse);
    f.classList.remove('efx-acc-collapsed');
  }

  function nextEmpty(currentField) {
    var idx = fields.indexOf(currentField);
    for (var i = 1; i <= fields.length; i++) {
      var f = fields[(idx + i) % fields.length];
      if (!getSummary(f)) return f;
    }
    return null;
  }

  function buildOne(field) {
    if (field.dataset.efxAccBuilt) return;
    field.classList.add('efx-logo-accordion', 'efx-acc-collapsed');

    var lbl = field.querySelector('label');
    if (!lbl) return;

    lbl.style.cursor = 'pointer';
    lbl.addEventListener('click', function (e) {
      e.preventDefault();
      if (field.classList.contains('efx-acc-collapsed')) expand(field);
      else collapse(field);
    });

    // change handling moved to document-level delegate below

    updateSummary(field);
    field.dataset.efxAccBuilt = '1';
  }

  function build() {
    var all = document.querySelectorAll('[id^="dynamic_option_id_"]');
    var found = Array.prototype.filter.call(all, isLogoField);
    if (!found.length) return false;
    found.sort(function (a, b) { return orderIdx(a) - orderIdx(b); });
    fields = found;
    found.forEach(buildOne);

    // Insert one-time disclaimer above the first logo accordion
    // (matches the Phase 4 angle-preview disclaimer style).
    if (!document.querySelector('.efx-logo-disclaimer')) {
      var disclaimer = document.createElement('div');
      disclaimer.className = 'efx-preview-disclaimer efx-logo-disclaimer';
      disclaimer.textContent = 'Any logo positions left blank will be printed without a logo.';
      found[0].parentNode.insertBefore(disclaimer, found[0]);
    }

    var firstEmpty = found.filter(function (f) { return !getSummary(f); })[0];
    expand(firstEmpty || found[0]);
    return true;
  }

  if (!build()) {
    var mo = new MutationObserver(function () { if (build()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  // Delegated change handler — catches every select inside a Phase 9
  // accordion regardless of bind order with Phase 3.6's slider.
  // On fill: collapse the current accordion. Do NOT auto-expand the
  // next one — let the customer pick which positions they want.
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('.efx-logo-accordion');
    if (!field) return;
    updateSummary(field);
    if (getSummary(field)) {
      setTimeout(function () { collapse(field); }, 250);
    }
  }, true);
})();

/* ============================================================
   EFX × DPO — PHASE 4: NAME ANGLE + NAME LINES
   ============================================================
   Where to paste: APPEND to efx-dpo-customizations.js
                   (don't replace anything — runs alongside
                    Phases 2–3)

   What it does:   1. Name Angle radio group → two visual
                      cards (Straight / Angled), with a live
                      preview of First Line + Second Line
                      rendered in each card
                   2. First Line Text + Second Line Text inputs
                      get a soft character counter pill (only
                      visible past 15 chars, turns red past
                      WARN_THRESHOLD)
                   3. Typing in either line updates BOTH angle
                      card previews live

   Field discovery: By label-text regex (same pattern as
                    Phase 2.2 Production Time). No option ID
                    is hardcoded, so it survives DPO
                    re-numbering across products.
   ============================================================ */

(function () {
  'use strict';

  // ── Tunable thresholds (per request: don't really limit) ──
  var MAX_LEN         = 40;   // hard backstop, won't realistically be hit
  var WARN_THRESHOLD  = 30;   // counter pill turns red past this length

  // ── Label-text patterns to find each field ─────────────────
  var FIELD_PATTERNS = {
    angle:  /^name\s*angle\s*:?\s*$/i,
    line1:  /^first\s*line\s*text\s*:?\s*$/i,
    line2:  /^second\s*line\s*text\s*:?\s*$/i,
  };

  // ── Shared state (refs to elements once they exist) ────────
  var state = {
    line1Input: null,
    line2Input: null,
    angleCards: null,   // NodeList of .efx-angle-card
    angleField: null,
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ── Find a DPO field by its label text ─────────────────────
  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('label');
      if (!label) continue;
      // Strip trailing required-asterisk text/spans before testing
      var clone = label.cloneNode(true);
      clone.querySelectorAll('em, span, a').forEach(function (n) { n.remove(); });
      var text = (clone.textContent || '').trim();
      if (pattern.test(text)) return fields[i];
    }
    return null;
  }

  /* ───────────────────────────────────────────────────────── */
  /* NAME ANGLE — radio group → two visual cards               */
  /* ───────────────────────────────────────────────────────── */
  function parseAngleRadio(input) {
    var label = document.querySelector('label[for="' + input.id + '"]') ||
                input.closest('label');
    var raw = '';
    if (label) {
      var clone = label.cloneNode(true);
      clone.querySelectorAll('input').forEach(function (n) { n.remove(); });
      raw = (clone.textContent || '').trim();
    }

    // Determine which preset this radio is (Straight vs Angled)
    var preset;
    if (/angled|tilt/i.test(raw))      preset = { key: 'angled',   title: 'Angled',   pill: 'Tilted · +10°' };
    else                               preset = { key: 'straight', title: 'Straight', pill: 'Standard · 0°' };

    return {
      value:   input.value,
      inputId: input.id,
      key:     preset.key,
      title:   preset.title,
      pill:    preset.pill,
    };
  }

  function buildAnglePicker(field) {
    if (!field || field.dataset.efxAnglePicker) return false;
    var control = field.querySelector('.control') || field;
    var radios  = control.querySelectorAll('input[type="radio"]');
    if (!radios.length) return false;
    field.dataset.efxAnglePicker = '1';

    // Remove the label underline (Phase 1 default)
    field.classList.add('efx-no-label-bar');

    var options = [].slice.call(radios).map(parseAngleRadio);

    // Sort: Straight first, Angled second (consistent regardless of DPO order)
    options.sort(function (a, b) {
      if (a.key === 'straight') return -1;
      if (b.key === 'straight') return 1;
      return 0;
    });

    // Hide original radios + labels
    radios.forEach(function (r) {
      r.style.display = 'none';
      var lbl = document.querySelector('label[for="' + r.id + '"]');
      if (lbl) lbl.style.display = 'none';
      var row = r.closest('.control > div');
      if (row && row !== control) row.style.display = 'none';
    });

    // Build the grid
    var grid = document.createElement('div');
    grid.className = 'efx-angle-grid';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Name angle');

    grid.innerHTML = options.map(function (o) {
      return '' +
        '<button type="button" class="efx-angle-card" role="radio" aria-checked="false" ' +
                'data-angle="' + escapeHtml(o.key) + '" ' +
                'data-input-id="' + escapeHtml(o.inputId) + '">' +
          '<div class="efx-angle-preview-wrap">' +
            '<div class="efx-angle-preview-1" data-preview-1>RANDY</div>' +
            '<div class="efx-angle-preview-2 efx-empty" data-preview-2></div>' +
          '</div>' +
          '<div class="efx-angle-title">' + escapeHtml(o.title) + '</div>' +
          '<span class="efx-angle-pill">' + escapeHtml(o.pill) + '</span>' +
        '</button>';
    }).join('');

    control.insertBefore(grid, control.firstChild);

    // ── Disclaimer (sits under the cards) ─────────────────────
    var disclaimer = document.createElement('div');
    disclaimer.className = 'efx-preview-disclaimer';
    disclaimer.textContent = 'Approximate preview · final jersey spacing may vary';
    grid.insertAdjacentElement('afterend', disclaimer);

    function selectCard(card) {
      grid.querySelectorAll('.efx-angle-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('selected');
      card.setAttribute('aria-checked', 'true');
      var input = document.getElementById(card.dataset.inputId);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('click',  { bubbles: true }));
      }
    }

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-angle-card');
      if (card) selectCard(card);
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-angle-card');
        if (card) { e.preventDefault(); selectCard(card); }
      }
    });

    // Reflect any pre-existing radio selection
    var checked = control.querySelector('input[type="radio"]:checked');
    if (checked) {
      var pre = grid.querySelector('[data-input-id="' + checked.id + '"]');
      if (pre) {
        pre.classList.add('selected');
        pre.setAttribute('aria-checked', 'true');
      }
    } else {
      // Default to first card (Straight) if nothing pre-selected
      var first = grid.querySelector('.efx-angle-card');
      if (first) selectCard(first);
    }

    // Cache for live sync
    state.angleField = field;
    state.angleCards = grid.querySelectorAll('.efx-angle-card');

    syncPreviews();
    return true;
  }

  /* ───────────────────────────────────────────────────────── */
  /* TEXT LINE — attach counter pill + live sync               */
  /* Works for both <input type="text"> and <textarea>         */
  /* ───────────────────────────────────────────────────────── */
  function attachTextLine(field, which) {
    if (!field || field.dataset.efxTextLine) return false;
    var control = field.querySelector('.control') || field;

    // DPO renders long-text fields as <textarea>, short ones as <input>.
    // Accept either.
    var input = control.querySelector('input[type="text"].product-custom-option') ||
                control.querySelector('textarea.product-custom-option') ||
                control.querySelector('input[type="text"]') ||
                control.querySelector('textarea');
    if (!input) return false;
    field.dataset.efxTextLine = which;

    // Remove the label underline so it feels grouped with the angle cards
    field.classList.add('efx-no-label-bar');

    // Raise maxlength (don't really limit — backstop only)
    input.setAttribute('maxlength', String(MAX_LEN));
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('spellcheck', 'false');

    // Neutralize textarea multi-line behavior so it visually reads as
    // a single-line input even when DPO rendered it as a textarea
    if (input.tagName === 'TEXTAREA') {
      input.setAttribute('rows', '1');
      input.setAttribute('wrap', 'soft');
      // Block Enter so customers can't insert literal newlines
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
      // Strip any newlines that slip in via paste
      input.addEventListener('paste', function () {
        setTimeout(function () {
          if (/[\r\n]/.test(input.value)) {
            input.value = input.value.replace(/[\r\n]+/g, ' ').trim();
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }, 0);
      });
    }

    // Wrap input in a positioning context (preserves DOM order)
    var wrap = document.createElement('div');
    wrap.className = 'efx-text-wrap';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);

    var counter = document.createElement('span');
    counter.className = 'efx-text-counter';
    counter.textContent = '0 / ' + MAX_LEN;
    wrap.appendChild(counter);

    function updateCounter() {
      var len = input.value.length;
      counter.textContent = len + ' / ' + MAX_LEN;
      counter.classList.toggle('efx-warn', len > WARN_THRESHOLD);
    }

    input.addEventListener('input', function () {
      updateCounter();
      syncPreviews();
    });

    // Cache for live sync
    if (which === 'line1') state.line1Input = input;
    if (which === 'line2') state.line2Input = input;

    updateCounter();
    return true;
  }

  /* ───────────────────────────────────────────────────────── */
  /* LIVE SYNC — push current text into both angle cards       */
  /* ───────────────────────────────────────────────────────── */
  function syncPreviews() {
    if (!state.angleCards) return;

    var v1 = (state.line1Input ? state.line1Input.value : '').toUpperCase();
    var v2 = (state.line2Input ? state.line2Input.value : '').toUpperCase();
    var hasTwo = !!v2;

    state.angleCards.forEach(function (card) {
      var wrap = card.querySelector('.efx-angle-preview-wrap');
      var p1   = card.querySelector('[data-preview-1]');
      var p2   = card.querySelector('[data-preview-2]');
      if (wrap) wrap.classList.toggle('has-line-2', hasTwo);
      if (p1) p1.textContent = v1 || 'YOUR NAME';
      if (p2) {
        p2.textContent = v2;
        p2.classList.toggle('efx-empty', !v2);
      }
    });
  }

  /* ───────────────────────────────────────────────────────── */
  /* FONT HOOK — exposed for future Font Style picker phase     */
  /* ───────────────────────────────────────────────────────── */
  /* Once the font picker is built (next phase), its onChange
     handler should call:
        window.efxSetNameFont("'Anton', sans-serif");
     and BOTH the preview elements AND the typing inputs will
     immediately re-render in that font. */
  window.efxSetNameFont = function (family) {
    if (!family) return;
    var targets = document.querySelectorAll(
      '.efx-angle-preview-1, .efx-angle-preview-2, .efx-text-wrap input.product-custom-option'
    );
    targets.forEach(function (el) { el.style.fontFamily = family; });
  };

  /* ───────────────────────────────────────────────────────── */
  /* BOOTSTRAP                                                  */
  /* ───────────────────────────────────────────────────────── */
  function tryInit() {
    var angleField = findFieldByLabel(FIELD_PATTERNS.angle);
    var line1Field = findFieldByLabel(FIELD_PATTERNS.line1);
    var line2Field = findFieldByLabel(FIELD_PATTERNS.line2);

    if (angleField) buildAnglePicker(angleField);
    if (line1Field) attachTextLine(line1Field, 'line1');
    if (line2Field) attachTextLine(line2Field, 'line2');

    // Done when all three are wired (or as many as exist on this product)
    return !!(angleField && line1Field && line2Field);
  }

  function start() {
    if (tryInit()) return;
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 5 (v4): FONT PILL SLIDER + AUTOFIT
   ============================================================
   Where to paste: REPLACE the previous Phase 5 block in
                   efx-dpo-customizations.js

   What changed vs v3:
     • Categories removed — slider shows all fonts
     • Autofit: angle preview + both text inputs now scale
       their font-size up to fill available width, capped at
       per-context maximums. All four elements share one
       resolved size (the smallest fit) so heights match
       visually across them when they belong to the same row.
     • Refit triggers: font change, text input, window resize,
       and document.fonts.ready (so custom fonts measure
       correctly once their files have loaded)

   Prereq: efx-font-registry.js loaded BEFORE this file
   ============================================================ */

(function () {
  'use strict';

  if (!window.EFX_FONTS) {
    console.warn('[EFX Phase 5] window.EFX_FONTS not loaded — picker disabled');
    return;
  }

  // Module-level so autofitAll can disconnect it during measurement
  // (measurement spans are appended/removed from <body> — that's a
  //  childList mutation, which would otherwise trigger this observer
  //  and cause a feedback loop).
  var __efxObserver = null;

  var FIELD_PATTERN_FONT   = /^font\s*style\s*:?\s*$/i;
  var FIELD_PATTERN_ANGLE  = /^name\s*angle\s*:?\s*$/i;
  var FIELD_PATTERN_LINE_1 = /^first\s*line\s*text/i;
  var FIELD_PATTERN_LINE_2 = /^second\s*line\s*text/i;

  var FONT_TARGETS_SELECTOR =
    '.efx-angle-preview-1, .efx-angle-preview-2, ' +
    '.efx-text-wrap input.product-custom-option, ' +
    '.efx-text-wrap textarea.product-custom-option';

  // Autofit fallback ceiling — only used if a font in the registry
  // is missing a `cap` field (shouldn't happen in practice).
  var DEFAULT_CAP   = 40;
  var FIT_SAFETY_PX = 8;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('label');
      if (!label) continue;
      var clone = label.cloneNode(true);
      clone.querySelectorAll('em, span, a').forEach(function (n) { n.remove(); });
      var text = (clone.textContent || '').trim();
      if (pattern.test(text)) return fields[i];
    }
    return null;
  }

  /* ───────────────────────────────────────────────────────── */
  /* PER-FONT TUNING LOOKUP                                     */
  /* Reads cap + baselineY from the registry for the currently  */
  /* selected font. Falls back to DEFAULT_CAP / 0 if missing.   */
  /* ───────────────────────────────────────────────────────── */
  function getSelectedFontEntry() {
    var selected = document.querySelector('.efx-font-card.selected');
    if (!selected) return null;
    var name = selected.dataset.name;
    for (var i = 0; i < window.EFX_FONTS.length; i++) {
      if (window.EFX_FONTS[i].name === name) return window.EFX_FONTS[i];
    }
    return null;
  }

  function currentCap() {
    var f = getSelectedFontEntry();
    return (f && typeof f.cap === 'number') ? f.cap : DEFAULT_CAP;
  }

  function currentBaselineY() {
    var f = getSelectedFontEntry();
    return (f && typeof f.baselineY === 'number') ? f.baselineY : 0;
  }

  function currentLineGap() {
    var f = getSelectedFontEntry();
    return (f && typeof f.lineGap === 'number') ? f.lineGap : 0;
  }

  function currentInputPad() {
    var f = getSelectedFontEntry();
    return (f && typeof f.inputPad === 'number') ? f.inputPad : 16;
  }

  function currentLetterSpacing() {
    var f = getSelectedFontEntry();
    return (f && typeof f.letterSpacing === 'number') ? f.letterSpacing : 0;
  }

  // Apply the baseline nudge to angle preview text only.
  // (Inputs keep their default vertical centering — easier on
  // the typing experience.)
  function applyBaseline() {
    var y = currentBaselineY();
    document.querySelectorAll(
      '.efx-angle-preview-1, .efx-angle-preview-2'
    ).forEach(function (el) {
      if (y === 0) {
        el.style.removeProperty('transform');
      } else {
        el.style.setProperty('transform', 'translateY(' + y + 'px)', 'important');
      }
    });
  }

  // Per-font extra spacing between line 1 and line 2 in the angle
  // preview. Applied as margin-top on .efx-angle-preview-2.
  // Positive = push line 2 down (more gap). Negative = pull up
  // (tighter / possibly overlapping, useful for fonts whose
  // descenders eat the space naturally).
  function applyLineGap() {
    var gap = currentLineGap();
    document.querySelectorAll('.efx-angle-preview-2').forEach(function (el) {
      if (gap === 0) {
        el.style.removeProperty('margin-top');
      } else {
        el.style.setProperty('margin-top', gap + 'px', 'important');
      }
    });
  }

  // Per-font vertical padding on the First/Second Line text inputs.
  // Same value top + bottom so text stays vertically centered.
  // Lower value = shorter input box, higher = more breathing room.
  function applyInputPad() {
    var pad = currentInputPad();
    document.querySelectorAll(
      '.efx-text-wrap input.product-custom-option, ' +
      '.efx-text-wrap textarea.product-custom-option'
    ).forEach(function (el) {
      el.style.setProperty('padding-top',    pad + 'px', 'important');
      el.style.setProperty('padding-bottom', pad + 'px', 'important');
    });
  }

  // Per-font letter-spacing (tracking). Stored as an em multiplier
  // so it scales correctly with the font-size that autofit picks.
  // Applied to angle preview text + text inputs. Must run BEFORE
  // autofitAnglePreviews / autofitInputs so the width measurement
  // accounts for the new tracking.
  function applyLetterSpacing() {
    var ls = currentLetterSpacing() + 'em';
    document.querySelectorAll(
      '.efx-angle-preview-1, .efx-angle-preview-2, ' +
      '.efx-text-wrap input.product-custom-option, ' +
      '.efx-text-wrap textarea.product-custom-option'
    ).forEach(function (el) {
      el.style.setProperty('letter-spacing', ls, 'important');
    });
  }

  /* ───────────────────────────────────────────────────────── */
  /* FONT APPLICATION (defeats Phase 4's !important via         */
  /* setProperty with 'important' priority)                     */
  /* ───────────────────────────────────────────────────────── */
  function applyFontImportant(family) {
    if (!family) return 0;
    var targets = document.querySelectorAll(FONT_TARGETS_SELECTOR);
    targets.forEach(function (el) {
      el.style.setProperty('font-family', family, 'important');
    });
    return targets.length;
  }

  window.efxSetNameFont = function (family) {
    if (!family) return;
    window.__efxCurrentFont = family;
    applyFontImportant(family);
    // Synchronous autofit so the browser paints the new font-family
    // and the new font-size in the same frame (no "big-then-shrink"
    // flash that you'd see with a debounced call).
    autofitAll();
  };

  // Only ever ONE retry loop in flight. Each call used to start its own 200ms
  // interval, and a restore replays change events more than once (restore()
  // re-asserts at 150ms and 450ms), so changing the font on a duplicated jersey
  // left several intervals running at once. Each tick re-ran autofitAll(), which
  // rewrites input padding, line gap and font-size — so everything below the
  // customizer, notably the "Save jersey" button, jittered up and down for
  // seconds. Restarting the single loop is fine: the first thing it does is try
  // synchronously, and it stops as soon as the font lands.
  var __efxFontRetry = null;

  function applyFontEverywhere(family) {
    if (!family) return;
    window.__efxCurrentFont = family;

    if (__efxFontRetry) { clearInterval(__efxFontRetry); __efxFontRetry = null; }

    if (applyFontImportant(family) > 0) {
      autofitAll();
      return;
    }
    var tries = 0;
    __efxFontRetry = setInterval(function () {
      if (applyFontImportant(family) > 0 || ++tries > 30) {
        clearInterval(__efxFontRetry);
        __efxFontRetry = null;
        autofitAll();
      }
    }, 200);
  }

  /* ───────────────────────────────────────────────────────── */
  /* AUTOFIT                                                    */
  /* ───────────────────────────────────────────────────────── */
  // Measure the rendered width of `text` in the given typography
  // at a reference font-size, so we can back-calculate the size
  // that fills a target width.
  function measureWidth(text, family, weight, refSize, letterSpacing) {
    if (!text) return 0;
    var test = document.createElement('span');
    test.style.cssText =
      'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0;' +
      'font-family:' + family + ';' +
      'font-weight:' + weight + ';' +
      'font-size:' + refSize + 'px;' +
      'letter-spacing:' + letterSpacing + ';' +
      'text-transform:uppercase;';
    test.textContent = text;
    document.body.appendChild(test);
    var w = test.getBoundingClientRect().width;
    document.body.removeChild(test);
    return w;
  }

  function availableWidthFor(el) {
    if (!el) return 0;
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      var s = getComputedStyle(el);
      var padX = parseFloat(s.paddingLeft || 0) + parseFloat(s.paddingRight || 0);
      return el.clientWidth - padX - FIT_SAFETY_PX;
    }
    // For angle preview elements, fit against the CARD's content
    // width — not the immediate parent wrap, which sizes itself
    // to its current content (circular for measurement).
    var card = el.closest && el.closest('.efx-angle-card');
    if (card) {
      var cs = getComputedStyle(card);
      var cpadX = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
      return card.clientWidth - cpadX - FIT_SAFETY_PX;
    }
    // Generic fallback
    var parent = el.parentElement;
    if (!parent) return 0;
    var ps = getComputedStyle(parent);
    var ppadX = parseFloat(ps.paddingLeft || 0) + parseFloat(ps.paddingRight || 0);
    return parent.clientWidth - ppadX - FIT_SAFETY_PX;
  }

  // Calculate the font-size needed for `text` to fill `el`'s
  // available width, capped at maxSize.
  function fitOne(el, text, maxSize) {
    if (!el || !text) return maxSize;
    var avail = availableWidthFor(el);
    if (avail <= 0) return maxSize;
    var s = getComputedStyle(el);
    var refSize = 100;
    // Pass letter-spacing as em (not the computed px) so the
    // measurement at refSize=100px tracks proportionally with
    // the font-size we ultimately pick.
    var lsEm = currentLetterSpacing() + 'em';
    var w = measureWidth(text, s.fontFamily, s.fontWeight, refSize, lsEm);
    if (w === 0) return maxSize;
    return Math.min(maxSize, (avail / w) * refSize);
  }

  function autofitAnglePreviews() {
    var cards = document.querySelectorAll('.efx-angle-card');
    if (!cards.length) return;

    var sample = cards[0];
    var p1 = sample.querySelector('.efx-angle-preview-1');
    var p2 = sample.querySelector('.efx-angle-preview-2');
    if (!p1) return;

    var text1 = (p1.textContent || '').trim();
    var hasTwo = p2 && !p2.classList.contains('efx-empty') && (p2.textContent || '').trim().length > 0;
    var text2 = hasTwo ? (p2.textContent || '').trim() : '';
    var max = currentCap();  // ← per-font cap, same for both contexts

    // Find the smallest size that fits across all cards/lines
    var minSize = max;
    cards.forEach(function (card) {
      var pp1 = card.querySelector('.efx-angle-preview-1');
      var pp2 = card.querySelector('.efx-angle-preview-2');
      if (pp1 && text1) minSize = Math.min(minSize, fitOne(pp1, text1, max));
      if (hasTwo && pp2 && text2) minSize = Math.min(minSize, fitOne(pp2, text2, max));
    });

    // Apply the same size everywhere
    cards.forEach(function (card) {
      var pp1 = card.querySelector('.efx-angle-preview-1');
      var pp2 = card.querySelector('.efx-angle-preview-2');
      if (pp1) pp1.style.setProperty('font-size', minSize + 'px', 'important');
      if (pp2) pp2.style.setProperty('font-size', minSize + 'px', 'important');
    });
  }

  function autofitInputs() {
    var inputs = document.querySelectorAll(
      '.efx-text-wrap input.product-custom-option, ' +
      '.efx-text-wrap textarea.product-custom-option'
    );
    if (!inputs.length) return;

    var max = currentCap();  // ← same per-font cap as the angle preview
    var minSize = max;
    inputs.forEach(function (inp) {
      var text = (inp.value || inp.placeholder || '').trim();
      if (text) minSize = Math.min(minSize, fitOne(inp, text, max));
    });

    inputs.forEach(function (inp) {
      inp.style.setProperty('font-size', minSize + 'px', 'important');
    });
  }

  function autofitAll() {
    // Pause the observer while we measure — measureWidth creates
    // and removes offscreen spans on <body>, which would otherwise
    // trigger this very observer and create a feedback loop.
    if (__efxObserver) __efxObserver.disconnect();
    try {
      applyBaseline();          // per-font Y-shift on preview text
      applyLineGap();           // per-font line 1 ↔ line 2 spacing
      applyInputPad();          // per-font input box height
      applyLetterSpacing();     // per-font tracking (must run before autofit)
      autofitAnglePreviews();
      autofitInputs();
    } finally {
      if (__efxObserver) {
        __efxObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
  }

  // Debounce so rapid input/resize events don't thrash measurements
  var autofitTimer = null;
  function scheduleAutofit() {
    if (autofitTimer) clearTimeout(autofitTimer);
    autofitTimer = setTimeout(autofitAll, 40);
  }

  /* ───────────────────────────────────────────────────────── */
  /* PICKER                                                     */
  /* ───────────────────────────────────────────────────────── */
  function buildFontPicker(field) {
    if (!field || field.dataset.efxFontPicker) return false;
    var control = field.querySelector('.control') || field;
    var select = control.querySelector('select');
    if (!select) return false;
    field.dataset.efxFontPicker = '1';

    // DPO REPLACES a field's <select> element when a restored row cascades —
    // the same thing that broke the size pills on jersey 2+. So never read or
    // write through the closure copy above: re-resolve from the persistent field
    // wrapper every time. Without this, changing the font on a DUPLICATED jersey
    // wrote the shopper's pick onto a detached node, the live select stayed
    // empty, and DPO flagged "Font Style" as missing at add to cart even though
    // the card showed as selected.
    function liveSelect() {
      return field.querySelector('select') || select;
    }

    field.classList.add('efx-no-label-bar');

    // Registry lookup (for category/family resolution)
    var byName = {};
    window.EFX_FONTS.forEach(function (f) { byName[f.name] = f; });

    // Build option list from the DPO select (source of truth)
    var options = [].slice.call(select.options)
      .filter(function (o) {
        return o.value && !/please\s*select/i.test(o.text);
      })
      .map(function (o) {
        var name = (o.text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
        var meta = byName[name] || {
          name: name,
          family: "'Inter', sans-serif",
        };
        return {
          value: o.value,
          name: name,
          displayName: meta.displayName || name,
          family: meta.family,
          pillY:    (typeof meta.pillY    === 'number') ? meta.pillY    : 0,
          pillSize: (typeof meta.pillSize === 'number') ? meta.pillSize : 15,
        };
      });
    if (!options.length) return false;

    select.style.display = 'none';

    // ── DOM (slider only, no chip row) ──
    var slider = document.createElement('div');
    slider.className = 'efx-font-slider';

    var track = document.createElement('div');
    track.className = 'efx-font-track';
    track.setAttribute('role', 'radiogroup');
    track.setAttribute('aria-label', 'Font style');
    track.innerHTML = options.map(function (o) {
      // Pill's font-family is on the button so the rendered name
      // shows the typeface itself. The inner span carries the
      // per-font fine-tuning: pillY (translateY) and pillSize
      // (font-size), both individually editable in the registry.
      var inlineFont = o.family.replace(/"/g, '&quot;');
      var nameStyles = 'font-size:' + o.pillSize + 'px;';
      if (o.pillY !== 0) {
        nameStyles += 'transform:translateY(' + o.pillY + 'px);';
      }
      return '<button type="button" class="efx-font-card" role="radio" ' +
             'aria-checked="false" ' +
             'data-value="' + escapeHtml(o.value) + '" ' +
             'data-name="' + escapeHtml(o.name) + '" ' +
             'data-family="' + escapeHtml(o.family) + '" ' +
             'style="font-family: ' + inlineFont + ';">' +
               '<span class="efx-font-card-name" style="' + nameStyles + '">' +
                 escapeHtml(o.displayName) +
               '</span>' +
             '</button>';
    }).join('');

    slider.appendChild(track);
    control.insertBefore(slider, control.firstChild);

    // ── Select handler ──
    function selectCard(card) {
      track.querySelectorAll('.efx-font-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('selected');
      card.setAttribute('aria-checked', 'true');

      // Re-resolved, not the closure copy — see liveSelect().
      var live = liveSelect();
      live.value = card.dataset.value;
      live.dispatchEvent(new Event('change', { bubbles: true }));
      live.dispatchEvent(new Event('input',  { bubbles: true }));

      applyFontEverywhere(card.dataset.family);
    }

    // Click-vs-drag detection
    var dragStartX = 0, dragStartScroll = 0, didDrag = false;
    track.addEventListener('mousedown', function (e) {
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      didDrag = false;
    });
    track.addEventListener('mousemove', function (e) {
      if (e.buttons !== 1) return;
      if (Math.abs(e.clientX - dragStartX) > 6) {
        didDrag = true;
        track.classList.add('efx-is-dragging');
        track.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
      }
    });
    var endDrag = function () {
      setTimeout(function () { track.classList.remove('efx-is-dragging'); }, 50);
    };
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    track.addEventListener('click', function (e) {
      if (didDrag) { didDrag = false; return; }
      var card = e.target.closest('.efx-font-card');
      if (card) selectCard(card);
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-font-card');
        if (card) { e.preventDefault(); selectCard(card); }
      }
    });

    // Preselect — try now, then retry on a short delay in case
    // DPO's product-title auto-select rule fires AFTER us. The
    // change event approach doesn't work because DPO's rule fires
    // before our listener attaches; polling catches the late value.
    // Blanking the select must un-highlight the cards, or a freshly added Team
    // Order jersey shows a font "chosen" that was never actually set.
    function clearFontCards() {
      track.querySelectorAll('.efx-font-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
    }

    function syncSelectedCard() {
      var v = liveSelect().value;
      if (!v) { clearFontCards(); return false; }
      var target = track.querySelector('.efx-font-card[data-value="' + v + '"]');
      if (!target) return false;
      if (target.classList.contains('selected')) return true;
      track.querySelectorAll('.efx-font-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      target.classList.add('selected');
      target.setAttribute('aria-checked', 'true');
      applyFontEverywhere(target.dataset.family);
      return true;
    }

    // Try immediately
    syncSelectedCard();
    // Retry on a short delay in case DPO sets the value after us
    setTimeout(syncSelectedCard, 100);
    setTimeout(syncSelectedCard, 400);
    setTimeout(syncSelectedCard, 1000);

    // Listen for programmatic select changes (e.g., DPO product-title
    // auto-select rules). When the underlying select changes via JS,
    // sync the card UI to match — selectCard handles user clicks but
    // never fires for programmatic .trigger('change') events.
    // Delegated on the persistent field wrapper, so it keeps working after DPO
    // swaps the <select> out — a closure-bound listener goes deaf at that point,
    // which is how a duplicated jersey ended up with a highlighted card and an
    // empty value.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT' && field.contains(e.target)) {
        syncSelectedCard();
      }
    }, true);

    select.addEventListener('change', function () {
      var liveVal = liveSelect().value;
      if (!liveVal) { clearFontCards(); return; }
      var target = track.querySelector('.efx-font-card[data-value="' + liveVal + '"]');
      if (!target) return;
      // Skip if already visually correct (avoid feedback loop)
      if (target.classList.contains('selected')) return;
      track.querySelectorAll('.efx-font-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      target.classList.add('selected');
      target.setAttribute('aria-checked', 'true');
      applyFontEverywhere(target.dataset.family);
    });

    return true;
  }

  /* ───────────────────────────────────────────────────────── */
  /* DOM REORDER                                                */
  /* ───────────────────────────────────────────────────────── */
  function reorderFields() {
    var fontField  = document.querySelector('[id^="dynamic_option_id_"][data-efx-font-picker]');
    var angleField = findFieldByLabel(FIELD_PATTERN_ANGLE);
    if (!fontField || !angleField) return false;
    if (fontField.dataset.efxRepositioned) return true;
    if (fontField === angleField.previousElementSibling) {
      fontField.dataset.efxRepositioned = '1';
      return true;
    }
    angleField.parentNode.insertBefore(fontField, angleField);
    fontField.dataset.efxRepositioned = '1';
    return true;
  }

  /* ───────────────────────────────────────────────────────── */
  /* LINE INPUT TAGGING                                         */
  /* Identifies which text input is First Line vs Second Line   */
  /* and tags them with .efx-line-1 / .efx-line-2 classes that  */
  /* the CSS uses to apply asymmetric vertical padding (so line */
  /* 1's text sits at the bottom of its box and line 2's at the */
  /* top, visually mimicking how a name+number prints).         */
  /* ───────────────────────────────────────────────────────── */
  function tagLineInputs() {
    [['1', FIELD_PATTERN_LINE_1], ['2', FIELD_PATTERN_LINE_2]].forEach(function (pair) {
      var n = pair[0], pattern = pair[1];
      var field = findFieldByLabel(pattern);
      if (!field) return;
      var input = field.querySelector(
        'input.product-custom-option, textarea.product-custom-option'
      );
      if (!input) return;
      if (!input.classList.contains('efx-line-' + n)) {
        input.classList.add('efx-line-' + n);
      }
      // Mobile keyboard tuning (one-time per input).
      // - autocapitalize="none" stops iOS/Android from auto-uppercasing
      //   (iOS specifically prefers "none" over "off")
      // - autocorrect="off" disables iOS name correction
      // - autocomplete="off" stops iOS from inferring this is a name
      //   field and re-enabling capitalization heuristically
      // - inputmode="text" forces the standard text keyboard
      // - spellcheck=false hides red squiggly underlines
      // Set BOTH the attribute and the property — iOS Safari has
      // historically read one or the other depending on version.
      if (input.dataset.efxMobileTuned !== '1') {
        input.setAttribute('autocapitalize', 'none');
        input.setAttribute('autocorrect',    'off');
        input.setAttribute('autocomplete',   'off');
        input.setAttribute('inputmode',      'text');
        input.setAttribute('spellcheck',     'false');
        try {
          input.autocapitalize = 'none';
          input.autocorrect    = 'off';
          input.autocomplete   = 'off';
          input.spellcheck     = false;
        } catch (e) { /* property setter not supported, ignore */ }
        input.dataset.efxMobileTuned = '1';
      }
      // Re-apply on focus (capture phase so we run BEFORE any
      // DPO/Shopify focus handlers that may flip the attribute back).
      // iOS reads autocapitalize when the keyboard opens, so the
      // last write before the keyboard appears wins.
      if (input.dataset.efxFocusBound !== '1') {
        input.addEventListener('focusin', function () {
          input.setAttribute('autocapitalize', 'none');
          try { input.autocapitalize = 'none'; } catch (e) {}
        }, true);
        input.dataset.efxFocusBound = '1';
      }
    });
  }

  /* ───────────────────────────────────────────────────────── */
  /* CASE PRESERVATION FOR ANGLE PREVIEW                        */
  /* Phase 4 ships a syncPreviews() that does .toUpperCase() on */
  /* the input value before writing it to the angle preview.    */
  /* That makes the preview always render uppercase even when   */
  /* the customer typed mixed case — annoying for script fonts. */
  /* This function re-writes the preview text from the raw      */
  /* input value, running AFTER Phase 4's handler (we delegate  */
  /* at the document level, which fires later in the bubble).   */
  /* ───────────────────────────────────────────────────────── */
  function syncPreviewCase() {
    ['1', '2'].forEach(function (n) {
      var input = document.querySelector('.efx-line-' + n);
      if (!input) return;
      var v = input.value || '';
      var expected = (n === '1') ? (v || 'YOUR NAME') : v;
      var previews = document.querySelectorAll('.efx-angle-preview-' + n);
      previews.forEach(function (el) {
        // Guard: only mutate when there's an actual change. Without
        // this, calling syncPreviewCase from a MutationObserver
        // callback would rewrite the same textContent on every fire
        // and recurse infinitely.
        if (el.textContent !== expected) {
          el.textContent = expected;
        }
        if (n === '2') {
          var shouldBeEmpty = !v;
          if (el.classList.contains('efx-empty') !== shouldBeEmpty) {
            el.classList.toggle('efx-empty', shouldBeEmpty);
          }
        }
      });
    });
  }

  /* ───────────────────────────────────────────────────────── */
  /* TRIGGER WIRING — autofit on input, resize, font load       */
  /* ───────────────────────────────────────────────────────── */
  function attachAutofitTriggers() {
    if (document.body.dataset.efxAutofitWired) return;
    document.body.dataset.efxAutofitWired = '1';

    // Typing in either name-line input
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches && t.matches(
        '.efx-text-wrap input.product-custom-option, ' +
        '.efx-text-wrap textarea.product-custom-option'
      )) {
        // Restore the user's typed case in the angle preview
        // (Phase 4 will have just uppercased it).
        syncPreviewCase();
        scheduleAutofit();
      }
    });

    // Viewport changes
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(autofitAll, 150);
    });

    // Custom fonts may not be loaded yet on first paint; refit
    // once they are so measurements reflect real glyph metrics.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(autofitAll);
    }
  }

  /* ───────────────────────────────────────────────────────── */
  /* BOOTSTRAP                                                  */
  /* ───────────────────────────────────────────────────────── */
  function tryInit() {
    var field = findFieldByLabel(FIELD_PATTERN_FONT);
    if (!field) return false;
    var built = buildFontPicker(field);
    reorderFields();
    tagLineInputs();      // ← add .efx-line-1 / .efx-line-2 classes
    syncPreviewCase();    // ← restore case on initial render
    attachAutofitTriggers();
    scheduleAutofit();
    return built;
  }

  function start() {
    tryInit();
    __efxObserver = new MutationObserver(function () {
      tryInit();
      if (window.__efxCurrentFont) {
        applyFontImportant(window.__efxCurrentFont);
      }
      scheduleAutofit();
    });
    __efxObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      if (__efxObserver) {
        __efxObserver.disconnect();
        __efxObserver = null;
      }
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 6 (v13)
   ============================================================
   Where to paste: REPLACE the previous Phase 6 block at the
                   bottom of efx-dpo-customizations.js.

   v13 vs v12:
     • Custom Logo accordion now wraps #1 too (loop n = 1..4
       instead of 2..4) so EVERY upload is hidden behind a
       "Click to select" header.
     • Header now includes a "Click to select" pill next to
       the chevron, matching Phase 9 visual style.
     • Chevron rotates 90° (right → down) instead of 180°
       to match the Phase 9 expand pattern.

   Pairs with Phase 6 CSS v13.
   ============================================================ */

(function () {
  'use strict';

  var CARD_FIELDS = [
    /^name\s+on\s+back/i,
    /^matching\s+(pants|shorts|skort)/i,
    /^matching\s+solid\s+color/i,
    /^proof\s+request/i,
    /^add\s+custom\s+logo/i,
    /^add\s+additional/i,
  ];

  var BOTTOM_TYPE_FIELDS = [
    /^pants,?\s*shorts?,?\s*or\s+skort/i,
  ];

  var CUSTOM_SELECT_FIELDS = [
    /^solid\s+color\s*:?\s*$/i,
    /^(pants|shorts|skort)\s+(waist\s+size|waist|inseam|length|size)/i,
    /^custom\s+logo\s+quantity/i,
    /^custom\s+logo\s+#?\d+\s*[-—]\s*placement/i,
  ];

  var UMBRELLA_CHILD_PATTERNS = [
    /^matching\s+solid\s+color/i,
    /^solid\s+color\s*:?\s*$/i,
    /^pants,?\s*shorts?,?\s*or\s+skort/i,
    /^(pants|shorts|skort)\s+(waist\s+size|waist|inseam|length|size)/i,
    /^custom\s+logo/i,
  ];

  function getBottomTypeSize(label) {
    var key = (label || '').toLowerCase().trim();
    if (/pant/.test(key))  return '28″–42″ waist · 28″–36″ inseam';
    if (/short/.test(key)) return '28″–42″ waist · 7″–11″ inseam';
    if (/skort/.test(key)) return 'XXS–3XL · Extended options available';
    return '';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function normalize(text) {
    return (text || '').trim().replace(/[\s\u00A0]+/g, ' ');
  }

  function formatPrice(p) {
    return (p % 1 === 0) ? p.toFixed(0) : p.toFixed(2);
  }

  function findFieldsByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    var titleSelector = 'label, .title, .field-title, .option-label, .option-name, h1, h2, h3, h4, h5, header';
    var matches = [];
    for (var i = 0; i < fields.length; i++) {
      var candidates = fields[i].querySelectorAll(titleSelector);
      for (var j = 0; j < Math.min(3, candidates.length); j++) {
        if (candidates[j].closest('.efx-time-card, .efx-time-stack, .efx-select')) continue;
        var clone = candidates[j].cloneNode(true);
        clone.querySelectorAll('em, span, a, input, sup, sub').forEach(function (n) { n.remove(); });
        var text = normalize(clone.textContent);
        if (pattern.test(text)) {
          matches.push(fields[i]);
          break;
        }
      }
    }
    return matches;
  }

  function parseInput(input) {
    var label = document.querySelector('label[for="' + input.id + '"]') ||
                input.closest('label');
    var raw = '';
    if (label) {
      var clone = label.cloneNode(true);
      clone.querySelectorAll('input').forEach(function (n) { n.remove(); });
      raw = normalize(clone.textContent);
    }
    var displayLabel = raw.replace(/\s*\+\$[\d.]+\s*$/, '').trim();
    var priceMatch = raw.match(/\+\$([\d.]+)/);
    var price = priceMatch ? parseFloat(priceMatch[1]) : 0;
    return {
      value:   input.value,
      inputId: input.id,
      type:    input.type,
      label:   displayLabel.toUpperCase(),
      price:   price,
    };
  }

  /* ─────────────────────────────────────────────────────────── */
  /* Yes/No row-card stack                                      */
  /* ─────────────────────────────────────────────────────────── */
  function buildCardStack(field) {
    if (!field || field.dataset.efxCardPicker) return false;
    var control = field.querySelector('.control') || field;
    var inputs = control.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    if (!inputs.length) return false;
    field.dataset.efxCardPicker = '1';

    var isCheckbox = inputs[0].type === 'checkbox';
    var options = [].slice.call(inputs).map(parseInput);

    inputs.forEach(function (r) {
      r.style.display = 'none';
      var lbl = document.querySelector('label[for="' + r.id + '"]') ||
                r.closest('label');
      if (lbl) lbl.style.display = 'none';
    });

    options.sort(function (a, b) {
      if (/^no$/i.test(a.label) && !/^no$/i.test(b.label)) return -1;
      if (/^no$/i.test(b.label) && !/^no$/i.test(a.label)) return 1;
      return 0;
    });

    var stack = document.createElement('div');
    stack.className = 'efx-time-stack';
    // Two-up layout for Yes/No (saves vertical space — both
    // pills sit side-by-side on one row instead of stacking).
    // Inline styles with !important beat any column-layout
    // rule from Phase 2.2 or other phases.
    var isTwoUp = options.length === 2;
    if (isTwoUp) {
      stack.classList.add('efx-time-stack--row');
      stack.style.setProperty('display', 'flex', 'important');
      stack.style.setProperty('flex-direction', 'row', 'important');
      stack.style.setProperty('gap', '8px', 'important');
      stack.style.setProperty('width', '100%', 'important');
    }
    stack.innerHTML = options.map(function (o) {
      var priceHtml = o.price ? '<div class="efx-time-price">+$' + (o.price % 1 === 0 ? o.price.toFixed(0) : o.price.toFixed(2)) + '</div>' : '';
      return '<div class="efx-time-card" data-input-id="' + escapeHtml(o.inputId) + '" role="button" tabindex="0">' +
               '<div class="efx-time-radio"><span class="efx-time-radio-dot"></span></div>' +
               '<div class="efx-time-info">' +
                 '<div class="efx-time-label">' + escapeHtml(o.label) + '</div>' +
               '</div>' +
               priceHtml +
             '</div>';
    }).join('');

    control.insertBefore(stack, control.firstChild);

    // For the two-up Yes/No layout, force each card to share
    // the row equally. Inline !important beats any width:100%
    // rule that might be on .efx-time-card elsewhere.
    if (isTwoUp) {
      stack.querySelectorAll('.efx-time-card').forEach(function (card) {
        card.style.setProperty('flex', '1 1 0', 'important');
        card.style.setProperty('min-width', '0', 'important');
        card.style.setProperty('width', 'auto', 'important');
      });
    }

    function selectCard(card) {
      if (card.classList.contains('efx-card-disabled')) return;
      var input = document.getElementById(card.dataset.inputId);
      if (!input) return;
      if (isCheckbox) {
        input.checked = !input.checked;
        card.classList.toggle('selected', input.checked);
      } else {
        stack.querySelectorAll('.efx-time-card').forEach(function (c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        input.checked = true;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('click',  { bubbles: true }));
    }

    stack.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-time-card');
      if (card) selectCard(card);
    });
    stack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-time-card');
        if (card) { e.preventDefault(); selectCard(card); }
      }
    });

    inputs.forEach(function (r) {
      if (r.checked) {
        var pre = stack.querySelector('[data-input-id="' + r.id + '"]');
        if (pre) pre.classList.add('selected');
      }
    });

    // Mirror external changes (e.g. DPO's Extra JS rule disabling
    // "No" and checking "Yes" when PBA/PWBA is selected) onto cards.
    function syncCardsToInputs() {
      inputs.forEach(function (r) {
        var card = stack.querySelector('[data-input-id="' + r.id + '"]');
        if (!card) return;
        card.classList.toggle('selected', r.checked);
        if (r.disabled) {
          card.classList.add('efx-card-disabled');
          card.setAttribute('aria-disabled', 'true');
        } else {
          card.classList.remove('efx-card-disabled');
          card.removeAttribute('aria-disabled');
        }
      });
    }

    inputs.forEach(function (r) {
      new MutationObserver(syncCardsToInputs).observe(r, {
        attributes: true,
        attributeFilter: ['checked', 'disabled']
      });
    });

    document.addEventListener('change', function (e) {
      if (e.target && inputs.indexOf && Array.prototype.indexOf.call(inputs, e.target) !== -1) {
        setTimeout(syncCardsToInputs, 50);
      } else if (e.target && e.target.tagName === 'SELECT') {
        // PBA/PWBA selection lives on logo position <select>s, so any
        // select change might trigger DPO's Extra JS rule.
        setTimeout(syncCardsToInputs, 100);
      }
    }, true);

    setTimeout(syncCardsToInputs, 200);
    setTimeout(syncCardsToInputs, 800);

    return true;
  }

  /* ─────────────────────────────────────────────────────────── */
  /* Bottom-type row cards                                      */
  /* ─────────────────────────────────────────────────────────── */
  function buildBottomTypeRow(field) {
    if (!field || field.dataset.efxBottomTypeRow) return false;
    var select = field.querySelector('select');
    if (!select) return false;

    var rawOptions = [].slice.call(select.options).filter(function (o) {
      var t = normalize(o.text);
      return o.value && !/please\s+select|^--/i.test(t);
    });
    if (!rawOptions.length) return false;

    field.dataset.efxBottomTypeRow = '1';

    var items = rawOptions.map(function (o) {
      var raw = normalize(o.text);
      var label = raw.replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      var priceMatch = raw.match(/\+\$([\d.]+)/);
      var price = priceMatch ? parseFloat(priceMatch[1]) : 0;
      return { value: o.value, label: label, price: price };
    });

    select.style.display = 'none';

    var stack = document.createElement('div');
    stack.className = 'efx-time-stack';
    stack.innerHTML = items.map(function (it) {
      var sizing = getBottomTypeSize(it.label);
      var sizingHtml = sizing ? '<div class="efx-bottom-sizing">' + escapeHtml(sizing) + '</div>' : '';
      var priceHtml = it.price ? '<div class="efx-time-price">+$' + (it.price % 1 === 0 ? it.price.toFixed(0) : it.price.toFixed(2)) + '</div>' : '';
      return '<div class="efx-time-card" data-value="' + escapeHtml(it.value) + '" role="button" tabindex="0">' +
               '<div class="efx-time-radio"><span class="efx-time-radio-dot"></span></div>' +
               '<div class="efx-time-info">' +
                 '<div class="efx-time-label">' + escapeHtml(it.label.toUpperCase()) + '</div>' +
                 sizingHtml +
               '</div>' +
               priceHtml +
             '</div>';
    }).join('');

    select.parentNode.insertBefore(stack, select);

    function selectCard(card) {
      stack.querySelectorAll('.efx-time-card').forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      select.value = card.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    stack.addEventListener('click', function (e) {
      var card = e.target.closest('.efx-time-card');
      if (card) selectCard(card);
    });
    stack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.efx-time-card');
        if (card) { e.preventDefault(); selectCard(card); }
      }
    });

    if (select.value) {
      var pre = stack.querySelector('[data-value="' + select.value + '"]');
      if (pre) pre.classList.add('selected');
    }

    return true;
  }

  /* ─────────────────────────────────────────────────────────── */
  /* Custom <select>                                            */
  /* ─────────────────────────────────────────────────────────── */
  function closeAllSelectPanels(exceptTrigger) {
    document.querySelectorAll('.efx-select-trigger[aria-expanded="true"]').forEach(function (t) {
      if (t === exceptTrigger) return;
      t.setAttribute('aria-expanded', 'false');
      var p = t.nextElementSibling;
      if (p && p.classList.contains('efx-select-panel')) p.hidden = true;
    });
  }

  if (!window.__efxSelectOutsideBound) {
    window.__efxSelectOutsideBound = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.efx-select')) closeAllSelectPanels(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllSelectPanels(null);
    });
  }

  function buildCustomSelect(field) {
    if (!field || field.dataset.efxCustomSelect) return false;
    var select = field.querySelector('select');
    if (!select) return false;

    var rawOptions = [].slice.call(select.options);
    if (!rawOptions.length) return false;

    var items = rawOptions.map(function (o) {
      var raw = normalize(o.text);
      var isPlaceholder = !o.value || /please\s+select|^--/i.test(raw);
      var label = raw.replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      var priceMatch = raw.match(/\+\$([\d.]+)/);
      var price = priceMatch ? parseFloat(priceMatch[1]) : 0;
      return { value: o.value, label: label, price: price, isPlaceholder: isPlaceholder };
    });

    var placeholderItem = items.find(function (it) { return it.isPlaceholder; });
    var realItems = items.filter(function (it) { return !it.isPlaceholder; });
    if (!realItems.length) return false;

    field.dataset.efxCustomSelect = '1';

    var placeholderText = (placeholderItem && placeholderItem.label) || '— Select —';

    select.style.display = 'none';

    var wrapper = document.createElement('div');
    wrapper.className = 'efx-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'efx-select-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML =
      '<span class="efx-select-value placeholder">' + escapeHtml(placeholderText) + '</span>' +
      '<svg class="efx-select-chevron" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M7 10l5 5 5-5z" fill="currentColor"/>' +
      '</svg>';
    var valueSpan = trigger.querySelector('.efx-select-value');

    var panel = document.createElement('div');
    panel.className = 'efx-select-panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    panel.innerHTML = realItems.map(function (it) {
      var priceHtml = it.price ? '<span class="efx-select-option-price">+$' + formatPrice(it.price) + '</span>' : '';
      return '<div class="efx-select-option" role="option" data-value="' + escapeHtml(it.value) + '">' +
               '<span class="efx-select-option-label">' + escapeHtml(it.label) + '</span>' +
               priceHtml +
             '</div>';
    }).join('');

    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);
    select.parentNode.insertBefore(wrapper, select);

    function syncValueFromSelect() {
      var current = realItems.find(function (it) { return it.value === select.value; });
      panel.querySelectorAll('.efx-select-option').forEach(function (o) { o.classList.remove('selected'); });
      if (current) {
        valueSpan.textContent = current.label;
        valueSpan.classList.remove('placeholder');
        var match = panel.querySelector('[data-value="' + CSS.escape(current.value) + '"]');
        if (match) match.classList.add('selected');
      } else {
        valueSpan.textContent = placeholderText;
        valueSpan.classList.add('placeholder');
      }
    }
    syncValueFromSelect();

    function openPanel() {
      closeAllSelectPanels(trigger);
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
    function closePanel() {
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
    function togglePanel() {
      if (trigger.getAttribute('aria-expanded') === 'true') closePanel();
      else openPanel();
    }
    function selectOptionEl(opt) {
      select.value = opt.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncValueFromSelect();
      closePanel();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); togglePanel();
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePanel(); }
    });
    panel.addEventListener('click', function (e) {
      var opt = e.target.closest('.efx-select-option');
      if (opt) selectOptionEl(opt);
    });
    select.addEventListener('change', syncValueFromSelect);

    return true;
  }

  /* ─────────────────────────────────────────────────────────── */
  /* Custom Logo accordions (for #1, #2, #3, #4)                */
  /* v13: wraps #1 too; adds "Click to select" pill; chevron     */
  /* rotates 90° instead of 180° to match Phase 9.              */
  /* ─────────────────────────────────────────────────────────── */
  function buildCustomLogoAccordions() {
    for (var n = 1; n <= 4; n++) {
      var uploadPattern = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*:?\\s*$', 'i');
      var placementPattern = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*[-—]\\s*placement', 'i');

      var uploadFields = findFieldsByLabel(uploadPattern);
      var placementFields = findFieldsByLabel(placementPattern);
      if (!uploadFields.length) continue;

      var uploadField = uploadFields[0];
      if (uploadField.dataset.efxClogoAccordion) continue;

      var placementField = placementFields[0] || null;

      uploadField.dataset.efxClogoAccordion = '1';
      if (placementField) placementField.dataset.efxClogoAccordion = '1';

      // Hide the upload field's own label — the accordion header
      // already shows "CUSTOM LOGO #N", so the inner label is a
      // duplicate.
      uploadField.classList.add('efx-clogo-hide-inner-label');

      var accordion = document.createElement('div');
      accordion.className = 'efx-clogo-accordion';
      accordion.dataset.logoNum = n;

      var header = document.createElement('button');
      header.type = 'button';
      header.className = 'efx-clogo-accordion-header';
      header.setAttribute('aria-expanded', 'false');
      header.innerHTML =
        '<span class="efx-clogo-accordion-title">CUSTOM LOGO #' + n + '</span>' +
        '<span class="efx-clogo-accordion-pill">Click to select</span>' +
        '<svg class="efx-clogo-accordion-chevron" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M9 6l6 6-6 6z" fill="currentColor"/>' +
        '</svg>';

      var body = document.createElement('div');
      body.className = 'efx-clogo-accordion-body efx-clogo-collapsed';

      accordion.appendChild(header);
      accordion.appendChild(body);

      uploadField.parentNode.insertBefore(accordion, uploadField);
      body.appendChild(uploadField);
      if (placementField) body.appendChild(placementField);

      header.addEventListener('click', function () {
       var expanded = this.getAttribute('aria-expanded') === 'true';
        var willOpen = !expanded;
        this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        this.nextElementSibling.classList.toggle('efx-clogo-collapsed', !willOpen);
      });
    }
  }

  // Hide an accordion when DPO hides its underlying field
  // (e.g. Quantity = 2 → Custom Logo #3 and #4 fields go
  // display:none, so their accordions disappear too).
  function syncAccordionVisibility() {
    document.querySelectorAll('.efx-clogo-accordion').forEach(function (acc) {
      var body = acc.querySelector('.efx-clogo-accordion-body');
      if (!body) return;
      var firstField = body.querySelector('[id^="dynamic_option_id_"]');
      if (!firstField) { acc.style.display = 'none'; return; }
      var dpoHidden = firstField.style.display === 'none';
      acc.style.display = dpoHidden ? 'none' : '';
    });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* Umbrella label-bar — class + inline-style strip            */
  /* ─────────────────────────────────────────────────────────── */
  function tagUmbrellaChildren() {
    UMBRELLA_CHILD_PATTERNS.forEach(function (p) {
      findFieldsByLabel(p).forEach(function (field) {
        if (field.dataset.efxPhase6Umbrella === '1') return;

        field.classList.add('efx-no-label-bar');
        field.dataset.efxPhase6Umbrella = '1';

        var titleSel = 'label, .option-name, .field-title, .title, .option-label, h1, h2, h3, h4, h5';
        var titleEls = field.querySelectorAll(titleSel);
        for (var i = 0; i < Math.min(3, titleEls.length); i++) {
          var el = titleEls[i];
          if (el.closest('.efx-time-card, .efx-select, .control, select, option')) continue;
          el.style.borderBottom = '0';
          el.style.paddingBottom = '0';
        }
      });
    });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* BOOTSTRAP                                                  */
  /* ─────────────────────────────────────────────────────────── */
  function tryInit() {
    CARD_FIELDS.forEach(function (pattern) {
      findFieldsByLabel(pattern).forEach(buildCardStack);
    });
    BOTTOM_TYPE_FIELDS.forEach(function (pattern) {
      findFieldsByLabel(pattern).forEach(buildBottomTypeRow);
    });
    buildCustomLogoAccordions();
    CUSTOM_SELECT_FIELDS.forEach(function (pattern) {
      findFieldsByLabel(pattern).forEach(buildCustomSelect);
    });
    tagUmbrellaChildren();
    syncAccordionVisibility();
  }

  var pending = false;
  function scheduleInit() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      tryInit();
    }, 100);
  }

  function start() {
    tryInit();

    var observer = new MutationObserver(scheduleInit);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']  // catches DPO setting display:none on fields
    });
    setTimeout(function () { observer.disconnect(); }, 300000); // 5 min

    document.body.addEventListener('change', scheduleInit, true);
    document.body.addEventListener('click',  scheduleInit, true);

    [2000, 5000, 10000, 30000, 60000].forEach(function (ms) {
      setTimeout(tryInit, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 10: PBA/PWBA business-rule enforcement
   ============================================================
   Not configured in DPO admin, so enforced here:
     • Any logo position holds PBA or PWBA  →  Name on Back = Yes,
                                                Custom Logo fields hidden
     • No PBA/PWBA anywhere                 →  Custom Logo fields restored
                                                (Name on Back left alone)
   ============================================================ */
(function () {
  'use strict';

  var LOGO_LABEL_PATTERNS = [
    /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
    /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i,
  ];
  var PBA_PWBA_PATTERN = /pba|pwba/i;

  function findFields(pred) {
    return [].slice.call(document.querySelectorAll('[id^="dynamic_option_id_"]')).filter(pred);
  }
  function findFieldByLabel(pattern) {
    return findFields(function (f) {
      var lbl = f.querySelector('label');
      return lbl && pattern.test(lbl.textContent.trim());
    })[0] || null;
  }
  function isLogoField(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return false;
    var text = lbl.textContent.trim();
    return LOGO_LABEL_PATTERNS.some(function (p) { return p.test(text); });
  }

  function isPbaPwbaSelected() {
    var logoFields = findFields(isLogoField);
    for (var i = 0; i < logoFields.length; i++) {
      var sel = logoFields[i].querySelector('.control select');
      if (!sel || !sel.value) continue;
      var opt = sel.options[sel.selectedIndex];
      if (opt && PBA_PWBA_PATTERN.test(opt.textContent)) return true;
    }
    return false;
  }

  function setNameOnBackYes() {
    var field = findFieldByLabel(/^name\s+on\s+back/i);
    if (!field) return;
    var yesRadio = [].slice.call(field.querySelectorAll('input[type="radio"]'))
      .find(function (r) {
        var lbl = document.querySelector('label[for="' + r.id + '"]') || r.closest('label');
        if (!lbl) return false;
        var clone = lbl.cloneNode(true);
        clone.querySelectorAll('input').forEach(function (n) { n.remove(); });
        var text = clone.textContent.trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
        return /^yes$/i.test(text);
      });
    if (yesRadio && !yesRadio.checked) {
      yesRadio.checked = true;
      yesRadio.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jQuery) window.jQuery(yesRadio).trigger('change');
    }
  }

  function toggleCustomLogos(hide) {
    [1, 2, 3, 4].forEach(function (n) {
      var pat      = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*:?\\s*$', 'i');
      var placePat = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*[-—]\\s*placement', 'i');
      [pat, placePat].forEach(function (p) {
        var f = findFieldByLabel(p);
        if (!f) return;
        f.style.display = hide ? 'none' : '';
        var acc = f.closest('.efx-clogo-accordion');
        if (acc) acc.style.display = hide ? 'none' : '';
      });
    });
    [/^add\s+custom\s+logo/i, /^custom\s+logo\s+quantity/i].forEach(function (p) {
      var f = findFieldByLabel(p);
      if (f) f.style.display = hide ? 'none' : '';
    });
  }

  function applyRules() {
    if (isPbaPwbaSelected()) {
      setNameOnBackYes();
      toggleCustomLogos(true);
    } else if (!(window.efxHasTag && window.efxHasTag('dpo-bowling-neon'))) {
      // Don't un-hide custom logos on Neon — Phase 13 keeps them hidden there.
      // (Phase 10 firing toggleCustomLogos(false) on Neon was re-showing them
      // on its 800/2500ms timers, which is the "custom logo re-appears" bug.)
      toggleCustomLogos(false);
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('[id^="dynamic_option_id_"]');
    if (!field || !isLogoField(field)) return;
    setTimeout(applyRules, 50);
  }, true);

  function start() {
    setTimeout(applyRules, 800);
    setTimeout(applyRules, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 10b: Right Sleeve BowlTV → Name on Back
   ============================================================
   Mirrors DPO's Extra JS rule which has proven unreliable in
   this environment. When PBA/PWBA BowlTV is selected on Right
   Sleeve specifically, disable the "No" radio on Name on Back
   (forcing Yes). Phase 6's card mirror handles the visual.
   ============================================================ */
(function () {
  'use strict';

  function applyBowlTVRule() {
    var rightSleeve = document.querySelector('#dynamic_option_id_1014 select');
    if (!rightSleeve) return;
    var opt = rightSleeve.options[rightSleeve.selectedIndex];
    var noRadio = document.getElementById('options_1016');
    if (!noRadio) return;

    var isBowlTV = !!(rightSleeve.value && opt && opt.config &&
                     opt.config.title && opt.config.title.indexOf('BowlTV') > -1);

    if (isBowlTV) {
      if (!noRadio.disabled) {
        noRadio.disabled = true;
        // Trigger our Phase 6 mirror by firing the same kind of
        // change DPO would have. attributeFilter watches 'disabled',
        // so the prop change alone should trigger it, but a manual
        // event is belt-and-suspenders.
        if (window.jQuery) window.jQuery(noRadio).trigger('change');
      }
      // Also ensure Yes is checked (Phase 10's setNameOnBackYes
      // handles this for all logo positions; this is the Right
      // Sleeve specific path).
      var yesRadio = document.getElementById('options_1016_2');
      if (yesRadio && !yesRadio.checked) {
        yesRadio.checked = true;
        yesRadio.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.jQuery) window.jQuery(yesRadio).trigger('change');
      }
    } else {
      if (noRadio.disabled) {
        noRadio.disabled = false;
        if (window.jQuery) window.jQuery(noRadio).trigger('change');
      }
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('#dynamic_option_id_1014');
    if (!field) return;
    setTimeout(applyBowlTVRule, 30);
  }, true);

  // Initial passes
  setTimeout(applyBowlTVRule, 800);
  setTimeout(applyBowlTVRule, 2500);
})();

/* ============================================================
   EFX × DPO — PHASE 11 v2: Generic field visibility engine
   ============================================================
   Reads each field's visibility_condition + visibility_action
   from window.dpoOptions.options, evaluates by reading the DOM
   directly (NOT is_selected, which DPO isn't updating), and
   resolves "field":N references via internal_id.
   ============================================================ */
(function () {
  'use strict';

  function normTitle(s) {
    if (s == null) return '';
    return String(s)
      .replace(/\(.*?\)/g, '')
      .replace(/[\/\\]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findFieldByInternalId(internalId) {
    if (!window.dpoOptions || !window.dpoOptions.options) return null;
    for (var k in window.dpoOptions.options) {
      var f = window.dpoOptions.options[k];
      if (!f) continue;
      if (Number(f.internal_id) === Number(internalId)) return { field: f, idx: k };
    }
    return null;
  }

  function findDomField(f) {
    if (!f) return null;
    var lookFor = normTitle((f.title || '').replace(/:$/, ''));
    if (!lookFor) return null;
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var lbl = fields[i].querySelector('label');
      if (!lbl) continue;
      // Strip injected anchor/link text (e.g. "Hover for sizing chart",
      // "Hover for info") before comparing.
      var clone = lbl.cloneNode(true);
      clone.querySelectorAll('a').forEach(function (n) { n.remove(); });
      if (normTitle(clone.textContent.replace(/:$/, '')) === lookFor) return fields[i];
    }
    return null;
  }

  // NEW: collect ALL checked titles (handles multi-select Size Type)
function getSelectedTitles(fieldIdx) {
  var f = window.dpoOptions && window.dpoOptions.options && window.dpoOptions.options[fieldIdx];
  if (!f) return [];
  var dom = findDomField(f);
  if (!dom) return [];
  var titles = [];

  var s = dom.querySelector('select');
  if (s && s.value) {
    if (f.items) for (var k in f.items)
      if (String(f.items[k].option_type_id) === String(s.value)) { titles.push(f.items[k].title); return titles; }
    var opt = s.options[s.selectedIndex];
    if (opt) titles.push(opt.text.replace(/\s*\+\$.*$/, '').trim());
    return titles;
  }

  var list = dom.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
  for (var ci = 0; ci < list.length; ci++) {
    var checked = list[ci], matched = null;
    if (f.items) for (var k2 in f.items)
      if (String(f.items[k2].option_type_id) === String(checked.value)) { matched = f.items[k2].title; break; }
    if (!matched) {
      var clbl = document.querySelector('label[for="' + checked.id + '"]') || checked.closest('label');
      if (clbl) { var clone = clbl.cloneNode(true); clone.querySelectorAll('input').forEach(function (n){n.remove();}); matched = clone.textContent.replace(/\s*\+\$.*$/, '').trim(); }
    }
    if (matched) titles.push(matched);
  }
  return titles;
}

  function evalCondition(cond) {
    if (typeof cond === 'string') {
      try { cond = JSON.parse(cond); } catch (_) { return false; }
    }
    if (!cond || !cond.conditions || !cond.conditions.length) return false;
    var results = cond.conditions.map(function (c) {
      if (c.type !== 'field') return false;
      var entry = findFieldByInternalId(c.field);
      if (!entry) return false;
      var sels = getSelectedTitles(entry.idx).map(normTitle);
  var val  = normTitle(c.value);
  if (c.condition === 'is')     return sels.indexOf(val) !== -1;
  if (c.condition === 'is_not') return sels.indexOf(val) === -1;
      return false;
    });
    return cond.type === 'all'
      ? results.every(function (x) { return x; })
      : results.some(function (x)  { return x; });
  }

  // Is a PBA/PWBA logo currently selected on any logo field?
  function pbaSelectedNow() {
    var logoRe = /^(front\s*logo|left\s*chest|right\s*chest|left\s*sleeve|right\s*sleeve|lower\s*back)/i;
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var lbl = fields[i].querySelector('label');
      if (!lbl || !logoRe.test((lbl.textContent || '').trim())) continue;
      var sel = fields[i].querySelector('.control select') || fields[i].querySelector('select');
      if (sel && sel.selectedIndex >= 0) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && /pba|pwba/i.test(opt.text || '')) return true;
      }
    }
    return false;
  }

  function applyAllRules() {
    if (!window.dpoOptions || !window.dpoOptions.options) return;

    // The merchant disallows custom logos on PBA/PWBA and Neon designs. DPO is
    // NOT configured to enforce that — "Add Custom Logo" has an empty-condition
    // "hidden" rule (which evaluates to "show"), and Custom Logo #2-#4 have a
    // "visible when PBA" rule (the opposite of the intent). So we force EVERY
    // custom-logo field hidden whenever PBA is selected or the product is Neon.
    // Phase 11 is the only engine that writes display with !important, so doing
    // it here is what actually wins.
    var blockCustomLogos = pbaSelectedNow() ||
      (window.efxHasTag && window.efxHasTag('dpo-bowling-neon'));
    var customLogoRe = /^(add\s+)?custom\s*logo/;

    for (var k in window.dpoOptions.options) {
      var f = window.dpoOptions.options[k];
      if (!f || !f.visibility_condition) continue;

      var condTrue = evalCondition(f.visibility_condition);
      var shouldHide;
      if (f.visibility_action === 'hidden')      shouldHide = condTrue;
      else if (f.visibility_action === 'visible') shouldHide = !condTrue;
      else continue;

      var fTitle = normTitle((f.title || '').replace(/:$/, ''));
      if (blockCustomLogos && customLogoRe.test(fTitle)) shouldHide = true;

      var dom = findDomField(f);
      if (!dom) continue;

      dom.style.setProperty('display', shouldHide ? 'none' : 'block', 'important');

      // Mirror onto any Custom Logo accordion wrapper
      var acc = dom.closest('.efx-clogo-accordion');
      if (acc) acc.style.display = shouldHide ? 'none' : '';
    }
  }

  var debounceTimers = [];
  function schedule() {
    debounceTimers.forEach(clearTimeout);
    // Re-assert at several delays. DPO's own visibility engine still writes
    // display on these fields and can land AFTER our 80ms pass on a fast
    // size-type switch, leaving the new field stuck hidden. Each pass reads
    // current state and is idempotent, so the later passes correct any stomp.
    debounceTimers = [80, 400, 1200].map(function (d) {
      return setTimeout(applyAllRules, d);
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.tagName === 'SELECT' || e.target.tagName === 'INPUT') schedule();
  }, true);

  // Initial passes — catch DPO's late field rendering
  setTimeout(applyAllRules, 500);
  setTimeout(applyAllRules, 1500);
  setTimeout(applyAllRules, 3500);

  // Expose for manual testing in console
  window.__efxApplyRules = applyAllRules;
})();

/* ============================================================
   EFX × DPO — PHASE 12: SHIP-BY ESTIMATOR
   ============================================================
   Adds an estimated ship-by date row inside each Production
   Time Frame card (Phase 2.2). Respects weekends, US holidays,
   and a 12:00 PM Eastern same-day cutoff. Holidays are
   computed each year, so the list never needs maintenance.
   ============================================================ */
(function () {
  'use strict';

  var CONFIG = {
    // Keys match the label text Phase 2.2 renders inside
    // .efx-time-label (case-insensitive).
    options: {
      'standard': { minDays: 22, maxDays: 28, verb: 'between' },
      'express':  { minDays: 10, maxDays: 17, verb: 'between' },
      'rush':     { minDays: 5,  maxDays: 5,  verb: 'by' },
    },
    operatingDays: [1, 2, 3, 4, 5],     // Mon–Fri
    cutoffHour: 12,                      // 12:00 PM
    cutoffTimezone: 'America/New_York',  // DST-aware
  };

  /* ── HOLIDAYS (per-year, auto-computed) ─────────────────── */
  function nthWeekdayOfMonth(year, monthIdx, weekday, n) {
    var d = new Date(year, monthIdx, 1);
    var shift = (weekday - d.getDay() + 7) % 7;
    d.setDate(1 + shift + (n - 1) * 7);
    return d;
  }
  function lastWeekdayOfMonth(year, monthIdx, weekday) {
    var d = new Date(year, monthIdx + 1, 0);
    var shift = (d.getDay() - weekday + 7) % 7;
    d.setDate(d.getDate() - shift);
    return d;
  }
  function observedDate(year, monthIdx, day) {
    var d = new Date(year, monthIdx, day);
    if (d.getDay() === 6) d.setDate(d.getDate() - 1);       // Sat → Fri
    else if (d.getDay() === 0) d.setDate(d.getDate() + 1);  // Sun → Mon
    return d;
  }
  function getHolidaysForYear(y) {
    var thanksgiving = nthWeekdayOfMonth(y, 10, 4, 4);
    var blackFriday = new Date(thanksgiving);
    blackFriday.setDate(thanksgiving.getDate() + 1);
    return [
      observedDate(y, 0, 1),              // New Year's Day
      lastWeekdayOfMonth(y, 4, 1),        // Memorial Day
      observedDate(y, 6, 4),              // July 4
      nthWeekdayOfMonth(y, 8, 1, 1),      // Labor Day
      thanksgiving,
      blackFriday,
      observedDate(y, 11, 25),            // Christmas
    ];
  }

  /* ── DATE MATH ──────────────────────────────────────────── */
  function toISODate(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }
  var holidayCache = {};
  function isHoliday(d) {
    var y = d.getFullYear();
    if (!holidayCache[y]) {
      holidayCache[y] = new Set(getHolidaysForYear(y).map(toISODate));
    }
    return holidayCache[y].has(toISODate(d));
  }
  function isBusinessDay(d) {
    if (CONFIG.operatingDays.indexOf(d.getDay()) === -1) return false;
    if (isHoliday(d)) return false;
    return true;
  }
  function addBusinessDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }
  function getEasternNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: CONFIG.cutoffTimezone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
    var parts = fmt.formatToParts(new Date()).reduce(function (acc, p) {
      if (p.type !== 'literal') acc[p.type] = parseInt(p.value, 10);
      return acc;
    }, {});
    return {
      y: parts.year,
      m: parts.month - 1,
      d: parts.day,
      h: parts.hour === 24 ? 0 : parts.hour,
    };
  }
  function getStartDate() {
    var e = getEasternNow();
    var start = new Date(e.y, e.m, e.d);
    var pastCutoff = e.h >= CONFIG.cutoffHour;
    if (pastCutoff || !isBusinessDay(start)) {
      do { start.setDate(start.getDate() + 1); } while (!isBusinessDay(start));
    }
    return start;
  }

  /* ── FORMATTING ─────────────────────────────────────────── */
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function formatRange(earliest, latest) {
    var refYear = new Date().getFullYear();
    var eM = MONTHS[earliest.getMonth()], eD = earliest.getDate(), eY = earliest.getFullYear();
    var lM = MONTHS[latest.getMonth()],   lD = latest.getDate(),   lY = latest.getFullYear();
    if (earliest.getTime() === latest.getTime()) {
      return eM + ' ' + eD + (eY !== refYear ? ', ' + eY : '');
    }
    if (eM === lM && eY === lY) {
      return eM + ' ' + eD + '–' + lD + (eY !== refYear ? ', ' + eY : '');
    }
    return eM + ' ' + eD + (eY !== refYear ? ', ' + eY : '') +
           ' – ' + lM + ' ' + lD + (lY !== refYear ? ', ' + lY : '');
  }
  function computeEstimate(opt) {
    var start = getStartDate();
    var earliest = addBusinessDays(start, opt.minDays);
    var latest = addBusinessDays(start, opt.maxDays);
    return { range: formatRange(earliest, latest), verb: opt.verb };
  }

  /* ── DOM INJECTION (Phase 2.2-aware) ─────────────────────── */
  function injectEstimates() {
    var cards = document.querySelectorAll('.efx-time-card');
    if (!cards.length) return false;

    cards.forEach(function (card) {
      if (card.querySelector('.efx-ship-estimate')) return;  // dedup

      var labelEl = card.querySelector('.efx-time-label');
      var info    = card.querySelector('.efx-time-info');
      if (!labelEl || !info) return;

      var key = labelEl.textContent.trim().toLowerCase();
      var opt = CONFIG.options[key];
      if (!opt) return;  // not a Production Time card (e.g. Size Type reuse)

      var result = computeEstimate(opt);
      var div = document.createElement('div');
      div.className = 'efx-ship-estimate';
      div.innerHTML = 'Ships ' + result.verb + ' <strong>' + result.range + '</strong>';
      info.appendChild(div);
    });
    return true;
  }

  /* ── INIT ───────────────────────────────────────────────── */
  function findStack() {
    // Production Time Frame is option 1001
    var field = document.getElementById('dynamic_option_id_1001');
    if (!field) return null;
    return field.querySelector('.efx-time-stack');
  }

  function start() {
    injectEstimates();

    // Scoped observer — only watch the Production Time stack.
    // Falls back to body until the stack exists.
    function attachScopedObserver() {
      var stack = findStack();
      if (!stack) return false;
      new MutationObserver(injectEstimates).observe(stack, {
        childList: true, subtree: true
      });
      return true;
    }

    if (!attachScopedObserver()) {
      // Stack not built yet (Phase 2.2 hasn't run). Watch body
      // briefly until it appears, then swap to scoped observer.
      var bodyObs = new MutationObserver(function () {
        injectEstimates();
        if (attachScopedObserver()) bodyObs.disconnect();
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { bodyObs.disconnect(); }, 15000);
    }

    // Belt-and-suspenders retries for late-loading DPO renders.
    [500, 1500, 3500].forEach(function (ms) {
      setTimeout(injectEstimates, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 13: NEON CUSTOM LOGO DISABLE
   ============================================================
   On products tagged 'dpo-bowling-neon', grays out the entire
   custom logo section (Add Custom Logo Yes/No + accordions)
   and shows a disclaimer explaining the limitation with a
   contact email for exceptions.
   ============================================================ */
(function () {
  'use strict';

  if (!window.efxHasTag || !window.efxHasTag('dpo-bowling-neon')) return;

  var DISCLAIMER_HTML =
    'Custom logos aren\'t available on neon designs. ' +
    'For exceptions, please email ' +
    '<a href="mailto:admin@efx.co">admin@efx.co</a>.';

  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('label');
      if (!label) continue;
      var clone = label.cloneNode(true);
      clone.querySelectorAll('em, span, a, input').forEach(function (n) { n.remove(); });
      if (pattern.test((clone.textContent || '').trim())) return fields[i];
    }
    return null;
  }

  function applyNeonDisable() {
    // Target: the "Add Custom Logo" Yes/No field + accordions
    var addCustomLogoField = findFieldByLabel(/^add\s+custom\s+logo/i);
    if (!addCustomLogoField) return false;

    // Skip if we already injected (idempotent)
    if (addCustomLogoField.dataset.efxNeonDisabled === '1') return true;
    addCustomLogoField.dataset.efxNeonDisabled = '1';

    // Insert disclaimer above the Add Custom Logo field
    if (!document.querySelector('.efx-neon-disclaimer')) {
      var disclaimer = document.createElement('div');
      disclaimer.className = 'efx-preview-disclaimer efx-neon-disclaimer';
      disclaimer.innerHTML = DISCLAIMER_HTML;
      addCustomLogoField.parentNode.insertBefore(disclaimer, addCustomLogoField);
    }

    // Force "No" FIRST (before hiding) so a stale "Yes" can't carry through.
    var noRadio = addCustomLogoField.querySelector('input[type="radio"][value=""]') ||
                  addCustomLogoField.querySelector('input[type="radio"]:not([value])');
    if (noRadio && !noRadio.checked) {
      noRadio.checked = true;
      noRadio.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jQuery) window.jQuery(noRadio).trigger('change');
    }

    // HIDE the Add Custom Logo option outright on Neon (not merely grey it) —
    // Neon designs don't allow custom logos at all, and a greyed-but-present
    // field was still reachable in the cart "Configure" popup and the Team
    // Order builder ("custom logo appears when it shouldn't"). The disclaimer
    // inserted above still explains why.
    addCustomLogoField.classList.add('efx-neon-disabled');
    addCustomLogoField.style.setProperty('display', 'none', 'important');

    // Same for the Custom Logo Quantity field and every Custom Logo accordion.
    document.querySelectorAll('.efx-clogo-accordion').forEach(function (acc) {
      acc.classList.add('efx-neon-disabled');
      acc.style.setProperty('display', 'none', 'important');
    });
    var quantityField = findFieldByLabel(/^custom\s+logo\s+quantity/i);
    if (quantityField) {
      quantityField.classList.add('efx-neon-disabled');
      quantityField.style.setProperty('display', 'none', 'important');
    }

    return true;
  }

  function start() {
    applyNeonDisable();
    // Re-apply on later DOM mutations (DPO sometimes re-renders fields)
    var obs = new MutationObserver(function () {
      applyNeonDisable();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);

    // Belt-and-suspenders retries
    [800, 2500, 5000].forEach(function (ms) {
      setTimeout(applyNeonDisable, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 14: AUTO-ADVANCE CUSTOM LOGO ACCORDIONS
   ============================================================
   When a Custom Logo accordion has both file uploaded AND
   placement selected, auto-collapse it and auto-expand the
   next empty one in sequence. Mirrors Phase 9's logo
   accordion behavior.
   ============================================================ */
(function () {
  'use strict';

  function isAccordionFilled(accordion) {
    var body = accordion.querySelector('.efx-clogo-accordion-body');
    if (!body) return false;

    // File: a file input with a non-empty `.files` list
    var fileInput = body.querySelector('input[type="file"]');
    var hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

    // Placement: the underlying <select> has a non-empty value
    var placementSelect = body.querySelector('select');
    var hasPlacement = !!(placementSelect && placementSelect.value);

    return hasFile && hasPlacement;
  }

  function isAccordionVisible(accordion) {
    // The accordion's wrapper gets display:none when Custom Logo
    // Quantity is lower than its slot number (Phase 6 syncs this).
    return accordion.style.display !== 'none';
  }

  function setExpanded(accordion, expanded) {
    var header = accordion.querySelector('.efx-clogo-accordion-header');
    var body   = accordion.querySelector('.efx-clogo-accordion-body');
    if (!header || !body) return;
    header.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    body.classList.toggle('efx-clogo-collapsed', !expanded);
  }

  function isExpanded(accordion) {
    var header = accordion.querySelector('.efx-clogo-accordion-header');
    return header && header.getAttribute('aria-expanded') === 'true';
  }

  function autoAdvance(triggerAccordion) {
    if (!isAccordionFilled(triggerAccordion)) return;

    // Collapse the one that just got filled
    setExpanded(triggerAccordion, false);

    // Find the next visible accordion that's not yet filled
    var allAccordions = Array.prototype.slice.call(
      document.querySelectorAll('.efx-clogo-accordion')
    );
    var triggerIdx = allAccordions.indexOf(triggerAccordion);
    if (triggerIdx === -1) return;

    // Search forward from current+1, wrap to start if needed
    for (var i = 1; i <= allAccordions.length; i++) {
      var next = allAccordions[(triggerIdx + i) % allAccordions.length];
      if (!isAccordionVisible(next)) continue;
      if (isAccordionFilled(next)) continue;
      // Found the next empty one — expand it
      setExpanded(next, true);
      return;
    }
    // All accordions filled — leave the trigger collapsed, done
  }

  // Debounced trigger so file + placement events fire cleanly
  var advanceTimer = null;
  function scheduleAdvance(accordion) {
    clearTimeout(advanceTimer);
    advanceTimer = setTimeout(function () {
      autoAdvance(accordion);
    }, 150);
  }

  // Listen for changes inside any Custom Logo accordion
  document.addEventListener('change', function (e) {
    var accordion = e.target.closest && e.target.closest('.efx-clogo-accordion');
    if (!accordion) return;

    // Only react to inputs we care about: file or select
    var t = e.target;
    if (t.type === 'file' || t.tagName === 'SELECT') {
      // Wait briefly so both field changes (if simultaneous) settle
      scheduleAdvance(accordion);
    }
  }, true);
})();

/* ============================================================
   EFX × DPO — PHASE 15: PBA/PWBA NAME-ON-BACK DISCLAIMER
   ============================================================
   When any logo position has PBA or PWBA selected, show a
   red disclaimer next to each Name on Back text input
   warning that nicknames are not acceptable. League rules
   require the bowler's registered name on these jerseys.
   ============================================================ */
(function () {
  'use strict';

  var DISCLAIMER_TEXT = 'PBA/PWBA jerseys require your full registered name. Nicknames cannot be used.';
  var NAME_LINE_LABELS = [
    /^first\s*line\s*text/i,
    /^second\s*line\s*text/i,
  ];
  var LOGO_LABELS = [
    /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
    /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i,
  ];

  function fieldMatchesAny(field, patterns) {
    var lbl = field.querySelector('label');
    if (!lbl) return false;
    var txt = '';
    for (var i = 0; i < lbl.childNodes.length; i++) {
      if (lbl.childNodes[i].nodeType === 3) txt += lbl.childNodes[i].textContent;
    }
    txt = txt.trim();
    return patterns.some(function (p) { return p.test(txt); });
  }

  function getLogoFields() {
    var all = document.querySelectorAll('[id^="dynamic_option_id_"]');
    return Array.prototype.filter.call(all, function (f) {
      return fieldMatchesAny(f, LOGO_LABELS);
    });
  }

  function getNameLineFields() {
    var all = document.querySelectorAll('[id^="dynamic_option_id_"]');
    return Array.prototype.filter.call(all, function (f) {
      return fieldMatchesAny(f, NAME_LINE_LABELS);
    });
  }

  function isPbaOrPwbaSelected() {
    var logoFields = getLogoFields();
    for (var i = 0; i < logoFields.length; i++) {
      var sel = logoFields[i].querySelector('.control select');
      if (!sel || !sel.value) continue;
      var opt = sel.options[sel.selectedIndex];
      if (!opt) continue;
      if (/pba|pwba/i.test(opt.textContent || '')) return true;
    }
    return false;
  }

  function ensureDisclaimer(field) {
    var wrap = field.querySelector('.efx-text-wrap') || field.querySelector('.control');
    if (!wrap) return null;
    var existing = wrap.querySelector(':scope > .efx-pba-name-warning');
    if (existing) return existing;

    var div = document.createElement('div');
    div.className = 'efx-pba-name-warning';
    div.innerHTML =
      '<span class="efx-pba-name-warning-icon" aria-hidden="true">⚠</span>' +
      '<span class="efx-pba-name-warning-text">' + DISCLAIMER_TEXT + '</span>';
    wrap.appendChild(div);
    return div;
  }

  function applyState() {
    var active = isPbaOrPwbaSelected();
    var nameLineFields = getNameLineFields();
    nameLineFields.forEach(function (field) {
      var div = ensureDisclaimer(field);
      if (!div) return;
      div.classList.toggle('efx-pba-name-warning--visible', active);
    });
  }

  // Listen for any change on logo position selects
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('[id^="dynamic_option_id_"]');
    if (!field) return;
    if (!fieldMatchesAny(field, LOGO_LABELS)) return;
    applyState();
  }, true);

  // Initial state after DOM settles
  function init() { applyState(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-check after any late-built DOM
  var mo = new MutationObserver(function () { applyState(); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();

/* ============================================================
   EFX × DPO — PHASE 16: SIMPLIFIED-TEMPLATE ADJUSTMENTS
   ============================================================
   Tag-gated. Handles templates that have a constrained option
   set vs. the main bowling jersey template.

   Currently supports:
     • dpo-bowling-fairways
     • dpo-bowling-athletic-tee

   Each template has a config object below that declares:
     - lockFabric:   lock the single fabric swatch
     - lockCollar:   lock the single collar card
     - hideFields:   regexes for fields to hide entirely
     - keepLogos:    label patterns for logo positions to keep
                     (everything else with a logo-position label
                     gets hidden, and the kept one gets the
                     Phase 9 accordion stripped off it)
     - frontLogoAsCustomSelect: convert Front Logo to a styled
                                <select> via Phase 6's pattern
   ============================================================ */
(function () {
  'use strict';

  if (!window.efxHasTag) return;

  // ── Per-template configs ────────────────────────────────────
  var TEMPLATES = {
    'dpo-bowling-fairways': {
      lockFabric: true,
      lockCollar: true,
      hideFields: [
        /^name\s+on\s+back/i,
        /^font\s*style/i,
        /^first\s*line\s*text/i,
        /^second\s*line\s*text/i,
        /^name\s*angle/i,
        /^add\s+custom\s+logo/i,
        /^custom\s+logo\s+quantity/i,
        /^custom\s+logo\s+#?\d+/i,        // #1–#4 upload + placement
      ],
      keepLogos: [/^right\s*chest/i],
      frontLogoAsCustomSelect: false,
    },
    'dpo-bowling-athletic-tee': {
      lockFabric: true,
      lockCollar: true,
      hideFields: [
        /^name\s+on\s+back/i,
        /^font\s*style/i,
        /^first\s*line\s*text/i,
        /^second\s*line\s*text/i,
        /^name\s*angle/i,
        /^add\s+custom\s+logo/i,
        /^custom\s+logo\s+quantity/i,
        /^custom\s+logo\s+#?\d+/i,
      ],
      // Athletic Tee has Front Logo only — but as a regular DPO field
      // (option 1005, NOT a multi-position logo group). Phase 9 won't
      // accordion-wrap it because its label is "Front Logo:" without
      // being part of the six positions list — actually it IS in the
      // list (`/^front\s*logo/i`). So Phase 9 WILL wrap it. We unwrap.
      keepLogos: [/^front\s*logo/i],
      frontLogoAsCustomSelect: true,  // also restyle as Phase 6 select
    },
  };

  // ── Find which template (if any) applies to this product ────
  var config = null;
  var activeTag = null;
  for (var tag in TEMPLATES) {
    if (window.efxHasTag(tag)) {
      config = TEMPLATES[tag];
      activeTag = tag;
      break;
    }
  }
  if (!config) return;

  // ── All logo position label patterns (for hide decisions) ───
  var ALL_LOGO_PATTERNS = [
    /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
    /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i,
  ];

  function fieldLabelText(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return '';
    var clone = lbl.cloneNode(true);
    clone.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
    return (clone.textContent || '').trim();
  }

  function isLogoField(field) {
    var t = fieldLabelText(field);
    return ALL_LOGO_PATTERNS.some(function (p) { return p.test(t); });
  }

  function shouldKeepLogo(field) {
    var t = fieldLabelText(field);
    return config.keepLogos.some(function (p) { return p.test(t); });
  }

  function matchesHidePattern(field) {
    var t = fieldLabelText(field);
    return config.hideFields.some(function (p) { return p.test(t); });
  }

  /* 1. Hide unavailable fields ─────────────────────────────── */
  function hideUnavailableFields() {
    document.querySelectorAll('[id^="dynamic_option_id_"]').forEach(function (field) {
      if (!matchesHidePattern(field)) return;
      field.style.display = 'none';
      var acc = field.closest('.efx-clogo-accordion');
      if (acc) acc.style.display = 'none';
    });
  }

  /* 2. Logo positions ──────────────────────────────────────── */
  function trimLogoPositions() {
    document.querySelectorAll('[id^="dynamic_option_id_"]').forEach(function (field) {
      if (!isLogoField(field)) return;
      if (shouldKeepLogo(field)) {
        unwrapLogoAccordion(field);
      } else {
        field.style.display = 'none';
      }
    });
    var disclaimer = document.querySelector('.efx-logo-disclaimer');
    if (disclaimer) disclaimer.style.display = 'none';
  }

  function unwrapLogoAccordion(field) {
    if (field.dataset.efxUnwrapped === '1') return;
    if (!field.classList.contains('efx-logo-accordion')) return;
    field.dataset.efxUnwrapped = '1';

    field.classList.remove('efx-logo-accordion', 'efx-acc-collapsed', 'efx-acc-has-value');

    var lbl = field.querySelector('label');
    if (lbl) {
      lbl.removeAttribute('data-efx-summary');
      lbl.style.cursor = '';
      var clone = lbl.cloneNode(true);
      lbl.parentNode.replaceChild(clone, lbl);
      var clear = clone.querySelector('.efx-acc-clear');
      if (clear) clear.remove();
    }

    var control = field.querySelector('.control');
    if (control) {
      control.style.maxHeight = '';
      control.style.opacity = '';
      control.style.padding = '';
      control.style.margin = '';
      control.style.pointerEvents = '';
    }

    field.classList.add('efx-fairways-flat-logo');
  }

  /* 3. Lock fabric ─────────────────────────────────────────── */
  function lockFabricSwatch() {
    if (!config.lockFabric) return;
    var grid = document.querySelector('.efx-swatch-grid');
    if (!grid || grid.dataset.efxLocked === '1') return;
    var cards = grid.querySelectorAll('.efx-swatch');
    if (cards.length !== 1) return;
    grid.dataset.efxLocked = '1';
    grid.setAttribute('data-efx-fairways-locked', '1');  // reuse Fairways CSS
    cards[0].classList.add('selected', 'efx-fairways-locked');
    var control = grid.closest('.control');
    var select = control && control.querySelector('select');
    if (select && !select.value) {
      select.value = cards[0].dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* 4. Lock collar ─────────────────────────────────────────── */
  function lockCollarCard() {
    if (!config.lockCollar) return;
    var grid = document.querySelector('.efx-collar-grid');
    if (!grid || grid.dataset.efxLocked === '1') return;
    var cards = grid.querySelectorAll('.efx-collar-card');
    if (cards.length !== 1) return;
    grid.dataset.efxLocked = '1';
    grid.setAttribute('data-efx-fairways-locked', '1');  // reuse Fairways CSS
    cards[0].classList.add('selected', 'efx-fairways-locked');
    var control = grid.closest('.control');
    var select = control && control.querySelector('select');
    if (select && !select.value) {
      select.value = cards[0].dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* 5. Front Logo → custom select (Athletic Tee) ───────────── */
  function styleFrontLogoAsSelect() {
    if (!config.frontLogoAsCustomSelect) return;
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    fields.forEach(function (field) {
      var t = fieldLabelText(field);
      if (!/^front\s*logo/i.test(t)) return;
      // The slider may have already hijacked this field — strip the slider
      // and reveal the underlying <select> so Phase 6's pattern can be
      // applied. Simpler: just mark the field, hide the slider, show select.
      var slider = field.querySelector('.efx-logo-slider');
      var control = field.querySelector('.control');
      var select = control && control.querySelector('select');
      if (!select) return;

      if (slider) slider.style.display = 'none';
      // Restore the native <select> from hidden state (Phase 3.6 hid it)
      select.style.display = '';
      // Remove the "efx-has-logo-slider" class so the Phase 1 control
      // CSS doesn't keep hiding sibling elements
      if (control) control.classList.remove('efx-has-logo-slider');
      // Tag this field so Phase 6 picks it up as a custom-select target
      field.classList.add('efx-fairways-front-logo-select');
    });
  }

  /* BOOTSTRAP ──────────────────────────────────────────────── */
  function applyAll() {
    hideUnavailableFields();
    trimLogoPositions();
    lockFabricSwatch();
    lockCollarCard();
    styleFrontLogoAsSelect();
  }

  function start() {
    applyAll();
    [400, 1200, 2500, 5000].forEach(function (ms) {
      setTimeout(applyAll, ms);
    });
    var obs = new MutationObserver(function () { applyAll(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — TAG TO BODY CLASS HELPER
   ============================================================
   Stamps efx-tag-{tag} classes on <body> for any tag in
   EFX_DPO_TAGS so CSS can target per-template. Used by the
   pants pill override (and easy to extend for any future
   template-scoped CSS rule).
   ============================================================ */
(function () {
  if (!Array.isArray(window.EFX_DPO_TAGS)) return;
  window.EFX_DPO_TAGS.forEach(function (tag) {
    if (typeof tag === 'string' && tag.indexOf('dpo-') === 0) {
      document.body.classList.add('efx-tag-' + tag);
    }
  });
})();

/* ============================================================
   EFX × DPO — PHASE 17: INVENTORY-PRODUCT SIZING PILL
   ============================================================
   Inventory (non-DPO) products use Shopify variants, not DPO
   option fields. This phase injects a "Hover for sizing chart"
   pill next to the .variant-inventory__title heading on tagged
   products and reuses the Phase 3.1 sizing tooltip (which is a
   global singleton on document.body).

   Tag-gated. Currently:
     • dpo-bowling-vault  →  Men's chart only

   To add another inventory product line, append a new tag to
   INVENTORY_TAGS below.
   ============================================================ */
(function () {
  'use strict';

  // Each entry: tag → which sizing chart keys to show
  var INVENTORY_TAGS = {
    'dpo-bowling-vault': ['men'],
  };

  // Pick the first matching tag (only one expected per product)
  var matchedTag = null;
  if (window.efxHasTag) {
    for (var tag in INVENTORY_TAGS) {
      if (window.efxHasTag(tag)) { matchedTag = tag; break; }
    }
  }
  if (!matchedTag) return;

  // Expose which chart keys to show — Phase 3.1 reads this
  window.__efxInventorySizeKeys = INVENTORY_TAGS[matchedTag];

  function injectPill() {
    var title = document.querySelector('.variant-inventory__title');
    if (!title || title.dataset.efxSizingPillBound === '1') return false;
    title.dataset.efxSizingPillBound = '1';

    // Build a pill that visually matches the DPO label <a> pill
    var pill = document.createElement('a');
    pill.href = '#';
    pill.className = 'efx-inventory-sizing-pill';
    pill.setAttribute('role', 'button');
    pill.textContent = 'Hover for sizing chart';
    // Inline the pill into the heading with proper spacing
    title.style.setProperty('display', 'flex', 'important');
    title.style.setProperty('align-items', 'center', 'important');
    title.style.setProperty('gap', '12px', 'important');
    title.style.setProperty('flex-wrap', 'wrap', 'important');
    title.appendChild(pill);

    // The Phase 3.1 tooltip is a singleton — we just need our pill to
    // open it. Phase 3.1's bindTrigger() only binds one trigger element,
    // so we wire our own minimal handlers here that open/close it.
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.__efxOpenInventoryTooltip(pill);
    });

    var hoverOpenTimer = null;
    var hoverCloseTimer = null;
    function hasHover() {
      return window.matchMedia('(hover: hover)').matches;
    }
    pill.addEventListener('mouseenter', function () {
      if (!hasHover()) return;
      if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
      if (hoverOpenTimer) clearTimeout(hoverOpenTimer);
      hoverOpenTimer = setTimeout(function () {
        window.__efxOpenInventoryTooltip(pill);
      }, 250);
    });
    pill.addEventListener('mouseleave', function () {
      if (!hasHover()) return;
      if (hoverOpenTimer) { clearTimeout(hoverOpenTimer); hoverOpenTimer = null; }
      hoverCloseTimer = setTimeout(function () {
        window.__efxCloseInventoryTooltip && window.__efxCloseInventoryTooltip();
      }, 350);
    });

    return true;
  }

  function start() {
    if (injectPill()) return;
    var obs = new MutationObserver(function () {
      if (injectPill()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   EFX × DPO — PHASE 18: PBA BRAND BUNDLE ENFORCEMENT
   ============================================================
   When PBA is selected on Right Sleeve, scan Front Logo,
   Left Chest, and Lower Back for any of three brand families
   (Storm, Roto Grip, 900 Global). If detected, force the full
   bundle into the correct positions and lock those positions.

   PBA is required for the bundle to apply. PWBA does not trigger.
   Removing PBA unlocks the positions (values left as-is).

   Detection vs applied bundle:
     Storm    detects: Storm - Original, Storm - Bolt
              applies: Front=Storm - Bolt, LC=Storm - Original,
                       LB=Storm - Original
     RotoGrip detects: Roto Grip - Original, Roto Grip - Star Only
              applies: Front=Roto Grip - Star Only,
                       LC=Roto Grip - Original, LB=Roto Grip - Original
     900G     detects: 900G, 900G - G
              applies: Front=900G - G, LC=900G, LB=900G

   Conflict priority: Front Logo > Left Chest > Lower Back.
   ============================================================ */
(function () {
  'use strict';

  var BUNDLES = {
    storm: {
      detect:  ['Storm - Original', 'Storm - Bolt'],
      apply:   {
        front:     'Storm - Bolt',
        leftChest: 'Storm - Original',
        lowerBack: 'Storm - Original',
      },
    },
    rotoGrip: {
      detect:  ['Roto Grip - Original', 'Roto Grip - Star Only'],
      apply:   {
        front:     'Roto Grip - Star Only',
        leftChest: 'Roto Grip - Original',
        lowerBack: 'Roto Grip - Original',
      },
    },
    nineHundred: {
      detect:  ['900G', '900G - G'],
      apply:   {
        front:     '900G - G',
        leftChest: '900G',
        lowerBack: '900G',
      },
    },
    motiv: {
      detect:  ['Motiv', 'Motiv - M'],
      apply:   {
        front:     'Motiv',
        leftChest: 'Motiv - M',
        lowerBack: 'Motiv - M',
      },
    },
  };

  var FIELD_PATTERNS = {
    front:      /^front\s*logo/i,
    leftChest:  /^left\s*chest/i,
    rightSleeve:/^right\s*sleeve/i,
    lowerBack:  /^lower\s*back\s*logo/i,
  };

  var PBA_PATTERN = /^pba\s*bowltv/i;  // matches PBA BowlTV, PBA BowlTV - 50, etc. but NOT PWBA

  var BUNDLE_PRIORITY = ['front', 'leftChest', 'lowerBack'];

  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var lbl = fields[i].querySelector('label');
      if (!lbl) continue;
      var clone = lbl.cloneNode(true);
      clone.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
      var text = (clone.textContent || '').trim();
      if (pattern.test(text)) return fields[i];
    }
    return null;
  }

  function getSelectedOptionText(field) {
    if (!field) return '';
    var sel = field.querySelector('.control select');
    if (!sel || !sel.value) return '';
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return '';
    // Strip price suffix
    return (opt.text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
  }

  function setFieldToOption(field, optionLabel) {
    if (!field) return false;
    var sel = field.querySelector('.control select');
    if (!sel) return false;

    // Find the option whose text matches optionLabel (price-stripped)
    var match = null;
    for (var i = 0; i < sel.options.length; i++) {
      var raw = (sel.options[i].text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      if (raw === optionLabel) { match = sel.options[i]; break; }
    }
    if (!match) return false;
    if (sel.value === match.value) return true;

    sel.value = match.value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    sel.dispatchEvent(new Event('input',  { bubbles: true }));
    if (window.jQuery) window.jQuery(sel).trigger('change');

    // Mirror to the logo slider cards
    var track = field.querySelector('.efx-logo-track');
    if (track) {
      track.querySelectorAll('.efx-logo-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      var card = track.querySelector('.efx-logo-card[data-value="' + match.value + '"]');
      if (card) {
        card.classList.add('selected');
        card.setAttribute('aria-checked', 'true');
      }
    }
    // Mark as user-touched so Phase 9 pill shows the value
    field.dataset.efxUserTouched = '1';
    return true;
  }

  function isPbaSelectedOnRightSleeve() {
    var rs = findFieldByLabel(FIELD_PATTERNS.rightSleeve);
    if (!rs) return false;
    var text = getSelectedOptionText(rs);
    return PBA_PATTERN.test(text);
  }

  function detectBundle() {
    // Returns 'storm' | 'rotoGrip' | 'nineHundred' | null
    // Priority: Front > Left Chest > Lower Back
    for (var p = 0; p < BUNDLE_PRIORITY.length; p++) {
      var pos = BUNDLE_PRIORITY[p];
      var field = findFieldByLabel(FIELD_PATTERNS[pos]);
      if (!field) continue;
      var text = getSelectedOptionText(field);
      if (!text) continue;
      for (var key in BUNDLES) {
        if (BUNDLES[key].detect.indexOf(text) !== -1) return key;
      }
    }
    return null;
  }

  function setLocked(positions, locked) {
    positions.forEach(function (pos) {
      var field = findFieldByLabel(FIELD_PATTERNS[pos]);
      if (!field) return;
      field.classList.toggle('efx-pba-bundle-locked', locked);
    });
  }

  function ensureBanner(show) {
    var existing = document.querySelector('.efx-pba-bundle-banner');
    if (show) {
      if (existing) return;
      var anchor = findFieldByLabel(FIELD_PATTERNS.front);
      if (!anchor) return;
      var banner = document.createElement('div');
      banner.className = 'efx-pba-bundle-banner';
      banner.innerHTML =
        '<span class="efx-pba-bundle-banner-icon" aria-hidden="true">🔒</span>' +
        '<span class="efx-pba-bundle-banner-text">' +
          'Front Logo, Left Chest, and Lower Back have been set to meet brand requirements. These positions are locked.' +
          '<span class="efx-pba-bundle-banner-hint">To unlock, remove PBA from the Right Sleeve.</span>' +
        '</span>';
      anchor.parentNode.insertBefore(banner, anchor);
    } else {
      if (existing) existing.remove();
    }
  }

  var lastBundle = null;
  var applying = false;

  function applyState() {
    if (applying) return;
    applying = true;
    try {
      // PBA on Right Sleeve is required for the bundle to apply.
      if (!isPbaSelectedOnRightSleeve()) {
        setLocked(['front', 'leftChest', 'lowerBack'], false);
        ensureBanner(false);
        lastBundle = null;
        return;
      }

      var bundle = detectBundle();
      if (!bundle) {
        setLocked(['front', 'leftChest', 'lowerBack'], false);
        ensureBanner(false);
        lastBundle = null;
        return;
      }

      var apply = BUNDLES[bundle].apply;
      setFieldToOption(findFieldByLabel(FIELD_PATTERNS.front),     apply.front);
      setFieldToOption(findFieldByLabel(FIELD_PATTERNS.leftChest), apply.leftChest);
      setFieldToOption(findFieldByLabel(FIELD_PATTERNS.lowerBack), apply.lowerBack);

      setLocked(['front', 'leftChest', 'lowerBack'], true);
      ensureBanner(true);
      lastBundle = bundle;
    } finally {
      applying = false;
    }
  }

  var debounceTimer;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyState, 80);
  }

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('[id^="dynamic_option_id_"]');
    if (!field) return;
    var lbl = field.querySelector('label');
    if (!lbl) return;
    var clone = lbl.cloneNode(true);
    clone.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
    var text = (clone.textContent || '').trim();
    // Only re-evaluate when one of the 4 relevant positions changes
    if (FIELD_PATTERNS.front.test(text)     ||
        FIELD_PATTERNS.leftChest.test(text) ||
        FIELD_PATTERNS.rightSleeve.test(text) ||
        FIELD_PATTERNS.lowerBack.test(text)) {
      schedule();
    }
  }, true);

  // Initial passes for late-rendered fields
  [800, 2500, 5000].forEach(function (ms) {
    setTimeout(applyState, ms);
  });
})();

/* ============================================================
   PHASE 19 — Product-name-based logo defaults
   ============================================================ */

(function() {
  'use strict';

  var DEFAULT_RULES = [
  {
    productKeywords: ['900G', '900 Global'],
    defaults: {
      'Front Logo': '900G',
      'Left Chest': '900G - G'
    }
  },
  {
    productKeywords: ['Brunswick'],
    defaults: {
      'Front Logo': 'Brunswick',
      'Left Chest': 'Brunswick - Vintage B'
    }
  },
  {
    productKeywords: ['C300'],
    defaults: {
      'Front Logo': 'C300',
      'Left Chest': 'C300'
    }
  },
  {
    productKeywords: ['DV8'],
    defaults: {
      'Front Logo': 'DV8',
      'Left Chest': 'DV8'
    }
  },
  {
    productKeywords: ['Ebonite'],
    defaults: {
      'Front Logo': 'Ebonite',
      'Left Chest': 'Ebonite - Vintage'
    }
  },
  {
    productKeywords: ['Hammer'],
    defaults: {
      'Front Logo': 'Hammer',
      'Left Chest': 'Hammer - Full'
    }
  },
  {
    productKeywords: ['Motiv'],
    defaults: {
      'Front Logo': 'Motiv',
      'Left Chest': 'Motiv - M'
    }
  },
   {
    productKeywords: ['Radical'],
    defaults: {
      'Front Logo': 'Radical',
      'Left Chest': 'Radical - R'
    }
  },
   {
    productKeywords: ['Roto Grip'],
    defaults: {
      'Front Logo': 'Roto Grip - Original',
      'Left Chest': 'Roto Grip - Star Only'
    }
  },
   {
    productKeywords: ['Storm'],
    defaults: {
      'Front Logo': 'Storm - Original',
      'Left Chest': 'Storm - Bolt'
    }
  },
   {
    productKeywords: ['Track'],
    defaults: {
      'Front Logo': 'Track',
      'Left Chest': 'Track - Flaming T'
    }
  }
];

  function getProductName() {
    var el = document.querySelector('h1.product_name, .product_name, h1');
    return el ? el.textContent.trim() : '';
  }

  function findRuleForCurrentProduct() {
    var name = getProductName().toLowerCase();
    if (!name) return null;
    for (var i = 0; i < DEFAULT_RULES.length; i++) {
      var keywords = DEFAULT_RULES[i].productKeywords;
      for (var k = 0; k < keywords.length; k++) {
        if (name.indexOf(keywords[k].toLowerCase()) !== -1) {
          return DEFAULT_RULES[i];
        }
      }
    }
    return null;
  }

  // Find the DPO field by its visible label text. Walks up the DOM
  // until it finds the container that holds a <select>.
  function findFieldByLabel(labelText) {
    var labels = document.querySelectorAll('label, .efx-acc-label');
    for (var i = 0; i < labels.length; i++) {
      var text = (labels[i].textContent || '').trim();
      var cleaned = text.replace(/[:\*]/g, '').trim();
      if (text === labelText || cleaned === labelText) {
        // Walk up looking for the closest ancestor that contains a <select>
        var node = labels[i];
        for (var d = 0; d < 6; d++) {
          node = node.parentElement;
          if (!node) break;
          if (node.querySelector('select')) {
            return node;
          }
        }
      }
    }
    return null;
  }

  function getSelectFromField(fieldEl) {
    return fieldEl ? fieldEl.querySelector('select') : null;
  }

  function isFieldEmpty(selectEl) {
    if (!selectEl) return false;
    var v = selectEl.value;
    if (!v || v === '') return true;
    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return true;
    var label = (opt.textContent || '').trim().toLowerCase();
    return label === 'none' ||
           label === '-- none --' ||
           label === 'please select' ||
           label === 'click to select' ||
           label === '';
  }

  function setSelectByOptionLabel(selectEl, targetLabel) {
    if (!selectEl) return false;
    for (var i = 0; i < selectEl.options.length; i++) {
      var optText = (selectEl.options[i].textContent || '').trim();
      var optBase = optText.replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      if (optBase === targetLabel || optText === targetLabel) {
        selectEl.value = selectEl.options[i].value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function applyRule(rule) {
    Object.keys(rule.defaults).forEach(function(labelText) {
      var targetValue = rule.defaults[labelText];
      var field = findFieldByLabel(labelText);
      var sel = getSelectFromField(field);
      if (!sel) {
        console.warn('[Phase 19] Field not found:', labelText);
        return;
      }
      if (!isFieldEmpty(sel)) {
        console.log('[Phase 19] Field already set, skipping:', labelText, '=', sel.value);
        return;
      }
      var ok = setSelectByOptionLabel(sel, targetValue);
      if (!ok) {
        var available = [];
        for (var i = 0; i < sel.options.length; i++) {
          available.push((sel.options[i].textContent || '').trim());
        }
        console.warn('[Phase 19] Option not found:', labelText, '→', targetValue,
                     '— available:', available);
      } else {
        console.log('[Phase 19] Default set:', labelText, '→', targetValue);
      }
    });
  }

  // Wait for DPO + Phase 9 accordions to finish rendering.
  // Poll for the label-containing accordion structure we know is there.
  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    var rule = findRuleForCurrentProduct();
    if (!rule) {
      clearInterval(poll);
      return;
    }

    var hasFields = document.querySelector('.efx-logo-accordion, .dpo-container, table.form-list');
    if (hasFields || attempts > 60) {
      clearInterval(poll);
      console.log('[Phase 19] DPO detected (attempt ' + attempts + '), applying rule for:', getProductName());
      setTimeout(function() { applyRule(rule); }, 500);
    }
  }, 250);

})();

/* ============================================================
   EFX × DPO — PHASE 20: STRIP EMOJI FROM NAME LINES
   ============================================================
   The selected jersey font has no emoji glyphs, but the browser
   falls back to the system color-emoji font in the live preview,
   so a customer can type 💖 and SEE it — even though it can never
   be sublimated and would break the Illustrator back-name render.
   This strips emoji (+ flags / skin tones / ZWJ joiners) from the
   First Line + Second Line inputs as they type or paste, so the
   preview only ever shows what we can actually print. Accented
   letters (José, Müller) are preserved. Mirrors the queue-side
   strip in efx_queue_normalize.py.
   ============================================================ */
(function () {
  'use strict';

  // Same ranges as the Python strip. NOT letters/numbers/accents/arrows.
  var EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{1F1E6}-\u{1F1FF}\u{1F3FB}-\u{1F3FF}\u{FE00}-\u{FE0F}\u{200D}\u{20E3}]/gu;

  function stripEmoji(s) {
    return String(s == null ? '' : s).replace(EMOJI_RE, '');
  }

  // Only the First/Second Line name inputs (wrapped by Phase 4 / tagged by Phase 5)
  function isNameLineInput(el) {
    return !!(el && el.matches && el.matches(
      '.efx-text-wrap input.product-custom-option, ' +
      '.efx-text-wrap textarea.product-custom-option, ' +
      '.efx-line-1, .efx-line-2'
    ));
  }

  // Capture phase → runs BEFORE Phase 4 / Phase 5 input handlers.
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!isNameLineInput(el)) return;
    var clean = stripEmoji(el.value);
    if (clean === el.value) return;
    var pos = el.selectionStart;
    var removed = el.value.length - clean.length;
    el.value = clean;
    try {
      var caret = Math.max(0, (pos == null ? clean.length : pos) - removed);
      el.setSelectionRange(caret, caret);
    } catch (_) { /* some input types disallow setSelectionRange */ }
  }, true);
})();

/* ============================================================
   EFX × DPO — PHASE 21: FRONT LOGO SPONSOR SETS
   ============================================================
   Where to paste: APPEND to efx-dpo-customizations.js
                   (runs alongside Phases 2–20)

   What it does:   When a customer selects a sponsor value in the
                   Front Logo field, auto-fills the matching logo
                   set into Left Chest / Right Chest / Left Sleeve
                   / Right Sleeve, LOCKS those positions, and HIDES
                   the Add Custom Logo section. Deselecting the
                   sponsor unlocks the positions (values left
                   as-is, à la Phase 18) and restores custom logos.

   Why JS, not DPO admin: this is enforced client-side like
                   Phase 18 (PBA bundle) and Phase 10 (PBA hide),
                   not via DPO's visibility_condition.

   Pairs with the flat-rate discount function: the discount keys
   on Front Logo == a sponsor value. Locking the set here keeps
   the sponsor branding intact for that flat price. Keep the
   SPONSOR_SETS keys below in sync with the discount's qualifying
   logo list (the metaobject).

   ── VERIFY BEFORE GOING LIVE ───────────────────────────────
   1. The option strings below must match the <option> text in
      each position's DPO select EXACTLY. The price suffix
      (+$x.xx) is stripped automatically; parentheses/brackets
      are NOT. A mismatch logs a console warning with the list of
      available options and that position is skipped — open the
      console after a test add-to-cart and confirm zero warnings.
   2. Each set value must EXIST as an option in that position's
      select on every product where the sponsor front logo is
      selectable.
   3. lockPositions / hideCustomLogo are per-sponsor toggles —
      flip either to false if you want editable defaults instead
      of a hard lock.
   ============================================================ */
(function () {
  'use strict';

  // Front Logo value  →  the set it forces. Add more sponsors here;
  // each new key must also be added to the discount metaobject.
  var SPONSOR_SETS = {
    'MJMA': {
      set: {
        leftChest:   'Brunswick',
        rightChest:  'Turbo (3.5x1.6704)',
        leftSleeve:  'EFX - Badge {HEM}',
        rightSleeve: 'Otter - Badge'
      },
      lockPositions:  true,
      hideCustomLogo: true
    }
  };

  var FIELD_PATTERNS = {
    front:       /^front\s*logo/i,
    leftChest:   /^left\s*chest/i,
    rightChest:  /^right\s*chest/i,
    leftSleeve:  /^left\s*sleeve/i,
    rightSleeve: /^right\s*sleeve/i
  };

  var SET_POSITIONS = ['leftChest', 'rightChest', 'leftSleeve', 'rightSleeve'];

  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var lbl = fields[i].querySelector('label');
      if (!lbl) continue;
      var clone = lbl.cloneNode(true);
      clone.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
      if (pattern.test((clone.textContent || '').trim())) return fields[i];
    }
    return null;
  }

  function getSelectedOptionText(field) {
    if (!field) return '';
    var sel = field.querySelector('.control select');
    if (!sel || !sel.value) return '';
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return '';
    return (opt.text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
  }

  // Set a position's <select> to an option by its (price-stripped) text,
  // mirror onto the Phase 3.6 slider, and mark the field user-touched so
  // Phase 9's accordion pill shows the value. Logs available options on miss.
  function setFieldToOption(field, optionLabel) {
    if (!field) return false;
    var sel = field.querySelector('.control select');
    if (!sel) return false;

    var match = null;
    for (var i = 0; i < sel.options.length; i++) {
      var raw = (sel.options[i].text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      if (raw === optionLabel) { match = sel.options[i]; break; }
    }
    if (!match) {
      var avail = [];
      for (var j = 0; j < sel.options.length; j++) avail.push((sel.options[j].text || '').trim());
      console.warn('[Phase 21] Option not found: "' + optionLabel + '" — available:', avail);
      return false;
    }

    if (sel.value !== match.value) {
      sel.value = match.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input',  { bubbles: true }));
      if (window.jQuery) window.jQuery(sel).trigger('change');
    }

    var track = field.querySelector('.efx-logo-track');
    if (track) {
      track.querySelectorAll('.efx-logo-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      var card = track.querySelector('.efx-logo-card[data-value="' + match.value + '"]');
      if (card) {
        card.classList.add('selected');
        card.setAttribute('aria-checked', 'true');
      }
    }
    field.dataset.efxUserTouched = '1';
    return true;
  }

  // Reuses the Phase 18 lock styling (.efx-pba-bundle-locked) so no new CSS.
  function setLocked(positions, locked) {
    positions.forEach(function (pos) {
      var field = findFieldByLabel(FIELD_PATTERNS[pos]);
      if (field) field.classList.toggle('efx-pba-bundle-locked', locked);
    });
  }

  // Hide/show Add Custom Logo + Quantity + #1–#4 upload/placement
  // (and their accordions). Same coverage as Phase 10's toggle.
  function toggleCustomLogos(hide) {
    [1, 2, 3, 4].forEach(function (n) {
      var pat      = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*:?\\s*$', 'i');
      var placePat = new RegExp('^custom\\s+logo\\s+#?' + n + '\\s*[-—]\\s*placement', 'i');
      [pat, placePat].forEach(function (p) {
        var f = findFieldByLabel(p);
        if (!f) return;
        f.style.display = hide ? 'none' : '';
        var acc = f.closest('.efx-clogo-accordion');
        if (acc) acc.style.display = hide ? 'none' : '';
      });
    });
    [/^add\s+custom\s+logo/i, /^custom\s+logo\s+quantity/i].forEach(function (p) {
      var f = findFieldByLabel(p);
      if (f) f.style.display = hide ? 'none' : '';
    });
  }

  var applying = false;
  var hidByPhase21 = false;

  function applyState() {
    if (applying) return;
    applying = true;
    try {
      var frontVal = getSelectedOptionText(findFieldByLabel(FIELD_PATTERNS.front));
      var sponsor  = SPONSOR_SETS[frontVal] || null;

      if (!sponsor) {
        setLocked(SET_POSITIONS, false);
        // Only un-hide if WE hid them — don't override DPO's own
        // Add-Custom-Logo visibility (this was force-showing #1–#4).
        if (hidByPhase21) {
          toggleCustomLogos(false);
          hidByPhase21 = false;
          if (window.__efxApplyRules) window.__efxApplyRules();  // re-run DPO rules
        }
        return;
      }

      Object.keys(sponsor.set).forEach(function (pos) {
        setFieldToOption(findFieldByLabel(FIELD_PATTERNS[pos]), sponsor.set[pos]);
      });

      if (sponsor.lockPositions)  setLocked(SET_POSITIONS, true);
      if (sponsor.hideCustomLogo) { toggleCustomLogos(true); hidByPhase21 = true; }
    } finally {
      applying = false;
    }
  }

  var debounce;
  function schedule() { clearTimeout(debounce); debounce = setTimeout(applyState, 80); }

  // Re-evaluate when the Front Logo selection changes.
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.tagName !== 'SELECT') return;
    var field = e.target.closest('[id^="dynamic_option_id_"]');
    if (!field) return;
    var lbl = field.querySelector('label');
    if (lbl && FIELD_PATTERNS.front.test((lbl.textContent || '').trim())) schedule();
  }, true);

  // Late-render passes + re-apply on DOM mutations from other phases.
  [600, 1500, 3500].forEach(function (ms) { setTimeout(applyState, ms); });
  var obs = new MutationObserver(schedule);
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);

  // Manual console testing
  window.__efxApplySponsorSets = applyState;
})();

/* ============================================================
   EFX × DPO — PHASE 22: CLEAR ALL LOGOS PILL
   ============================================================
   Where to paste: APPEND to efx-dpo-customizations.js
                   (runs alongside Phases 2–21)

   What it does:   Drops a purple "Clear All" pill above the
                   logo positions. It only appears once at least
                   one of Front Logo / Left Chest / Right Chest /
                   Left Sleeve / Right Sleeve / Lower Back holds a
                   logo. One tap resets all six to None and syncs
                   the Phase 3.6 sliders + Phase 9 accordion pills.

   Note: clearing Front Logo to None also releases any Phase 21
   sponsor lock (MJMA), so this safely wipes a locked set too.
   Does NOT touch Custom Logos / Name on Back — say the word if
   you want those included.
   ============================================================ */
(function () {
  'use strict';

  var LOGO_LABELS = [
    /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
    /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i
  ];

  function labelText(field) {
    var lbl = field.querySelector('label');
    if (!lbl) return '';
    var t = '';
    for (var i = 0; i < lbl.childNodes.length; i++) {
      if (lbl.childNodes[i].nodeType === 3) t += lbl.childNodes[i].textContent;
    }
    return t.trim();
  }

  function isLogoField(field) {
    return LOGO_LABELS.some(function (p) { return p.test(labelText(field)); });
  }

  function getLogoFields() {
    return [].slice.call(document.querySelectorAll('[id^="dynamic_option_id_"]'))
             .filter(isLogoField);
  }

  function fieldHasValue(field) {
    var sel = field.querySelector('.control select');
    if (!sel || !sel.value) return false;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return false;
    return !/^[-—\s]*none[-—\s]*$/i.test((opt.textContent || '').trim());
  }

  // Mirrors Phase 9's per-field clear (reset to None + sync slider).
  function clearLogoField(field) {
    var sel = field.querySelector('.control select');
    if (!sel) return;
    var noneOpt = Array.prototype.find.call(sel.options, function (o) {
      return !o.value || /^[-—\s]*none[-—\s]*$/i.test((o.textContent || '').trim());
    });
    if (!noneOpt) return;

    sel.value = noneOpt.value;
    delete field.dataset.efxUserTouched;

    var track = field.querySelector('.efx-logo-track');
    if (track) {
      track.querySelectorAll('.efx-logo-card').forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      var noneCard = track.querySelector('.efx-logo-card.is-none');
      if (noneCard) {
        noneCard.classList.add('selected');
        noneCard.setAttribute('aria-checked', 'true');
      }
    }
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.jQuery) window.jQuery(sel).trigger('change');
  }

  var rowEl = null, btnEl = null;

  function buildPill() {
    if (btnEl) return true;
    var fields = getLogoFields();
    if (!fields.length) return false;

    var disclaimer = document.querySelector('.efx-logo-disclaimer');
    if (!disclaimer) return false;

    disclaimer.style.display        = 'flex';
    disclaimer.style.alignItems     = 'center';
    disclaimer.style.justifyContent = 'space-between';
    disclaimer.style.gap            = '12px';
    disclaimer.style.textAlign      = 'left';
    disclaimer.style.marginBottom   = '20px';   // ← padding below the row

    btnEl = document.createElement('button');
    btnEl.type = 'button';
    btnEl.className = 'efx-logo-clearall';
    btnEl.textContent = 'Clear All';
    btnEl.style.cssText =
      'appearance:none;border:0;cursor:pointer;flex:0 0 auto;' +
      'font-family:inherit;font-weight:600;font-size:11px;line-height:1;' +
      'letter-spacing:.04em;text-transform:uppercase;' +
      'color:#fff;background:#742FCA;border-radius:999px;padding:6px 13px;' +
      'margin-right:24px;' +                     // ← shift left to align with the pills
      'transition:background .15s ease,transform .05s ease;';
    btnEl.addEventListener('mouseenter', function () { btnEl.style.background = '#5e25a3'; });
    btnEl.addEventListener('mouseleave', function () { btnEl.style.background = '#742FCA'; });
    btnEl.addEventListener('mousedown',  function () { btnEl.style.transform = 'scale(.97)'; });
    btnEl.addEventListener('mouseup',    function () { btnEl.style.transform = 'none'; });
    btnEl.addEventListener('click', function (e) {
      e.preventDefault();
      getLogoFields().forEach(clearLogoField);
      updateVisibility();
    });

    disclaimer.appendChild(btnEl);
    return true;
  }

  function updateVisibility() {
    if (!btnEl) return;
    btnEl.style.display = getLogoFields().some(fieldHasValue) ? 'inline-flex' : 'none';
  }

  function tick() { if (buildPill()) updateVisibility(); }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.tagName === 'SELECT') setTimeout(tick, 30);
  }, true);

  [600, 1500, 3500].forEach(function (ms) { setTimeout(tick, ms); });
  var obs = new MutationObserver(function () { setTimeout(tick, 30); });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);
})();

/* ============================================================
   EFX × DPO — PHASE 23: COLLECTION-FORCED FRONT LOGO + FIELDS
   Forces Front Logo (+ a sponsor set via Phase 21), forces
   extra fields (Name on Back = Yes), and locks the lot — only
   when the product is reached through a configured collection.
   ============================================================ */
(function () {
  'use strict';

  window.__efxPhase23Version = 'radio-direct-v2';   // deploy/cache check

  var FORCE_FRONT_LOGO_BY_COLLECTION = { 'mjma-bowling-jerseys': 'MJMA' };
  var FRONT_LOGO_PATTERN = /^front\s*logo/i;

  // Extra non-logo fields to force + lock (label → option text).
  var FORCE_FIELDS = [
    { pattern: /^name\s*on\s*back/i, value: 'Yes' }
  ];

  var LOGO_LOCK_PATTERNS = [
    /^front\s*logo/i, /^left\s*chest/i, /^right\s*chest/i,
    /^left\s*sleeve/i, /^right\s*sleeve/i, /^lower\s*back\s*logo/i
  ];

  function getForcedLogo() {
    var path = (location.pathname || '').toLowerCase();
    for (var h in FORCE_FRONT_LOGO_BY_COLLECTION) {
      if (path.indexOf('/collections/' + h + '/') !== -1) return FORCE_FRONT_LOGO_BY_COLLECTION[h];
    }
    return null;
  }

  function findFieldByLabel(pattern) {
    var fields = document.querySelectorAll('[id^="dynamic_option_id_"]');
    for (var i = 0; i < fields.length; i++) {
      var lbl = fields[i].querySelector('label');
      if (!lbl) continue;
      var clone = lbl.cloneNode(true);
      clone.querySelectorAll('a, em, span, input').forEach(function (n) { n.remove(); });
      if (pattern.test((clone.textContent || '').trim())) return fields[i];
    }
    return null;
  }

  // Select-based fields (logos): set <select> + mirror slider.
  function setFieldToOption(field, optionLabel) {
    var sel = field.querySelector('.control select');
    if (!sel) return false;
    var match = null;
    for (var i = 0; i < sel.options.length; i++) {
      var raw = (sel.options[i].text || '').trim().replace(/\s*\+\$[\d.]+\s*$/, '').trim();
      if (raw === optionLabel) { match = sel.options[i]; break; }
    }
    if (!match) { console.warn('[Phase 23] option not found: "' + optionLabel + '"'); return false; }
    if (sel.value !== match.value) {
      sel.value = match.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input',  { bubbles: true }));
      if (window.jQuery) window.jQuery(sel).trigger('change');
    }
    var track = field.querySelector('.efx-logo-track');
    if (track) {
      track.querySelectorAll('.efx-logo-card').forEach(function (c) {
        c.classList.remove('selected'); c.setAttribute('aria-checked', 'false');
      });
      var card = track.querySelector('.efx-logo-card[data-value="' + match.value + '"]');
      if (card) { card.classList.add('selected'); card.setAttribute('aria-checked', 'true'); }
    }
    field.dataset.efxUserTouched = '1';
    return true;
  }

  // Card-picker fields (Name on Back etc.): drive the radio directly.
  function setCardPicker(field, value) {
    var want = String(value).trim().toLowerCase();
    var radio = null, rows = field.querySelectorAll('.options-list .field.choice');
    for (var i = 0; i < rows.length; i++) {
      var span = rows[i].querySelector('label span'), r = rows[i].querySelector('input[type="radio"]');
      if (span && r && span.textContent.trim().toLowerCase() === want) { radio = r; break; }
    }
    if (!radio) { console.warn('[Phase 23] card option not found: "' + value + '"'); return false; }
    if (!radio.checked) {                       // idempotent — re-runs leave it alone
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input',  { bubbles: true }));
      if (window.jQuery) window.jQuery(radio).trigger('change');
    }
    var stack = field.querySelector('.efx-time-stack');
    if (stack) {
      stack.querySelectorAll('.efx-time-card').forEach(function (c) { c.classList.remove('selected'); });
      var card = field.querySelector('.efx-time-card[data-input-id="' + radio.id + '"]');
      if (card) card.classList.add('selected');
    }
    return true;
  }

  function forceField(field, value) {
    if (field.hasAttribute('data-efx-card-picker') || !field.querySelector('.control select')) {
      return setCardPicker(field, value);
    }
    return setFieldToOption(field, value);
  }

  function lockField(field) {
    field.classList.add('efx-pba-bundle-locked');
    var ctrl = field.querySelector('.control'), track = field.querySelector('.efx-logo-track');
    if (ctrl)  ctrl.style.pointerEvents  = 'none';
    if (track) track.style.pointerEvents = 'none';
  }

  var forced = getForcedLogo();
  if (!forced) return;

  function apply() {
    var front = findFieldByLabel(FRONT_LOGO_PATTERN);
    if (!front) return false;
    setFieldToOption(front, forced);                     // Phase 21 cascades the set
    FORCE_FIELDS.forEach(function (ff) {                 // force Name on Back = Yes
      var f = findFieldByLabel(ff.pattern);
      if (f) forceField(f, ff.value);
    });
    LOGO_LOCK_PATTERNS                                    // lock logos + forced fields
      .concat(FORCE_FIELDS.map(function (ff) { return ff.pattern; }))
      .forEach(function (p) { var f = findFieldByLabel(p); if (f) lockField(f); });
    return true;
  }

  [400, 900, 1800, 3500].forEach(function (ms) { setTimeout(apply, ms); });
  var obs = new MutationObserver(function () { setTimeout(apply, 30); });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);

  window.__efxApplyForcedLogo = apply;
})();
/* ============================================================
   EFX × DPO — diagnostics (temporary). Confirms this file is
   fresh and dumps the live state for the PBA-logo / size bugs.
   Run  __efxDiag()  in the browser console after reproducing.
   ============================================================ */
try { console.log('[EFX Customizer] build 2026-07-14 · e (size-visibility)'); } catch (e) {}

window.__efxDiag = function () {
  var PBA = /pba|pwba/i;
  var logoRe = /^(front\s*logo|left\s*chest|right\s*chest|left\s*sleeve|right\s*sleeve|lower\s*back)/i;
  var sizeRe = /(men|women|youth)\s*sizes|^size\b|sizes?\s*:?\s*$/i;
  var out = { build: '2026-07-14-g', pbaDetected: false, logos: [], customLogos: [], sizes: [] };

  // Size Type checkbox states (the field that governs which size dropdown shows)
  out.sizeTypeCheckboxes = [];
  document.querySelectorAll('[id^="dynamic_option_id_"]').forEach(function (f) {
    if (!/size\s*type/i.test(f.textContent || '')) return;
    f.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      var l = cb.closest('label') || document.querySelector('label[for="' + cb.id + '"]');
      out.sizeTypeCheckboxes.push({
        label: (l ? l.textContent : '').trim(), name: cb.name,
        value: cb.value, checked: cb.checked
      });
    });
  });

  // Team Order builder's saved snapshot for the size fields, if the drawer exists
  try { out.builderSnapshot = window.__efxTOSnap ? window.__efxTOSnap() : '(builder not present)'; }
  catch (e) { out.builderSnapshot = 'err: ' + e.message; }

  document.querySelectorAll('[id^="dynamic_option_id_"]').forEach(function (f) {
    var lbl = f.querySelector('label');
    var title = lbl ? (lbl.textContent || '').trim() : '';
    var sel = f.querySelector('.control select') || f.querySelector('select');
    var selText = (sel && sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) ? sel.options[sel.selectedIndex].text : null;
    var disp = getComputedStyle(f).display;

    if (logoRe.test(title)) {
      out.logos.push({ title: title, selected: selText, display: disp });
      if (selText && PBA.test(selText)) out.pbaDetected = true;
    }
    if (/custom\s*logo/i.test(title)) {
      out.customLogos.push({ title: title, computedDisplay: disp, inlineDisplay: f.style.display || '(none set)' });
    }
    if (sizeRe.test(title)) {
      var selectedPill = f.querySelector('.efx-size-pill.selected');
      out.sizes.push({
        title: title, display: disp,
        selectValue: sel ? sel.value : null, selectText: selText,
        pillCount: f.querySelectorAll('.efx-size-pill').length,
        highlightedPill: selectedPill ? selectedPill.getAttribute('data-value') : null
      });
    }
  });

  console.log('=== __efxDiag ===\n' + JSON.stringify(out, null, 2));
  return out;
};

/* ──────────────────────────────────────────────────────────────
 * Product-page Add to Cart: refill a silently-blanked size from its stamp
 * ──────────────────────────────────────────────────────────────
 * DPO can asynchronously blank a size <select> on a cascade WITHOUT firing a
 * change event, so the pill proxy's live re-assert misses it. At Add to Cart the
 * empty size then fails "<type> Sizes required" and DPO scrolls to that field —
 * which is hoisted/hidden down near the name section, so it looks like a "name"
 * problem. Here we refill each ACTIVE (non-.ihidden) size field from the value
 * the proxy stamped on it (data-efx-size), in the CAPTURE phase so it runs
 * before DPO validates. If nothing was ever picked there's no stamp, so a
 * genuinely missing size is still correctly required. (The Team Order builder
 * does the same via ensureSizesFilled; this covers the single-item path.)
 * ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var ROOT_ID = 'itoris_dynamicproductoptions';

  function refillStampedSizes() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    [].forEach.call(root.querySelectorAll('[id^="dynamic_option_id_"][data-efx-size]'), function (field) {
      if (field.classList.contains('ihidden')) return; // inactive type — skip
      var want = field.getAttribute('data-efx-size');
      var sel = field.querySelector('select');
      if (!want || !sel || sel.value === want) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === want) {
          sel.value = want;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          break;
        }
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('button[name="add"], [data-add-to-cart], .product-form__submit, .product-form__cart-submit, .add-to-cart')) {
      refillStampedSizes();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && (
      (f.matches && (f.matches('form[action*="/cart/add"]') || f.matches('[data-cart-form]'))) ||
      (f.closest && f.closest('.product-form'))
    )) {
      refillStampedSizes();
    }
  }, true);
})();

/* ──────────────────────────────────────────────────────────────
 * Add to Cart — silent SIZE requirement + clear "what's missing" error
 * ──────────────────────────────────────────────────────────────
 * DPO's size requirement was removed (three separate required Size Type
 * checkboxes can't all be satisfied when only one type is pickable). So we
 * enforce it ourselves: on a size-bearing product, block Add to Cart until a
 * size type + size is chosen, and show a plain banner by the Add button naming
 * what's still needed (scrolls to it). After a passing add we also surface any
 * OTHER field DPO still flags, so the shopper isn't left guessing. Detail is
 * logged + stashed in localStorage['efxLastAddFail']
 * (read: JSON.parse(localStorage.efxLastAddFail)).
 * ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var ROOT_ID = 'itoris_dynamicproductoptions';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function cleanLabel(f) {
    var l = f.querySelector('label');
    if (!l) return '';
    var c = l.cloneNode(true);
    c.querySelectorAll('a, em, span, input, sup, sub').forEach(function (n) { n.remove(); });
    return (c.textContent || '').replace(/\s+/g, ' ').replace(/[:*\s]+$/, '').trim();
  }

  // Collect the fields DPO flagged, deduped by field, with human labels + detail.
  function collect() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return { names: [], detail: [] };
    var seen = {}, names = [], detail = [];
    [].forEach.call(root.querySelectorAll('.dpo-error, .validation-advice, .validation-failed'), function (e) {
      var f = e.closest('[id^="dynamic_option_id_"]');
      if (!f || seen[f.id]) return;
      seen[f.id] = 1;
      var name = cleanLabel(f);
      if (name) names.push(name);
      var inp = f.querySelector('input:not([type=radio]):not([type=checkbox]), select');
      detail.push({
        field: f.id, label: name,
        value: inp ? (inp.value || '') : '(radio/checkbox)',
        ihidden: f.classList.contains('ihidden'),
        stamp: f.getAttribute('data-efx-size'),
        err: (e.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
      });
    });
    return { names: names, detail: detail };
  }

  function bannerEl(form) {
    var b = document.getElementById('efx-add-error');
    if (b) return b;
    b = document.createElement('div');
    b.id = 'efx-add-error';
    b.className = 'efx-add-error';
    b.setAttribute('role', 'alert');
    b.setAttribute('aria-live', 'assertive');
    b.hidden = true;
    var anchor = form && form.querySelector(
      'button[name="add"], [data-add-to-cart], .product-form__submit, .product-form__cart-submit'
    );
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(b, anchor);
    else if (form) form.appendChild(b);
    else document.body.appendChild(b);
    return b;
  }

  function showBanner(names, form, detail, trigger) {
    var b = bannerEl(form);
    if (!names.length) { if (b) b.hidden = true; return; }
    b.innerHTML =
      '<span class="efx-add-error__title">Please complete before adding to cart</span>' +
      '<span class="efx-add-error__items">' +
        names.map(function (n) { return '<span class="efx-add-error__item">' + esc(n) + '</span>'; }).join('') +
      '</span>' +
      '<span class="efx-add-error__hint">The option(s) above still need a selection.</span>';
    b.hidden = false;
    try { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
    try {
      console.log('%c[EFX] Add to Cart BLOCKED by:', 'color:#c00;font-weight:bold', detail || names);
      localStorage.setItem('efxLastAddFail', JSON.stringify({
        at: new Date().toISOString(), trigger: trigger || 'click', url: location.pathname, fields: detail || names
      }));
    } catch (e2) { /* noop */ }
  }

  // OUR silent size requirement — DPO no longer enforces it (Randy removed it to
  // avoid the three-required-checkboxes conflict). On a size-bearing product,
  // require that a size type is chosen AND its size dropdown has a value.
  // Returns [] when satisfied (or when the product has no size options at all).
  function missingSize() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return [];
    var sizeFields = [].slice.call(root.querySelectorAll('[id^="dynamic_option_id_"]')).filter(function (f) {
      var lbl = cleanLabel(f);
      return /\bsizes?\b/i.test(lbl) && !/size\s*type/i.test(lbl) && f.querySelector('select');
    });
    if (!sizeFields.length) return []; // no size options on this product — nothing to enforce
    // The active (shown) size dropdown is the one DPO hasn't marked .ihidden for
    // the unselected types. No active one → no size type chosen yet.
    var active = sizeFields.filter(function (f) { return !f.classList.contains('ihidden'); });
    if (!active.length) return ['Size'];
    var ok = active.some(function (f) { var s = f.querySelector('select'); return s && s.value; });
    return ok ? [] : ['Size'];
  }

  // Shared with the Team Order builder (efx-team-order.js), which validates each
  // jersey by replaying it into this same customizer: DPO no longer marks sizes
  // required, so its validateForm() would pass a sizeless row. The builder calls
  // this per row so the size is enforced for EVERY item, not just single adds.
  window.efxMissingSize = missingSize;

  // After a passing add, surface any OTHER fields DPO still flags (e.g. a logo
  // or name that DPO requires) so the shopper isn't left guessing.
  function captureDpoErrors(trigger, form) {
    var r = collect();
    var b = document.getElementById('efx-add-error');
    if (!r.names.length) { if (b) b.hidden = true; return; }
    showBanner(r.names, form, r.detail, trigger);
  }

  function onAdd(e, form, trigger) {
    var miss = missingSize();
    if (miss.length) {
      // Block the add before DPO / the native form handles it, and explain why.
      e.preventDefault();
      e.stopImmediatePropagation();
      showBanner(miss, form, [{ field: '(efx-size)', label: 'Size', value: '', note: 'no size selected' }], trigger);
      return;
    }
    setTimeout(function () { captureDpoErrors(trigger, form); }, 450);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(
      'button[name="add"], [data-add-to-cart], .product-form__submit, .product-form__cart-submit, .add-to-cart'
    );
    if (!btn) return;
    onAdd(e, btn.closest('form, .product-form'), 'click');
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.closest && f.closest('.product-form, [data-cart-form]')) {
      onAdd(e, f, 'submit');
    }
  }, true);

  // Clear the banner once the shopper fixes things.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#' + ROOT_ID)) {
      var b = document.getElementById('efx-add-error');
      if (b && !b.hidden && !collect().names.length && !missingSize().length) b.hidden = true;
    }
  }, true);
})();
